<template>
     
    <div class="block-layout questionnaire" id="scrollableques" :class="{'padt20':!checkCurrentUrl}">
        <div class="vx-col w-full wizard-container form_section  questionnairesection pad0 case-form-v2">
            <div class="questionnaire_page" id="questionnaire_page" v-if="petition && questionnaireDetails!=null">
                <div class="questionnaire_sec">

                    <div class="questionnaire_titles" v-if="petition && questionnaireDetails!=null">
                        <div class="questionnaire_titles_info">
                            <h2  v-if="getCaseName" v-html="getCaseName">
                               
                            </h2>
                            <h2 v-else>
                                Questionnaire for {{petition.typeDetails.name}}
                                <small v-if="petition.subTypeDetails">{{petition.subTypeDetails.name}}</small>
                               
    
                            </h2>
                            <p>
                                Please take a few moments to complete this short registration form
                                
                            </p>
                            <ul>
                                <template v-for="(item,index) in tabslist">
                                    <li :key="index" :class="{'active':currentTab==item.key || (index<=checkActiveTab && currentTab!=item.key)} " @click="setActiveTab(item.key,true)">
                                        <span>{{index+1}}</span><a>{{item.name}}</a>
                                    </li>
                                    
                                </template>  
                            </ul>
                            <ul v-if="checkProperty(petition, 'completedActivities') && checkProperty(petition, 'completedActivities', 'length')>0 && 
                                checkProperty(petition, 'completedActivities').indexOf('SUBMIT_BY_SPONSOR')>-1">
                                <vs-button
                                color="primary" type="border" class="primary_btn delete_btn light-blue-btn assign_bulk_btn"
                                    @click="reloadthePage(true)">Go to fill Beneficiary Questionnaire
                                </vs-button>  

                            </ul>
                        </div>
                        
                        <figure><img src="@/assets/images/main/content-bottom-image.svg" /></figure>
                    </div>
                    <div class="questionnaire_form">
                        <vs-col class="w-full p-0" v-if="beneFiciaryDeytailsExists == false">
                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                        Note: You can enter certain beneficiary information which is different from the profile information or new information in the case application.
                                        However, you can decide at the time of application submission if you want those change information to be updated in the beneficiary profile.
                                    </vs-alert>
                                </vs-col>
    
                        <div v-if="currentTab=='casedetails'" id="case_details_dt">
                            <form data-vv-scope="casedetailsform" @submit.prevent="" @keydown.enter.prevent="">
                                <vs-col class="w-full p-0">
                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                        NOTE: This questionnaire should be filled out completely and
                                        accurately. Kindly read the instructions carefully.
                                    </vs-alert>
    
                                </vs-col>
    
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container pt-10 form-container-questionnaire">
                                        <div class="vx-row">
                                            <genderField :required="true" :display="false" formScope="casedetailsform" :fieldsArray="questionnaireDetails" :gender="petition.sponsorInfo.gender" v-model="petition.sponsorInfo.gender" :tplsection="'sponsorInfo'" :tplkey="'gender'" :fieldName="'gender'" />
                                            <div class="divider full-divider mb-10"></div>
                                            <div class="vx-col w-full">
                                                <vx-input-group class="form-input-group FML">
                                                    <immiInput :display="false" :fieldsArray="questionnaireDetails" cid="benf" formscope="casedetailsform" v-model="petition.sponsorInfo.firstName" :tplsection="'sponsorInfo'" :tplkey="'firstName'"  :required="true" :fieldName="'firstName'" label="First Name" placeHolder="First Name" />
                                                    <immiInput :display="false" :fieldsArray="questionnaireDetails" cid="benm" formscope="casedetailsform" v-model="petition.sponsorInfo.middleName" :tplsection="'sponsorInfo'"  :tplkey="'middleName'" :required="false" :fieldName="'middleName'" label="Middle Name" placeHolder="Middle Name" />
                                                    <immiInput :display="false" :allowUpperCase="petition.tenantDetails && checkProperty(petition,'tenantDetails','slug') &&  checkProperty(petition,'tenantDetails','slug') == 'slg'" :fieldsArray="questionnaireDetails" cid="benl" formscope="casedetailsform" v-model="petition.sponsorInfo.lastName" :tplsection="'sponsorInfo'" :tplkey="'lastName'"  :required="true" :fieldName="'lastName'" label="Last Name" placeHolder="Last Name" />
                                                </vx-input-group>
                                            </div>

                                            <div class="vx-col w-full mb-5 yesno-v2" v-if="canRenderField('otherNames',questionnaireDetails, false, 'sponsorInfo' )">
                                                <div class="d-block align-center">
                                                    <a class="switch-label">
                                                        Have you ever used any other names previously?
                                                    </a><em v-if="checkFieldIsRequired({'key':'otherNames','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" >*</em>
                                                    <ul class="custom-radio custom-radio_v2">
                                                        <li>
                                                            <vs-radio ref="yes" v-model="petition.sponsorInfo.hasOtherNames" vs-name="sponsorInfo.hasOtherNames" :vs-value="true"  @input="resetOtherNames(petition.sponsorInfo.hasOtherNames)">Yes</vs-radio>
                                                        </li>
                                                        <li>
                                                            <vs-radio ref="no" v-model="petition.sponsorInfo.hasOtherNames" vs-name="sponsorInfo.hasOtherNames" :vs-value="false"  @input="resetOtherNames(petition.sponsorInfo.hasOtherNames)" >No</vs-radio>
                                                        </li> 
                                                    </ul>
                                                    <div class="form_group" v-if="checkFieldIsRequired({'key':'otherNames','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })">
                                                        <input type="hidden" :name="'otherNames_sponsorInfo'" v-validate="'required'"  data-vv-as="Field"  v-model="petition.sponsorInfo.hasOtherNames">
                                                        <span v-show="errors.has( 'casedetailsform.otherNames_sponsorInfo')" class="text-danger text-sm" style="">*Field is required</span>
                                                    </div>
                                                </div>
                                                <span class="inline_note pt-4">(NOTE: Please enter the name if you have a different name in the educational document other than passport.)</span>
                                            </div>
                                            <template v-if="petition.sponsorInfo && petition.sponsorInfo.hasOtherNames && canRenderField('otherNames',questionnaireDetails, false, 'sponsorInfo' )">
                                               <div class="vx-col w-full" v-for="(item, ind) in petition.sponsorInfo['otherNames']" :key="ind">
                                                    <vx-input-group class="form-input-group delete-rows-cst FML">
                                                        <immiInput formscope="casedetailsform" :cid="'benf'+ind" v-model="item.firstName" :display="false" :tplkey="''" :tplsection="'sponsorInfo.otherNames'"   :required="false" :fieldName="'firstName'" label="First Name" placeHolder="First Name" />
                                                        <immiInput formscope="casedetailsform" :cid="'benm'+ind" v-model="item.middleName" :display="false" :tplkey="''" :tplsection="'sponsorInfo.otherNames'"   :required="false" :fieldName="'middleName'" label="Middle Name" placeHolder="Middle Name" />
                                                        <immiInput formscope="casedetailsform" :allowUpperCase="petition.tenantDetails && checkProperty(petition,'tenantDetails','slug') &&  checkProperty(petition,'tenantDetails','slug') == 'slg'" :cid="'benl'+ind" v-model="item.lastName" :display="false" :tplkey="''" :tplsection="'sponsorInfo.otherNames'"  :required="false" :fieldName="'lastName'" label="Last Name" placeHolder="Last Name" />
                                                        <div class="delete" v-if="ind > 0" @click="removeOtherName(ind)">
                                                            <a>
                                                                <img src="@/assets/images/main/delete-row-img.svg">
                                                            </a>
                                                        </div>
                                                    </vx-input-group>
                                                    <a class="add-more add-more-names ml-0 mt-0" v-if="petition.sponsorInfo['otherNames'].length - 1 ==ind" @click="addOtherNames()"><span>+</span>Add</a>
                                                </div>
                                            </template>
                                            
                                            <immiInput :wrapclass="''" :fieldsArray="questionnaireDetails" :display="false" :tplkey="'email'" datatype="email" cid="benfemail" formscope="casedetailsform" v-model="petition.sponsorInfo.email" :required="true" :tplsection="'sponsorInfo'"  :fieldName="'email'"  label="Email" placeHolder="Email" />
                                            <immiPhone :fieldsArray="questionnaireDetails" :display="false" :tplkey="'cellPhoneNumber'" @updatephoneCountryCode="updatecellPhoneCountryCode" :countrycode="petition.sponsorInfo.cellPhoneCountryCode.countryCode" cid="bencellPhoneNumber" formscope="casedetailsform" v-model="petition.sponsorInfo.cellPhoneNumber" :tplsection="'sponsorInfo'"  :fieldName="'cellPhoneNumber'" :required="true" label="Phone Number" placeHolder="Phone Number" />
                                            <!-- :dateEnableTo="startEligibleDate"  -->
                                            <datepickerField :fieldsArray="questionnaireDetails" :display="false" :tplkey="'dateOfBirth'" :dateEnableTo="new Date()" :validationRequired="true" v-model="petition.sponsorInfo.dateOfBirth" formscope="casedetailsform" :fieldName="'dateOfBirth'" label="Date of Birth" :tplsection="'sponsorInfo'" />
                                            <selectField :fieldsArray="questionnaireDetails" :display="false" :tplkey="'countryOfBirth'" @input="changeBfProvince" :required="true" :optionslist="countries" v-model="petition.sponsorInfo.countryOfBirthDetails" formscope="casedetailsform" :fieldName="'countryOfBirth'" label="Country of Birth" placeHolder="Country of Birth" :tplsection="'sponsorInfo'" />
                                            <selectField :fieldsArray="questionnaireDetails" :display="false" :tplkey="'provinceOfBirth'" @input="petition.sponsorInfo.provinceOfBirth = petition.sponsorInfo.provinceOfBirthDetails.id" :required="true" :optionslist="bfeprovinceStates" v-model="petition.sponsorInfo.provinceOfBirthDetails" formscope="casedetailsform" :tplsection="'sponsorInfo'"  :fieldName="'provinceOfBirth'" label="Province of Birth" placeHolder="Province of Birth" />
                                            <immiInput :fieldsArray="questionnaireDetails" :display="false" :tplkey="'locationOfBirth'" cid="benflocationOfBirth" formscope="casedetailsform" v-model="petition.sponsorInfo.locationOfBirth" :required="true"  :fieldName="'locationOfBirth'" label="Location of Birth" placeHolder="Location of Birth" :tplsection="'sponsorInfo'" />
                                            <selectField :fieldsArray="questionnaireDetails" :display="false" :tplkey="'maritalStatus'" @input="petition.sponsorInfo.maritalStatus = petition.sponsorInfo.maritalStatusDetails.id;updateTablist()" :required="true" v-if="marital_statuses.length > 0" :optionslist="marital_statuses" v-model="petition.sponsorInfo.maritalStatusDetails" formscope="casedetailsform" :tplsection="'sponsorInfo'" :fieldName="'maritalStatus'" label="Marital Status" placeHolder="Marital Status" />
                                                 <!----485 Start    &&-->
                                            <template v-if="checkProperty(petition ,'sponsorInfo','maritalStatus') && checkProperty(petition ,'sponsorInfo','maritalStatus')!=1 "  >   
                                                <datepickerField  :display="false" :fieldsArray="questionnaireDetails" :tplkey="'dateOfMarriage'"  :validationRequired="true" v-model="petition.sponsorInfo.dateOfMarriage" formscope="casedetailsform" :dateEnableTo="new Date()"  :tplsection="'sponsorInfo'"  :fieldName="'dateOfMarriage'"  label="Date of Marriage" />
                                                <selectField   :display="false" :fieldsArray="questionnaireDetails" :tplkey="'countryOfMarriage'"   @input="changeCountryMarriage" :required="true" :optionslist="countries" v-model="petition.sponsorInfo.countryOfMarriageDetails" formscope="casedetailsform"  :tplsection="'sponsorInfo'"  :fieldName="'countryOfMarriage'"  label="Country of Marriage" placeHolder="Country of Marriage" />
                                                <selectField  :display="false" :fieldsArray="questionnaireDetails" :tplkey="'provinceOfMarriage'"  @input="petition.sponsorInfo.provinceOfMarriage = petition.sponsorInfo.provinceOfMarriageDetails.id" :required="true" :optionslist="statesOfMarriage" v-model="petition.sponsorInfo.provinceOfMarriageDetails" formscope="casedetailsform"  :tplsection="'sponsorInfo'"  :fieldName="'provinceOfMarriage'"  label="Province of Marriage" placeHolder="Province of Marriage" />
                                                <immiInput   :display="false" :fieldsArray="questionnaireDetails" :tplkey="'locationOfMarriage'"  cid="locationOfMarriage" formscope="casedetailsform" v-model="petition.sponsorInfo.locationOfMarriage" :required="true"  :tplsection="'sponsorInfo'"  :fieldName="'locationOfMarriage'"  label="Location of Marriage" placeHolder="Location of Marriage" />
                                            </template>  
                                                
                                                <immiyesorno  :required="checkFieldIsRequired({'key':'nameDiffFromBirthCert','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })"  wrapclass=" "    :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="nameDiffFromBirthCert" :tplkey="'nameDiffFromBirthCert'"   v-model="petition.sponsorInfo.nameDiffFromBirthCert" :tplsection="'sponsorInfo'"  :fieldName="'nameDiffFromBirthCert'"   label="If your name is different from that stated on your birth certificate, have you had it legally changes?"></immiyesorno>
                                                <immiyesorno :required="checkFieldIsRequired({'key':'birthCertHaveNamePobDob','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass="yesno-v2_wrap" :tplkey="'birthCertHaveNamePobDob'"   :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="birthCertHaveNamePobDob"  v-model="petition.sponsorInfo.birthCertHaveNamePobDob" :tplsection="'sponsorInfo'"  :fieldName="'birthCertHaveNamePobDob'"  label="Does the birth certificate have your name, place of birth, date of birth, parent's names mentioned, and the birth was registered around the time you were born?"></immiyesorno>
                                                <immiyesorno v-if="checkProperty(petition, 'sponsorInfo', 'birthCertHaveNamePobDob') == false" :required="checkFieldIsRequired({'key':'have2AffidavitsOfBirthFamily','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass=" " :tplkey="'have2AffidavitsOfBirthFamily'"   :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="have2AffidavitsOfBirthFamily"  v-model="petition.sponsorInfo.have2AffidavitsOfBirthFamily"  :tplsection="'sponsorInfo'"  :fieldName="'have2AffidavitsOfBirthFamily'" label="Do you have Two (2) Affidavits of Birth from family members?"></immiyesorno>                                                                                                                                                   
                                                
                                                                                 
                                                <immiInput :allowFloatingPoint="false" :maxLength="3" :onlyNumbers="true" :display="false" :fieldsArray="questionnaireDetails" :tplkey="'weight'"  cid="weight" formscope="casedetailsform" v-model="petition.sponsorInfo.weight" :tplsection="'sponsorInfo'"  :fieldName="'weight'"  :required="true"  label="Weight (LBS)" placeHolder="Weight" />
                                                
                                                <selectField :display="false" :closeOnSelect="false" :multiple="true" :fieldsArray="questionnaireDetails"  :required="true"  :tplkey="'race'"  cid="race" :optionslist="races_list" v-model="petition.sponsorInfo.race" :tplsection="'sponsorInfo'"  :fieldName="'race'"  formscope="casedetailsform"  label="Ethnicity/Race" placeHolder="Ethnicity/Race" />
                                                <selectField :display="false" :fieldsArray="questionnaireDetails"  :required="true"  :tplkey="'hairColor'" cid="hairColor" :optionslist="hair_colorsList" v-model="petition.sponsorInfo.hairColor" :tplsection="'sponsorInfo'"  :fieldName="'hairColor'"  formscope="casedetailsform"  label="Hair Color" placeHolder="Hair Color" />
                                                <div class="vx-col  w-full md:w-1/2" v-if="canRenderField('inches',questionnaireDetails, false, 'sponsorInfo.height' ) || canRenderField('feet',questionnaireDetails, false, 'sponsorInfo.height' )">
                                                    <div class="form_group">
                                                        <label class="form_label">Height</label>
                                                        <div class="height_field">
                                                            <selectField :display="false" :fieldsArray="questionnaireDetails"  :required="true"  :tplkey="'feet'" cid="feet" :optionslist="feetList" v-model="petition.sponsorInfo.height.feet"  :tplsection="'sponsorInfo.height'"  :fieldName="'feet'" :listContainsId="false" formscope="casedetailsform"  label="" placeHolder="Feet" />
                                                            <selectField :display="false" :fieldsArray="questionnaireDetails"  :required="true"  :tplkey="'inches'" cid="inches" :optionslist="inchesList" v-model="petition.sponsorInfo.height.inches" :tplsection="'sponsorInfo.height'"  :fieldName="'inches'" :listContainsId="false"  formscope="casedetailsform"  label="" placeHolder="Inches" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <selectField :display="false" :fieldsArray="questionnaireDetails"  :required="true" :optionslist="eye_colorList" v-model="petition.sponsorInfo.eyeColor" :tplsection="'sponsorInfo'"  :fieldName="'eyeColor'" :tplkey="'eyeColor'"  formscope="casedetailsform"  label="Eye Color" placeHolder="Eye Color" />
                                                <selectField :display="false" :fieldsArray="questionnaireDetails"  :required="true" :optionslist="countriesWithoutUS"  @input="petition.sponsorInfo.countryOfCitizenship = petition.sponsorInfo.countryOfCitizenshipDetails.id" v-model="petition.sponsorInfo.countryOfCitizenshipDetails" :tplsection="'sponsorInfo'"  :tplkey="'countryOfCitizenship'" :fieldName="'countryOfCitizenship'"  formscope="casedetailsform"  label="Country of Citizenship" placeHolder="Country of Citizenship" />
                                                <datepickerField  :display="false" :fieldsArray="questionnaireDetails" :tplkey="'dateFromUSCitizen'"  :validationRequired="true" v-model="petition.sponsorInfo.dateFromUSCitizen" formscope="casedetailsform" :dateEnableTo="new Date()"  :tplsection="'sponsorInfo'"  :fieldName="'dateFromUSCitizen'"  label="Date from which you have resided in the USA" />
                                        
                                            <div class="vx-col w-full">

                                                <div v-if="canRenderField('address',questionnaireDetails, false, 'sponsorInfo' ) && countries.length>0">
                                                    <h3 class="small-header">Current Address</h3>
                                                    <addressField 
                                                    :prefiilAddress="prefillCountryInQuestionnaire == false||([10,8].indexOf(checkProperty(petition,'subTypeDetails','id'))>-1 && checkProperty(petition,'typeDetails','id')==1 )?false:true" 
                                                    :fieldsArray="questionnaireDetails" :disableCountry="petition.sponsorInfo.currentlyInUS" formscope="casedetailsform" :showaptType="true" :addFormContainerCls="false" :validationRequired="checkFieldIsRequired({'key':'address','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :countries="countries" v-model="petition.sponsorInfo.address" :tplsection="'sponsorInfo'"  :fieldName="'address'"  :cid="'sponsorInfoaddress'" />
    
                                                </div>
                                                <div v-if="(canRenderField('mailingAddressIsSameAsAddress',questionnaireDetails, false, 'sponsorInfo' ) && canRenderField('currentAddress',questionnaireDetails, false, 'sponsorInfo' ) )" >
                                                    <div class="vx-col w-full d-flex">
                                                        <h3 class="small-header">Mailing Address</h3>
                                                            <vs-checkbox @change="setSameaddress()"  v-model="petition.sponsorInfo.mailingAddressIsSameAsAddress" :tplsection="'sponsorInfo'"  :fieldName="'mailingAddressIsSameAsAddress'" 
                                                            style="margin-left: 15px; margin-bottom:12px;">Same as Current Address </vs-checkbox>
                                                    </div>
                                                    <template v-if=" countries.length>0">
                                                    <addressField :ref="'mailingAddresscomponent'"  :prefiilAddress="prefillCountryInQuestionnaire == false?false:true"  :display="true" :fieldsArray="questionnaireDetails" :disableCountry="checkProperty(petition,'sponsorInfo','currentAddress') && checkProperty(petition['sponsorInfo'],'currentAddress','countryDetails')
                                                     && checkProperty(petition['sponsorInfo'],'currentAddress','countryId') && petition.sponsorInfo.mailingAddressIsSameAsAddress"
                                                     formscope="casedetailsform" :showaptType="true" :addFormContainerCls="false" :validationRequired="checkFieldIsRequired({'key':'currentAddress','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :countries="countries" v-model="petition.sponsorInfo.currentAddress" :tplsection="'sponsorInfo'"  :fieldName="'currentAddress'"  :cid="'beneficiarymailInfoaddress'" />
                                                    </template>
                                                </div>
                                            </div>
                                            <template v-if="canRenderField('addressOfLastNYears',questionnaireDetails, false, 'sponsorInfo.addressOfLastNYears') || canRenderField('addressOutsideUSMoreThanYear',questionnaireDetails, false, 'sponsorInfo.addressOutsideUSMoreThanYear') ">
                                                <div class="vx-col w-full" v-if="canRenderField('addressOfLastNYears',questionnaireDetails, false, 'sponsorInfo.addressOfLastNYears' ) &&  checkProperty(petition.sponsorInfo,'addressOfLastNYears') && checkProperty(petition.sponsorInfo,'addressOfLastNYears' ,'length')>0">                                      
                                                    <template v-if="canRenderField('addressOfLastNYears',questionnaireDetails, false, 'sponsorInfo.addressOfLastNYears' ) &&  checkProperty(petition.sponsorInfo,'addressOfLastNYears') && checkProperty(petition.sponsorInfo,'addressOfLastNYears' ,'length')>0">
                                                        <h3 class="small-header" style="margin-bottom:0 !important;padding-bottom:0 !important">Your Residence starting with most current for the Past Five Years in the U.S and Abroad </h3>
                                                        <div class="I-485-wrapper">
                                                            <div class="vx-row delete-row I-485-bg" v-for="(lyearItem, index) in petition.sponsorInfo['addressOfLastNYears']" :key="index">
                                                            <addressField :fieldsArray="questionnaireDetails" :disableCountry="false" formscope="casedetailsform" :showaptType="true" :addFormContainerCls="false" :validationRequired="checkFieldIsRequired({'key':'addressOfLastNYears','section':'sponsorInfo.addressOfLastNYears', 'fieldsArray':questionnaireDetails, 'required':true })" :countries="countries" v-model="petition.sponsorInfo['addressOfLastNYears'][index]" :tplsection="'sponsorInfo.addressOfLastNYears'"  :fieldName="'addressOfLastNYears'+index"  :cid="'addressOfLastNYears'+index" />
                                                            <div class="w-full">
                                                                <div class="vx-row">
                                                                    <datepickerField  @input="clearStartandEnddate($event,'addressOfLastNYears',index,'start')" :display="false" :fieldsArray="questionnaireDetails" :tplkey="'startDate'"  :validationRequired="true" v-model="lyearItem.startDate" formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'sponsorInfo.addressOfLastNYears'"  :fieldName="'residenceStartDate'+index" :cid="'residenceStartDate'+index"  label="Start Date" />
                                                                    <datepickerField @input="clearStartandEnddate($event,'addressOfLastNYears',index,'end')"   :display="false" :fieldsArray="questionnaireDetails" :tplkey="'endDate'" :isDisabled="!lyearItem.startDate"  :validationRequired="true" v-model="lyearItem.endDate" :dateEnableFrom="lyearItem.startDate" formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'sponsorInfo.addressOfLastNYears'" :cid="'residenceEndDate'+index"  :fieldName="'residenceEndDate'+index"  label="End Date" />
                                                                </div>
                                                            </div>
                                                                <div class="delete" v-if="petition.sponsorInfo['addressOfLastNYears'].length > 1">
                                                                    <a @click="removeNyears(index)">
                                                                    <img src="@/assets/images/main/delete-row-img-white.svg" />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                     <div class="m-auto" vs-type="flex" vs-align="center" vs-lg="2" vs-sm="2">
                                                         <a @click="addNyears()" class="add-more ml-0 mt-4" style="display:inline-block" type="filled">
                                                       <span>+</span> More</a>
                                                    </div>
                                           </div>
                                           <div class="vx-col w-full" v-if=" canRenderField('addressOutsideUSMoreThanYear',questionnaireDetails, false, 'sponsorInfo.addressOutsideUSMoreThanYear' ) && checkProperty(petition.sponsorInfo,'addressOutsideUSMoreThanYear') && checkProperty(petition.sponsorInfo,'addressOutsideUSMoreThanYear' ,'length')>0">
                                                <template v-if="canRenderField('addressOutsideUSMoreThanYear',questionnaireDetails, false, 'sponsorInfo.addressOutsideUSMoreThanYear' )  &&  checkProperty(petition.sponsorInfo,'addressOutsideUSMoreThanYear') && checkProperty(petition.sponsorInfo,'addressOutsideUSMoreThanYear','length')>0">
                                                    <h3 class="small-header" style="margin-top: 40px !important;
                                                            padding-bottom: 0 !important;"> Last Address outside Of the United States for more than one year</h3>
                                                    <div class="vx-row delete-row" v-for="(lastYearItem, ind) in petition.sponsorInfo['addressOutsideUSMoreThanYear']" :key="ind">
                                                        <addressField :hideusa="true" :wrapclass="'px-4'" :fieldsArray="questionnaireDetails"  formscope="casedetailsform" :showaptType="true" :addFormContainerCls="false" :validationRequired="checkFieldIsRequired({'key':'addressOutsideUSMoreThanYear','section':'sponsorInfo.addressOutsideUSMoreThanYear', 'fieldsArray':questionnaireDetails, 'required':true })" :countries="countries" v-model="petition.sponsorInfo['addressOutsideUSMoreThanYear'][ind]" :tplsection="'sponsorInfo.addressOutsideUSMoreThanYear'"  :fieldName="'addressOutsideUSMoreThanYear'+ind"  :cid="'addressOutsideUSMoreThanYear'+ind" />
                                                        <datepickerField   @input="clearStartandEnddate($event,'addressOutsideUSMoreThanYear',ind,'start')" :display="false" :fieldsArray="questionnaireDetails" :tplkey="'startDate'"  :validationRequired="true" v-model="lastYearItem.startDate" formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'sponsorInfo.addressOutsideUSMoreThanYear'"  :fieldName="'outSideStartDate'+ind" :cid="'outSideStartDate'+ind"  label="Start Date" />
                                                        <datepickerField @input="clearStartandEnddate($event,'addressOutsideUSMoreThanYear',ind,'end')" :display="false" :fieldsArray="questionnaireDetails" :tplkey="'endDate'" :isDisabled="!lastYearItem.startDate"  :validationRequired="true" v-model="lastYearItem.endDate" :dateEnableFrom="lastYearItem.startDate"  formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'sponsorInfo.addressOutsideUSMoreThanYear'"  :fieldName="'outSideEndDate'+ind" :cid="'outSideStartDate'+ind" label="End Date" /> 
                                                        <div class="delete" v-if="petition.sponsorInfo['addressOutsideUSMoreThanYear'].length > 1">
                                                                <a @click="removeLastYearItem(ind)">
                                                                <img src="@/assets/images/main/delete-row-img-white.svg" />
                                                                </a>
                                                            </div>
                                                    </div> 
                                                </template>
                                               
                                            </div> 
                                            </template>
                                            
                                            <immiMask :display="false" :tplkey="'SSN'" :fieldsArray="questionnaireDetails" :patren="['### - ## - ####']" datatype="min:9|max:9" :wrapclass="canRenderField('ben_alienNumber',questionnaireDetails)?'md:w-1/2':' '" cid="benfSSN" formscope="casedetailsform" v-model="petition.sponsorInfo.SSN" :tplsection="'sponsorInfo'"  :fieldName="'SSN'"  :required="false"  label="Social Security number (if applicable)" vvas="Social Security number" placeHolder="123 - 45 - 6789" />
                                            <immiInput :display="false" :tplkey="'alienNumber'" :fieldsArray="questionnaireDetails" datatype="alpha_num|max:9" cid="benfalienNumber_alienNumber" formscope="casedetailsform" v-model="petition.sponsorInfo.alienNumber" :tplsection="'sponsorInfo'"  :fieldName="'alienNumber'"   label="Your Alien Number (if applicable)" placeHolder="Alien Number " />
                                            <template>
                                                <immiyesorno formscope="casedetailsform" :cid="'filedOnAnyOtherPerOrPetitioner'" :required="checkFieldIsRequired({'key':'filedOnAnyOtherPerOrPetitioner','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :tplkey="'filedOnAnyOtherPerOrPetitioner'"  :fieldsArray="questionnaireDetails" v-model="petition.sponsorInfo.filedOnAnyOtherPerOrPetitioner" :tplsection="'sponsorInfo'"  :fieldName="'filedOnAnyOtherPerOrPetitioner'" :wrapclass="'yesno-v2'"   label="Have you ever filed a petition for this beneficiary or any other person"></immiyesorno>
                                                <immiInput v-if="checkProperty(petition, 'sponsorInfo' , 'filedOnAnyOtherPerOrPetitioner')" :fieldsArray="questionnaireDetails" :display="false" :tplkey="'filedName'" cid="filedName" formscope="casedetailsform" v-model="petition.sponsorInfo.filedName" :required="true"  :fieldName="'filedName'" label="Name" placeHolder="Name" :tplsection="'sponsorInfo'" />
                                                <immiInput v-if="checkProperty(petition, 'sponsorInfo' , 'filedOnAnyOtherPerOrPetitioner')" :fieldsArray="questionnaireDetails" :display="false" :tplkey="'filedPlace'" cid="filedPlace" formscope="casedetailsform" v-model="petition.sponsorInfo.filedPlace" :required="true"  :fieldName="'filedPlace'" label="Place" placeHolder="Place" :tplsection="'sponsorInfo'" />
                                                <datepickerField v-if="checkProperty(petition, 'sponsorInfo' , 'filedOnAnyOtherPerOrPetitioner')" :display="false" :fieldsArray="questionnaireDetails" :tplkey="'fileDateOfFiling'"  :validationRequired="true" v-model="petition.sponsorInfo.fileDateOfFiling" formscope="casedetailsform" :dateEnableTo="new Date()"  :tplsection="'sponsorInfo'"  :fieldName="'fileDateOfFiling'"  label="Date of Filing" />
                                                <selectField :listContainsId="false" v-if="checkProperty(petition, 'sponsorInfo' , 'filedOnAnyOtherPerOrPetitioner')" :display="false" :fieldsArray="questionnaireDetails"  :required="true" :optionslist="filledStatusList" v-model="petition.sponsorInfo.filedStatus" :tplsection="'sponsorInfo'"  :fieldName="'filedStatus'" :tplkey="'filedStatus'"  formscope="casedetailsform"  label="Filed Status" placeHolder="Filed Status" />
                                            </template>
                                            <template>
                                                <selectField :display="false" :fieldsArray="questionnaireDetails"  :required="true" :optionslist="fillingForList"
                                                 v-model="petition.sponsorInfo.filingThisPetitionerFor"   :listContainsId="false"
                                                 :tplsection="'sponsorInfo'"  :fieldName="'filingThisPetitionerFor'" :tplkey="'filingThisPetitionerFor'"  formscope="casedetailsform"  label="I’M filing this petition for" placeHolder="I’M filing this petition for" />
                                                 <!-- newly added keys starts -->
                                                 <div class="vx-col w-full mb-5 yesno-v2" v-if="canRenderField('fillThisPetiChildOrParentRelation',questionnaireDetails, false, 'sponsorInfo' ) && ['Mother','Father','Child'].indexOf(petition.sponsorInfo.filingThisPetitionerFor)>-1 ">
                                                    <div class="custom-radio_sec">
                                                        <a class="switch-label">
                                                            Select the box that describes your relationship with beneficiary
                                                        </a><em v-if="checkFieldIsRequired({'key':'fillThisPetiChildOrParentRelation','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" >*</em>
                                                        <ul class="custom-radio custom-radio_v2">
                                                            <li>
                                                                <vs-radio ref="Child_was_born" v-model="petition.sponsorInfo.fillThisPetiChildOrParentRelation" vs-name="Child_was_born" :vs-value="1"  >Child was born to parents who were married to each other at the time of the child's birth</vs-radio>
                                                            </li>
                                                            <li>
                                                                <vs-radio ref="_citizenshipNaturalization" v-model="petition.sponsorInfo.fillThisPetiChildOrParentRelation" vs-name="permanent_resident" :vs-value="2" >Stepchild/Stepparent</vs-radio>
                                                            </li> 
                                                            <li>
                                                                <vs-radio ref="_citizenshipNaturalization" v-model="petition.sponsorInfo.fillThisPetiChildOrParentRelation" vs-name="permanent_resident" :vs-value="3" >Child was born to parents who were not married to each other at the time of the child's birth </vs-radio>
                                                            </li> 
                                                            <li>
                                                                <vs-radio ref="_citizenshipNaturalization" v-model="petition.sponsorInfo.fillThisPetiChildOrParentRelation" vs-name="permanent_resident" :vs-value="4" >Child was adopted (not an Orphan or Hague Convention adoptee)</vs-radio>
                                                            </li> 
                                                        </ul>
                                                        <div class="form_group" v-if="checkFieldIsRequired({'key':'fillThisPetiChildOrParentRelation','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })">
                                                            <input type="hidden" :name="'otherNames_fillThisPetiChildOrParentRelation'" v-validate="'required'"  data-vv-as="Field"  v-model="petition.sponsorInfo.fillThisPetiChildOrParentRelation">
                                                            <span v-show="errors.has( 'casedetailsform.otherNames_fillThisPetiChildOrParentRelation')" class="text-danger text-sm" style="">*Field is required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <immiyesorno v-if="['Sibling'].indexOf(petition.sponsorInfo.filingThisPetitionerFor)>-1"  :required="checkFieldIsRequired({'key':'fillThisBroOrSisRelatedByAdoption','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass=" " 
                                                 :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="fillThisBroOrSisRelatedByAdoption"  v-model="petition.sponsorInfo.fillThisBroOrSisRelatedByAdoption" :tplkey="'fillThisBroOrSisRelatedByAdoption'" :tplsection="'sponsorInfo'"  :fieldName="'fillThisBroOrSisRelatedByAdoption'"   label="Are you related to your brother/sister by adoption?"></immiyesorno>
                                                 
                                                 <!-- newly added keys end -->
                                                 <div class="vx-col w-full mb-5 yesno-v2" v-if="canRenderField('haveUSCitizenOrPermResident',questionnaireDetails, false, 'sponsorInfo' ) && checkProperty(petition, 'sponsorInfo' , 'filingThisPetitionerFor')">
                                                    <div class="d-block align-center">
                                                        <a class="switch-label">
                                                            I am filing this petition as
                                                        </a><em v-if="checkFieldIsRequired({'key':'haveUSCitizenOrPermResident','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" >*</em>
                                                        <ul class="custom-radio custom-radio_v2">
                                                            <li>
                                                                <vs-radio @input="clearUsandPrFields('us_citizen')" ref="_citizenshipBirth" v-model="petition.sponsorInfo.haveUSCitizenOrPermResident" vs-name="us_citizen" :vs-value="'us_citizen'"  >US Citizen</vs-radio>
                                                            </li>
                                                            <li>
                                                                <vs-radio @input="clearUsandPrFields('permanent_resident')" ref="_citizenshipNaturalization" v-model="petition.sponsorInfo.haveUSCitizenOrPermResident" vs-name="permanent_resident" :vs-value="'permanent_resident'" >Lawful Permanent Resident</vs-radio>
                                                            </li> 
                                                        </ul>
                                                        <div class="form_group" v-if="checkFieldIsRequired({'key':'haveUSCitizenOrPermResident','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })">
                                                            <input type="hidden" :name="'otherNames_haveUSCitizenOrPermResident'" v-validate="'required'"  data-vv-as="Field"  v-model="petition.sponsorInfo.haveUSCitizenOrPermResident">
                                                            <span v-show="errors.has( 'casedetailsform.otherNames_haveUSCitizenOrPermResident')" class="text-danger text-sm" style="">*Field is required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                           
                                            </template>
                                            <template v-if="checkProperty(petition, 'sponsorInfo', 'haveUSCitizenOrPermResident') == 'us_citizen'">
                                                <!-- <immiyesorno @input="clearUsCitizenFields($event)" :required="checkFieldIsRequired({'key':'usCitizen','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass=" "  :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="usCitizen"  v-model="petition.sponsorInfo.usCitizen" :tplkey="'usCitizen'" :tplsection="'sponsorInfo'"  :fieldName="'usCitizen'"   label="If you are a U.S. Citizen?"></immiyesorno> -->
                                                <div class="vx-col w-full mb-5 yesno-v2" v-if="canRenderField('citizenshipAcquiredThrough',questionnaireDetails, false, 'sponsorInfo' ) && checkProperty(petition, 'sponsorInfo', 'haveUSCitizenOrPermResident') == 'us_citizen'">
                                                    <div class="d-block align-center">
                                                        <a class="switch-label">
                                                            Citizenship was acquired through
                                                        </a><em v-if="checkFieldIsRequired({'key':'citizenshipAcquiredThrough','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" >*</em>
                                                        <ul class="custom-radio custom-radio_v2">
                                                            <li>
                                                                <vs-radio ref="cit_izenshipBirth"   v-model="petition.sponsorInfo.citizenshipAcquiredThrough" :vs-name="'citizenshipBirth'" :vs-value="'citizenshipBirth'"  >Birth</vs-radio>
                                                            </li>
                                                            <li>
                                                                <vs-radio  ref="ci_tizenshipNaturalization"  v-model="petition.sponsorInfo.citizenshipAcquiredThrough" :vs-name="'citizenshipNaturalization'" :vs-value="'citizenshipNaturalization'" >Naturalization</vs-radio>
                                                            </li> 
                                                            <li>
                                                                <vs-radio ref="ci_tizenshipParents" v-model="petition.sponsorInfo.citizenshipAcquiredThrough" :vs-name="'citizenshipParents'" :vs-value="'citizenshipParents'" >Parents</vs-radio>
                                                            </li> 
                                                        </ul>
                                                        <div class="form_group" v-if="checkFieldIsRequired({'key':'citizenshipAcquiredThrough','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })">
                                                            <input type="hidden" :name="'otherNames_citizenshipAcquiredThrough'" v-validate="'required'"  data-vv-as="Field"  v-model="petition.sponsorInfo.citizenshipAcquiredThrough">
                                                            <span v-show="errors.has( 'casedetailsform.otherNames_citizenshipAcquiredThrough')" class="text-danger text-sm" style="">*Field is required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <immiInput v-if="checkProperty(petition, 'sponsorInfo', 'haveUSCitizenOrPermResident') == 'us_citizen'" :fieldsArray="questionnaireDetails" :display="false" :tplkey="'certOfCitizenNumber'" cid="certOfCitizenNumber" formscope="casedetailsform" v-model="petition.sponsorInfo.certOfCitizenNumber" :required="true"  :fieldName="'certOfCitizenNumber'" label="Certificate of Citizenship Number" placeHolder="Certificate of Citizenship Number" :tplsection="'sponsorInfo'" />
                                                <immiInput v-if="checkProperty(petition, 'sponsorInfo', 'haveUSCitizenOrPermResident') == 'us_citizen'" :fieldsArray="questionnaireDetails" :display="false" :tplkey="'placeOfIssuance'" cid="placeOfIssuance" formscope="casedetailsform" v-model="petition.sponsorInfo.placeOfIssuance" :required="true"  :fieldName="'placeOfIssuance'" label="Place of Issuance" placeHolder="Place of Issuance" :tplsection="'sponsorInfo'" />
                                                <datepickerField v-if="checkProperty(petition, 'sponsorInfo', 'haveUSCitizenOrPermResident') == 'us_citizen'" :display="false" :fieldsArray="questionnaireDetails" :tplkey="'dateOfIssuance'"  :validationRequired="true" v-model="petition.sponsorInfo.dateOfIssuance" formscope="casedetailsform" :dateEnableTo="new Date()"  :tplsection="'sponsorInfo'"  :fieldName="'dateOfIssuance'"  label="Date of Issuance" />
                                            </template>
                                            <template v-if="checkProperty(petition, 'sponsorInfo', 'haveUSCitizenOrPermResident') == 'permanent_resident'">
                                                <!-- <immiyesorno @input="clearPrResidentFields($event)" :required="checkFieldIsRequired({'key':'lawfulPerResident','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass=" "  :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="lawfulPerResident"  v-model="petition.sponsorInfo.lawfulPerResident" :tplkey="'lawfulPerResident'" :tplsection="'sponsorInfo'"  :fieldName="'lawfulPerResident'"   label="If you are a Lawful Permanent Resident"></immiyesorno> -->
                                                <div class="vx-col w-full mb-10 ownership_editor" v-if="canRenderField('lprRequired',questionnaireDetails,false ,'sponsorInfo') && checkProperty(petition, 'sponsorInfo', 'haveUSCitizenOrPermResident') == 'permanent_resident'">
                                                    <div class="form_group">
                                                        <label class="form_label">LPR was acquired through</label>
                                                        <ckeditor :fieldsArray="questionnaireDetails" :display="false" wrapclass=" " formscope="casedetailsform" v-model="petition.sponsorInfo.lprRequired" :tplsection="'sponsorInfo'" :tplkey="'lprRequired'" :fieldName="'ownershipInterestDesc'" :required="true"  label="Ownership Details" placeHolder="Ownership Details"  :editor="editor" :config="editorConfig"></ckeditor>
                                                    </div>
                                                </div>

                                                <datepickerField v-if="checkProperty(petition, 'sponsorInfo', 'haveUSCitizenOrPermResident') == 'permanent_resident'" :display="false" :fieldsArray="questionnaireDetails" :tplkey="'dateReceivedLPR'"  :validationRequired="true" v-model="petition.sponsorInfo.dateReceivedLPR" formscope="casedetailsform" :dateEnableTo="new Date()"  :tplsection="'sponsorInfo'"  :fieldName="'dateReceivedLPR'"  label="Date received LPR" />
                                                <immiyesorno v-if="checkProperty(petition, 'sponsorInfo', 'haveUSCitizenOrPermResident') == 'permanent_resident'" :required="checkFieldIsRequired({'key':'usCitizenOrLPR','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass=" "  :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="lawfulPerResident"  v-model="petition.sponsorInfo.usCitizenOrLPR" :tplkey="'usCitizenOrLPR'" :tplsection="'sponsorInfo'"  :fieldName="'usCitizenOrLPR'"   label="Did you gain LPR through marriage to a U.S. citizen or a LPR? "></immiyesorno>
                                                <!-- newly added keys starts -->
                                               
                                                <immiyesorno  :required="checkFieldIsRequired({'key':'gainLawPermResidentThroughAdoption','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass=" " 
                                                :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="gainLawPermResidentThroughAdoption"  v-model="petition.sponsorInfo.gainLawPermResidentThroughAdoption" :tplkey="'gainLawPermResidentThroughAdoption'" :tplsection="'sponsorInfo'"  :fieldName="'gainLawPermResidentThroughAdoption'"   label="Did you gain lawful permanent resident status or citizenship through adoption?"></immiyesorno>
                                                <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'classOfAdmission'" cid="classOfAdmission" formscope="casedetailsform" v-model="petition.sponsorInfo.lawFulPermanentResident.classOfAdmission" :required="true"  :fieldName="'classOfAdmission'" label="Class of Admission" placeHolder="Class of Admission" :tplsection="'sponsorInfo.lawFulPermanentResident'" />
                                                <datepickerField :display="false" :fieldsArray="questionnaireDetails" :tplkey="'dateOfAdmission'"  :validationRequired="true" v-model="petition.sponsorInfo.lawFulPermanentResident.dateOfAdmission" formscope="casedetailsform"   :tplsection="'sponsorInfo.lawFulPermanentResident'"  :fieldName="'dateOfAdmission'"  label="Date of Admission" />
                                                <selectField :display="false" :fieldsArray="questionnaireDetails"  :required="true" :optionslist="usastates"
                                                 v-model="petition.sponsorInfo.stateDetailsOfAdmission"  @input="petition.sponsorInfo.stateOfAdmission = petition.sponsorInfo.stateDetailsOfAdmission.id"
                                                 :tplsection="'sponsorInfo'"  :fieldName="'stateOfAdmission'" :tplkey="'stateOfAdmission'"  formscope="casedetailsform"  label="State of Admission" placeHolder="State of Admission" />
                                                 <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'cityOfAdmission'" cid="cityOfAdmission" formscope="casedetailsform" v-model="petition.sponsorInfo.cityOfAdmission" :required="true"  :fieldName="'cityOfAdmission'" label="City or Town of Admission" placeHolder="City or Town of Admission" :tplsection="'sponsorInfo'" />
                                               
                                                <!-- newly added keys end -->
                                            </template>
                                            <!-- newly added keys starts -->
                                            <div class="vx-col w-full mb-5 yesno-v2" v-if="canRenderField('anyOtherElseFiledPetitionForBnf',questionnaireDetails, false, 'sponsorInfo' )">
                                                <div class="d-block align-center">
                                                    <a class="switch-label">
                                                        Has anyone else ever filed a petition for the beneficiary?
                                                    </a><em v-if="checkFieldIsRequired({'key':'anyOtherElseFiledPetitionForBnf','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" >*</em>
                                                    <ul class="custom-radio custom-radio_v2">
                                                        <li>
                                                            <vs-radio ref="Yes_" v-model="petition.sponsorInfo.anyOtherElseFiledPetitionForBnf" vs-name="Yes" :vs-value="'Yes'"  >Yes</vs-radio>
                                                        </li>
                                                        <li>
                                                            <vs-radio ref="_No" v-model="petition.sponsorInfo.anyOtherElseFiledPetitionForBnf" vs-name="No" :vs-value="'No'" >No</vs-radio>
                                                        </li> 
                                                        <li>
                                                            <vs-radio ref="_Unknown" v-model="petition.sponsorInfo.anyOtherElseFiledPetitionForBnf" vs-name="Unknown" :vs-value="'Unknown'" >Unknown </vs-radio>
                                                        </li> 
                                                       
                                                    </ul>
                                                    <div class="form_group" v-if="checkFieldIsRequired({'key':'anyOtherElseFiledPetitionForBnf','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })">
                                                        <input type="hidden" :name="'otherNames_anyOtherElseFiledPetitionForBnf'" v-validate="'required'"  data-vv-as="Field"  v-model="petition.sponsorInfo.anyOtherElseFiledPetitionForBnf">
                                                        <span v-show="errors.has( 'casedetailsform.otherNames_anyOtherElseFiledPetitionForBnf')" class="text-danger text-sm" style="">*Field is required</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <immiyesorno  :required="checkFieldIsRequired({'key':'benfEverInImmigrationProceedings','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass=" "  :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="benfEverInImmigrationProceedings"  v-model="petition.sponsorInfo.benfEverInImmigrationProceedings" :tplkey="'benfEverInImmigrationProceedings'" :tplsection="'sponsorInfo'"  :fieldName="'benfEverInImmigrationProceedings'"   label="Was the beneficiary EVER in immigration proceedings?"></immiyesorno>
                                            <div class="vx-col w-full mb-5 yesno-v2" v-if="canRenderField('typeOfProceedings',questionnaireDetails, false, 'sponsorInfo' ) && checkProperty(petition, 'sponsorInfo', 'benfEverInImmigrationProceedings')">
                                                <div class="custom-radio_sec">
                                                    <a class="switch-label">
                                                        Select the type of proceedings and provide the location and date of the proceedings. 
                                                    </a><em v-if="checkFieldIsRequired({'key':'typeOfProceedings','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" >*</em>
                                                    <ul class="custom-radio custom-radio_v2">
                                                        <li>
                                                            <vs-radio ref="Yes_Yes" v-model="petition.sponsorInfo.typeOfProceedings" vs-name="Yes_Yes" :vs-value="1"  >Removal</vs-radio>
                                                        </li>
                                                        <li>
                                                            <vs-radio ref="No_No" v-model="petition.sponsorInfo.typeOfProceedings" vs-name="No_No" :vs-value="2" >Exclusion/Deportation</vs-radio>
                                                        </li> 
                                                        <li>
                                                            <vs-radio ref="Unknown_Unknown" v-model="petition.sponsorInfo.typeOfProceedings" vs-name="Unknown_Unknown" :vs-value="3" >Rescission</vs-radio>
                                                        </li> 
                                                        <li>
                                                            <vs-radio ref="Other_Unknown" v-model="petition.sponsorInfo.typeOfProceedings" vs-name="Other_Unknown" :vs-value="4" >Other Judicial Proceedings</vs-radio>
                                                        </li> 
                                                       
                                                    </ul>
                                                    <div class="form_group" v-if="checkFieldIsRequired({'key':'typeOfProceedings','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })">
                                                        <input type="hidden" :name="'otherNames_typeOfProceedings'" v-validate="'required'"  data-vv-as="Field"  v-model="petition.sponsorInfo.typeOfProceedings">
                                                        <span v-show="errors.has( 'casedetailsform.otherNames_typeOfProceedings')" class="text-danger text-sm" style="">*Field is required</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <template v-if="canRenderField('benfEverInImmigrationProceedings',questionnaireDetails, false, 'sponsorInfo' )  && checkProperty(petition, 'sponsorInfo', 'benfEverInImmigrationProceedings')">
                                                <datepickerField :display="false" :fieldsArray="questionnaireDetails" :tplkey="'dateOfProceedings'"  :validationRequired="true" v-model="petition.sponsorInfo.dateOfProceedings" formscope="casedetailsform"   :tplsection="'sponsorInfo'"  :fieldName="'dateOfProceedings'"  label="Date of proceedings" />
                                                <selectField :display="false" :fieldsArray="questionnaireDetails"  :required="true" :optionslist="usastates"
                                                 v-model="petition.sponsorInfo.stateDetailsOfProceedings" 
                                                 :tplsection="'sponsorInfo'"  :fieldName="'stateOfProceedings'" :tplkey="'stateOfProceedings'"  formscope="casedetailsform"  label="State of proceedings" placeHolder="State of proceedings" />
                                                 <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'cityOfProceedings'" cid="cityOfProceedings" formscope="casedetailsform" v-model="petition.sponsorInfo.cityOfProceedings" :required="true"  :fieldName="'cityOfProceedings'" label="City or Town of proceedings" placeHolder="City or Town of proceedings" :tplsection="'sponsorInfo'" />
                                               
                                            </template>
                                            <immiyesorno  :required="checkFieldIsRequired({'key':'hasSubmitSepPetiForOtherRelation','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass=" "  :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="hasSubmitSepPetiForOtherRelation" 
                                             v-model="petition.sponsorInfo.hasSubmitSepPetiForOtherRelation" :tplkey="'hasSubmitSepPetiForOtherRelation'" :tplsection="'sponsorInfo'"  :fieldName="'hasSubmitSepPetiForOtherRelation'"   label="Are you are also submitting separate petitions for other relatives?"></immiyesorno>
                                             <template v-if="checkProperty(petition, 'sponsorInfo', 'hasSubmitSepPetiForOtherRelation')">
                                                <div class="vx-col w-full" v-if="(canRenderField('familyName',questionnaireDetails, false, 'sponsorInfo.submitSupPetiForOtherRelative') || canRenderField('givenName',questionnaireDetails, false, 'sponsorInfo.submitSupPetiForOtherRelative')
                                                ||canRenderField('middleName',questionnaireDetails, false, 'sponsorInfo.submitSupPetiForOtherRelative') || canRenderField('relationShip',questionnaireDetails, false, 'sponsorInfo.submitSupPetiForOtherRelative')) 
                                                &&  checkProperty(petition.sponsorInfo,'submitSupPetiForOtherRelative') && checkProperty(petition.sponsorInfo,'submitSupPetiForOtherRelative' ,'length')>0">                                      
                                                    <div class="I-485-wrapper">
                                                        <div class="vx-row delete-row I-485-bg" v-for="(lyearItem, index) in petition.sponsorInfo['submitSupPetiForOtherRelative']" :key="index">
                                                        <div class="w-full">
                                                            <div class="vx-row">
                                                                <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'familyName'" :cid="'familyName'+index" formscope="casedetailsform" v-model="lyearItem.familyName" :required="true"  :fieldName="'familyName'" label="Family Name" placeHolder="Family Name" :tplsection="'sponsorInfo.submitSupPetiForOtherRelative'" />
                                                                <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'givenName'" :cid="'givenName'+index" formscope="casedetailsform" v-model="lyearItem.givenName" :required="true"  :fieldName="'givenName'" label="Given Name" placeHolder="Given Name" :tplsection="'sponsorInfo.submitSupPetiForOtherRelative'" />
                                                                <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'middleName'" :cid="'middleName'+index" formscope="casedetailsform" v-model="lyearItem.middleName" :required="true"  :fieldName="'middleName'" label="Middle Name" placeHolder="Middle Name" :tplsection="'sponsorInfo.submitSupPetiForOtherRelative'" />
                                                                <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'relationShip'" :cid="'relationShip'+index" formscope="casedetailsform" v-model="lyearItem.relationShip" :required="true"  :fieldName="'relationShip'" label="Relationship" placeHolder="Relationship" :tplsection="'sponsorInfo.submitSupPetiForOtherRelative'" />
                                                            </div>
                                                        </div>
                                                            <div class="delete" v-if="petition.sponsorInfo['submitSupPetiForOtherRelative'].length > 1">
                                                                <a @click="removesubmitPetit(index)">
                                                                <img src="@/assets/images/main/delete-row-img-white.svg" />
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="m-auto" vs-type="flex" vs-align="center" vs-lg="2" vs-sm="2">
                                                        <a @click="addSubmitPetit()" class="add-more ml-0 mt-4" style="display:inline-block" type="filled">
                                                        <span>+</span> More</a>
                                                    </div>
                                                </div>







                                        <template v-if="false">
                                            <!-- <immiyesorno  :required="checkFieldIsRequired({'key':'relative','section':'sponsorInfo.submitSupPetiForOtherRelative', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass=" "  :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="relative"  v-model="petition.sponsorInfo.submitSupPetiForOtherRelative.relative" :tplkey="'relative'" :tplsection="'sponsorInfo.submitSupPetiForOtherRelative'"  :fieldName="'relative'"   label="Relative"></immiyesorno> -->
                                            <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'familyName'" cid="familyName" formscope="casedetailsform" v-model="petition.sponsorInfo.submitSupPetiForOtherRelative.familyName" :required="true"  :fieldName="'familyName'" label="Family Name" placeHolder="Family Name" :tplsection="'sponsorInfo.submitSupPetiForOtherRelative'" />
                                            <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'givenName'" cid="givenName" formscope="casedetailsform" v-model="petition.sponsorInfo.submitSupPetiForOtherRelative.givenName" :required="true"  :fieldName="'givenName'" label="Given Name" placeHolder="Given Name" :tplsection="'sponsorInfo.submitSupPetiForOtherRelative'" />
                                            <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'middleName'" cid="middleName" formscope="casedetailsform" v-model="petition.sponsorInfo.submitSupPetiForOtherRelative.middleName" :required="true"  :fieldName="'middleName'" label="Middle Name" placeHolder="Middle Name" :tplsection="'sponsorInfo.submitSupPetiForOtherRelative'" />
                                            <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'relationShip'" cid="relationShip" formscope="casedetailsform" v-model="petition.sponsorInfo.submitSupPetiForOtherRelative.relationShip" :required="true"  :fieldName="'relationShip'" label="Relationship" placeHolder="Relationship" :tplsection="'sponsorInfo.submitSupPetiForOtherRelative'" />
                                        </template>
                                        </template>
                                           <immiyesorno  :required="checkFieldIsRequired({'key':'haveYouPrevFiledAnyPetitionForBnf','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass=" "  :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="haveYouPrevFiledAnyPetitionForBnf" 
                                             v-model="petition.sponsorInfo.haveYouPrevFiledAnyPetitionForBnf" :tplkey="'haveYouPrevFiledAnyPetitionForBnf'" :tplsection="'sponsorInfo'"  :fieldName="'hasSubmitSepPetiForOtherRelation'"   label="Have you EVER previously filed a petition for this beneficiary or any other alien?"></immiyesorno>
                                             <template v-if="canRenderField('haveYouPrevFiledAnyPetitionForBnf',questionnaireDetails, false, 'sponsorInfo' )  && checkProperty(petition, 'sponsorInfo', 'haveYouPrevFiledAnyPetitionForBnf')">
                                                <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'familyName'" cid="familyName" formscope="casedetailsform" v-model="petition.sponsorInfo.bnfPrevPetitionInfo.familyName" :required="true"  :fieldName="'familyName'" label="Family Name" placeHolder="Family Name" :tplsection="'sponsorInfo.bnfPrevPetitionInfo'" />
                                                <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'givenName'" cid="givenName" formscope="casedetailsform" v-model="petition.sponsorInfo.bnfPrevPetitionInfo.givenName" :required="true"  :fieldName="'givenName'" label="Given Name" placeHolder="Given Name" :tplsection="'sponsorInfo.bnfPrevPetitionInfo'" />
                                                <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'middleName'" cid="middleName" formscope="casedetailsform" v-model="petition.sponsorInfo.bnfPrevPetitionInfo.middleName" :required="true"  :fieldName="'middleName'" label="Middle Name" placeHolder="Middle Name" :tplsection="'sponsorInfo.bnfPrevPetitionInfo'" />
                                                <datepickerField :display="false" :fieldsArray="questionnaireDetails" :tplkey="'dateOfFiling'"  :validationRequired="true" v-model="petition.sponsorInfo.bnfPrevPetitionInfo.dateOfFiling" formscope="casedetailsform"   :tplsection="'sponsorInfo.bnfPrevPetitionInfo'"  :fieldName="'dateOfFiling'"  label="Date" />
                                                <selectField :display="false" :fieldsArray="questionnaireDetails"  :required="true" :optionslist="usastates"
                                                v-model="petition.sponsorInfo.bnfPrevPetitionInfo.stateDetailsOfFiling" 
                                                :tplsection="'sponsorInfo.bnfPrevPetitionInfo'"  :fieldName="'stateOfFiling'" :tplkey="'stateOfFiling'"  formscope="casedetailsform"  label="State" placeHolder="State" />
                                                <immiInput  :fieldsArray="questionnaireDetails" :display="false" :tplkey="'cityOfFiling'" cid="cityOfFiling" formscope="casedetailsform" v-model="petition.sponsorInfo.bnfPrevPetitionInfo.cityOfFiling" :required="true"  :fieldName="'cityOfFiling'" label="City or Town" placeHolder="City or Town" :tplsection="'sponsorInfo.bnfPrevPetitionInfo'" />
                                                <datepickerField :display="false" :fieldsArray="questionnaireDetails" :tplkey="'dateOfFiling'"  :validationRequired="true" v-model="petition.sponsorInfo.bnfPrevPetitionInfo.dateOfFiling" formscope="casedetailsform"   :tplsection="'sponsorInfo.bnfPrevPetitionInfo'"  :fieldName="'dateOfFiling'"  label="Date of Filed" />
                                                
                                                <selectField :listContainsId="false" :display="false" :fieldsArray="questionnaireDetails"  :required="true" :optionslist="caseApprovedList"
                                                v-model="petition.sponsorInfo.bnfPrevPetitionInfo.status" 
                                                :tplsection="'sponsorInfo.bnfPrevPetitionInfo'"  :fieldName="'status'" :tplkey="'status'"  formscope="casedetailsform"  label="Result" placeHolder="Result" />
                                               
                                           </template>
                                              <!-- newly added keys end -->
                                            <immiyesorno  :required="checkFieldIsRequired({'key':'benfApplyAdjustStatus','section':'sponsorInfo.affidavitInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass=" "  :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="benfApplyAdjustStatus"  v-model="petition.sponsorInfo.affidavitInfo.benfApplyAdjustStatus" :tplkey="'benfApplyAdjustStatus'" :tplsection="'sponsorInfo.affidavitInfo'"  :fieldName="'benfApplyAdjustStatus'"   label="Is beneficiary is applying for adjustment of status based on your application? "></immiyesorno>
                                               
                                            <template v-if="canRenderField('affidavitInfo',questionnaireDetails, false, 'sponsorInfo.affidavitInfo' ) && checkProperty(petition.sponsorInfo, 'affidavitInfo', 'benfApplyAdjustStatus')">
                                                <affidavitForm :tplsection="'sponsorInfo.affidavitInfo'" cid="sponsorInfo.affidavitInfo" formscope="casedetailsform" :petition="petition" :fieldName="'affidavitInfo'" :fieldsArray="questionnaireDetails"  v-model="petition.sponsorInfo.affidavitInfo" />
                                            </template>
                                            <!-- v-model="petition.sponsorInfo.affidavitInfo"  -->
                                            <immiyesorno :required="checkFieldIsRequired({'key':'previouslyMarried','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" v-if="checkProperty(petition ,'sponsorInfo','maritalStatus') && checkProperty(petition ,'sponsorInfo','maritalStatus') !=1" wrapclass=" "  :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="previouslyMarried"  v-model="petition.sponsorInfo.previouslyMarried" :tplkey="'previouslyMarried'" :tplsection="'sponsorInfo'"  :fieldName="'previouslyMarried'"   label="Were you married previously?"></immiyesorno>
                                            <template v-if="petition.sponsorInfo.previouslyMarried  && checkProperty(petition ,'sponsorInfo','maritalStatus') !=1 && canRenderField('previousSpouse',questionnaireDetails, false, 'sponsorInfo.previousSpouse' ) && canRenderField('previouslyMarried',questionnaireDetails, false, 'sponsorInfo' )">
                                                <previousSpouseForm  :tplsection="'sponsorInfo.previousSpouse'" cid="ben_previousSpouse" formscope="casedetailsform" :countries="countries" :petition="petition" :fieldName="'previousSpouse'" :fieldsArray="questionnaireDetails" v-model="petition.sponsorInfo.previousSpouse"    />
                                            </template> 
    
                                        </div>
                                    </div>
                                </vs-col>
                            </form>
                        </div>            
    <!-------------------------------------------------------------------------------->
                        <div v-if="currentTab=='employment'" id="employment_details">
                            <form data-vv-scope="employmentform" @submit.prevent="" @keydown.enter.prevent="">
                                <template v-if="canRenderField('anyOtherPersonEmployedInUS', questionnaireDetails ,false,'sponsorInfo' ) || canRenderField('prevEmploymentInfo', questionnaireDetails ,false,'sponsorInfo.prevEmploymentInfo') ">
                                    <vs-col class="w-full p-0">
                                        <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                            Provide your current and previous employment details, starting from the most recent first.
                                        </vs-alert>
        
                                    </vs-col>
                                        
                                    <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                        <div class="form-container form-container-questionnaire form-container-employment">
                                            <div class="vx-row">
                                                <!-- <h3 class="small-header emp_det_header">Employment Details</h3> -->
                                                <div class="empyes_no">
                                                    <immiyesorno :wrapclass="'yesnomar'" :cid="'anyOtherPersonEmployedInUS'" formscope="employmentform" :required="checkFieldIsRequired({'key':'anyOtherPersonEmployedInUS','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :tplkey="'anyOtherPersonEmployedInUS'" :fieldsArray="questionnaireDetails"   v-model="petition.sponsorInfo.anyOtherPersonEmployedInUS" :tplsection="'sponsorInfo'"  :fieldName="'anyOtherPersonEmployedInUS'"   label="Have you ever been employed?"></immiyesorno>
                                                </div>
                                                <template v-if="(petition.sponsorInfo && petition.sponsorInfo.anyOtherPersonEmployedInUS && canRenderField('anyOtherPersonEmployedInUS', questionnaireDetails ,false,'sponsorInfo' ) && canRenderField('prevEmploymentInfo', questionnaireDetails ,false,'sponsorInfo.prevEmploymentInfo'))   ">
                                                    <immiemployment :prefillCountryInQuestionnaire="prefillCountryInQuestionnaire" :petition="petition" :countries="countries" :fieldsArray="questionnaireDetails"  cid="ben_prevEmploymentInfo" formscope="employmentform" v-model="petition.sponsorInfo.prevEmploymentInfo" :tplsection="'sponsorInfo.prevEmploymentInfo'"  :fieldName="'prevEmploymentInfo'"  />
                                                </template>
                                            </div>
        
                                        </div>
                                    </vs-col>
                                </template>
                                <template v-if=" canRenderField('prevEmploymentOutsideUS', questionnaireDetails ,false,'sponsorInfo.prevEmploymentOutsideUS') || canRenderField('haveYouEverEmployed', questionnaireDetails ,false,'sponsorInfo')">
                                    <vs-col class="w-full p-0 mart30">
                                        <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                            Last Employer outside of the United States for more than one year.
                                        </vs-alert>
        
                                    </vs-col>
                                    <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                        <div class="form-container form-container-questionnaire form-container-employment">
                                            <div class="vx-row">
                                                <div class="empyes_no">
                                                    <immiyesorno :wrapclass="'yesnomar'" :cid="'haveYouEverEmployed'" formscope="employmentform" :required="checkFieldIsRequired({'key':'haveYouEverEmployed','section':'sponsorInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :tplkey="'haveYouEverEmployed'" :fieldsArray="questionnaireDetails"   v-model="petition.sponsorInfo.haveYouEverEmployed" :tplsection="'sponsorInfo'"  :fieldName="'haveYouEverEmployed'"   label="Have you ever been employed Outside US?"></immiyesorno>
                                                </div>
                                                <template v-if=" petition.sponsorInfo && petition.sponsorInfo.haveYouEverEmployed">
                                                    <immiemployment :prefillCountryInQuestionnaire="prefillCountryInQuestionnaire" :petition="petition" :countries="countries" :fieldsArray="questionnaireDetails"  cid="ben_prevEmploymentOutsideUS" formscope="employmentform" v-model="petition.sponsorInfo.prevEmploymentOutsideUS" :tplsection="'sponsorInfo.prevEmploymentOutsideUS'"  :fieldName="'prevEmploymentOutsideUS'"  />
                                                </template>
                                            </div>
                                        </div>
                                    </vs-col>  
                                </template>
                            </form>
    
                        </div>
                        <div v-if="currentTab=='parent' && (canRenderField('motherInfo', questionnaireDetails ,false,'sponsorInfo.motherInfo') || canRenderField('fatherInfo', questionnaireDetails ,false,'sponsorInfo.fatherInfo'))" id="parent_details">
                            <form data-vv-scope="parentform" @submit.prevent="" @keydown.enter.prevent="">
                                <template v-if=" canRenderField('fatherInfo', questionnaireDetails ,false,'sponsorInfo.fatherInfo')">
                                    <vs-col class="w-full p-0">
                                        <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                            Provide your father details, starting from the most recent first.
                                        </vs-alert>
                                    </vs-col>
                                    <vs-col class="m-auto float-none p-0" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                        <div class="form-container form-container-questionnaire form_container_485">
                                            <div class="vx-row">
                                                <div class="vx-col w-full">
                                                    <parentForm :countriesWithoutUS="countriesWithoutUS"  :petition="petition" :countries="countries" :fieldsArray="questionnaireDetails" cid="ben_fatherInfo"  formscope="parentform"  v-model="petition.sponsorInfo.fatherInfo" :tplsection="'sponsorInfo.fatherInfo'"  :fieldName="'fatherInfo'"   />
                                                </div>
                                            </div>
                                        </div>
                                    </vs-col>
                                </template>
                                <template v-if=" canRenderField('motherInfo', questionnaireDetails ,false,'sponsorInfo.motherInfo')">
                                    <vs-col class="w-full p-0 mart20" >
                                        <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                            Provide your mother details, starting from the most recent first.
                                        </vs-alert>
                                    </vs-col>
                                    <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" >
                                        <div class="form-container form-container-questionnaire form_container_485">
                                            <div class="vx-row">
                                                <div class="vx-col w-full">
                                                    <parentForm :countriesWithoutUS="countriesWithoutUS" :countries="countries" :fieldsArray="questionnaireDetails" :petition="petition" v-model="petition.sponsorInfo.motherInfo" :parentType="'Mother Information'" cid="ben_motherInfo"  :tplsection="'sponsorInfo.motherInfo'"  :fieldName="'motherInfo'"  formscope="parentform"  />
                                                </div>    
                                            </div>
                                        </div>
                                    </vs-col>
                                </template>
                                </form>
                        </div> 
    
                        <div v-if="currentTab=='dependentsinfo' " id="dependentsinfo_details">
                            <form data-vv-scope="dependentsinfoform" @submit.prevent="" @keydown.enter.prevent="">
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container pt-10 form-container-questionnaire">
                                        <div class="vx-row">
                                            <immiyesorno :cid="'hasSpouse'" formscope="dependentsinfoform" :required="checkFieldIsRequired({'key':'hasSpouse','section':'sponsorInfo.dependentsInfo.spouse', 'fieldsArray':questionnaireDetails, 'required':false })" :wrapclass="'h4_ead_label'"
                                             @input="spouseH4()" :display="false" :tplkey="'hasSpouse'" :fieldsArray="questionnaireDetails" v-model="petition.sponsorInfo.dependentsInfo.spouse.hasSpouse"  :tplsection="'sponsorInfo.dependentsInfo.spouse'"  :fieldName="'hasSpouse'"  label="Do you want to fill spouse information?"></immiyesorno>
                                            <div class="vx-col w-full">
                                                <div class="dependent-block_wrap" v-if="petition.sponsorInfo && petition.sponsorInfo.dependentsInfo && petition.sponsorInfo.dependentsInfo.spouse && petition.sponsorInfo.dependentsInfo.spouse.firstName!='' && petition.sponsorInfo.dependentsInfo.spouse.firstName!=null && checkProperty( petition['sponsorInfo']['dependentsInfo'],'spouse', 'hasSpouse') ">
                                                    <div class="dependent-block">
                                                        <div class="dependent-title">
                                                            <h3> {{ formatFullname(petition.sponsorInfo.dependentsInfo.spouse) }}</h3>
                                                            <ul>
                                                                <li @click="editSpouse(petition.sponsorInfo.dependentsInfo.spouse)">
                                                                    <a><img src="@/assets/images/main/edit_icon.svg" />
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div class="dependent_details">
                                                            <ul>
                                                                
                                                                <li v-if="checkProperty(petition['sponsorInfo']['dependentsInfo'], 'spouse', 'dateOfBirth')"> Date of Birth <span>{{checkProperty(petition['sponsorInfo']['dependentsInfo'], 'spouse', 'dateOfBirth') | formatDate}}</span></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <immiyesorno :cid="'hasChildren_hasChildren'" formscope="dependentsinfoform" :required="checkFieldIsRequired({'key':'hasChildren','section':'sponsorInfo.dependentsInfo.children', 'fieldsArray':questionnaireDetails, 'required':false })"
                                             @input="childH4()" :wrapclass="'h4_ead_label'" :display="false" :tplkey="'hasChildren'" :fieldsArray="questionnaireDetails" v-model="petition.hasRequiredForChildren" :tplsection="'sponsorInfo.dependentsInfo.children'"  :fieldName="'hasChildren'"    label="Do you want to fill children information?"></immiyesorno>
                                            <template v-if="petition.sponsorInfo && petition.sponsorInfo.dependentsInfo && petition.sponsorInfo.dependentsInfo.childrens && petition.sponsorInfo.dependentsInfo.childrens.length > 0 && petition.sponsorInfo.dependentsInfo.childrens[0].firstName!='' && petition.sponsorInfo.dependentsInfo.childrens[0].firstName!=null">
                                                <div class="vx-col w-full">
                                                    <div class="dependent-block_wrap">
                                                        <template v-for="(children, index) in petition.sponsorInfo.dependentsInfo.childrens">
                                                            <div class="dependent-block" v-if="children.saved" :key="index">
                                                                <div class="dependent-title" :key="index">
                                                                    <h3>
                                                                        {{ formatFullname(children) }}
                                                                    </h3>
                                                                    <ul>
                                                                        <li @click="editChildren(children,index)">
                                                                            <a><img src="@/assets/images/main/edit_icon.svg" />
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
    
                                                                <div class="dependent_details">
                                                                    <ul>
                                                                        <li v-if="children.dateOfBirth"> Date of Birth <span>{{children.dateOfBirth | formatDate}}</span></li>
                                                                         <!-- <li v-if="children.addressOutsideUS &&
                                                                        children.addressOutsideUS.countryDetails && children.addressOutsideUS.countryDetails.name
                                                                        
                                                                        "> Country <span>{{children.addressOutsideUS.countryDetails.name}}</span></li> -->
    
                                                                    </ul>
    
                                                                </div>
                                                            </div>
    
                                                        </template>
                                                    </div>
                                                </div>
                                            </template>
                                            <div style="margin-left:1rem;" vs-type="flex" vs-align="left" vs-lg="2" vs-sm="2" v-if="petition.hasRequiredForChildren">
                                                <a @click="addchildren" class="add-more ml-0" style="display:inline-block" type="filled">
                                                    <span>+</span> Add Child
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </vs-col>
                            </form>
                        </div>
    
                        <div v-if="currentTab=='documents'" id="documents_details">
                           
                            <form data-vv-scope="documentsform" @submit.prevent="" @keydown.enter.prevent="">


                                <vs-col class="w-full p-0">
                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                        NOTE: This questionnaire should be filled out completely and
                                        accurately. Kindly read the instructions carefully.
                                    </vs-alert>
                                    <fileUploadNote :fileNote="true" />
                                </vs-col>
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container pt-10 form-container-questionnaire">
                                        <div class="vx-row">
                                          <casedocumentslist @emitUploadingAction="emitUploadingAction" :docMainCategory="'sponsorDocsList'" :docslist="sponsorDocsList" :petition="petition" formscope="documentsform" :fieldsArray="questionnaireDetails" v-model="petition.sponsorInfo.documents" :tplsection="'sponsorInfo.documents'"  :fieldName="''" ></casedocumentslist>
                                        </div> 
                                    </div>
                                    
                                </vs-col>

    
                            </form>
    
                        </div>
                        <!-- && consentData && termsAndConditionsData -->
                        <div v-if="['Update', 'Review & Submit', 'Submit'].indexOf(actiontype)>-1 && [50,51].indexOf(getUserRoleId)>-1&&checkProperty(configDetails ,'acceptConsentAndTAndC')!=false">
                            <form data-vv-scope="consentTermsForm" @submit.prevent="" @keydown.enter.prevent="">
                                <div class="m-auto float-none" :class="{'pl-5':currentTab != 'documents'}" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container pt-0 form-container-questionnaire">
                                        <div class="vx-row">
                                            <div class="vx-col w-full">
                                                <label class="switch-label"> <span @click="openConsentContent('termsAndConditions')" class="terms_n_cond_lbl">Terms and Conditions</span> and <span @click="openConsentContent('consent')" class="terms_n_cond_lbl">Consent </span>to the collection and processing of my personal data for immigration case(s), including any applicable necessary filings.</label>
                                            </div>
                                            <div class="vs-col">
                                                <div class="form_group custom-form-label custom-cx-box">
                                                    <vs-checkbox
                                                    v-model="consentChecked"
                                                    data-vv-as="adjustmentOfI485Status"
                                                    name="consentChecked">I have read and understand the above
                                                    </vs-checkbox>
                                                </div>
                                                <input type="hidden" :name="'select_PrimaryH1BHolder'" v-validate="'required'" data-vv-as="Field"
                                                v-model="getConsentVal">
                                                <span class="text-danger text-sm pt-5" style="top:46px"
                                                v-show="errors.has('consentTermsForm.select_PrimaryH1BHolder')">*You must read and understand the above</span>
                                            </div>
                                            <div class="vs-col">
                                                <div class="form_group custom-form-label custom-cx-box">
                                                    <vs-checkbox
                                                    v-model="termsAndConditionsChecked"
                                                    data-vv-as="adjustmentOfI485Status"
                                                    name="termsAndConditionsChecked">I agree to the above
                                                    </vs-checkbox>
                                                </div>
                                                <input type="hidden" :name="'select_PrimaryH1BHoer'" v-validate="'required'" data-vv-as="Field"
                                                v-model="getTermsVal">
                                                <span class="text-danger text-sm pt-5" style="top:46px"
                                                v-show="errors.has('consentTermsForm.select_PrimaryH1BHoer')">*You must agree to the above</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="questionnaire_footer">
                    <div class="d-flex">
                        <vs-button v-if="getIndexOfActivetab!=1" @click="goBack()" class="questionnaire_btn" type="filled">Back</vs-button>
                    </div>
                    <div class="d-flex">
                        <vs-button @click="saveCase(true);" :disabled="documentUploading" class="questionnaire_btn" type="filled">Save</vs-button>
                        <vs-button color="success" @click="submitCase();" :disabled="documentUploading" class="save questionnaire_btn" type="filled">{{actiontype}}</vs-button>
    
                    </div>
                </div>
            </div>
    
        </div>
    
        <div class="custom_modal_sec preview_questionarie" :class="{ modalopen: questionnairePreview }">
            <div class="custom_modal_overlay" ></div>
    
            <div class="custom_modal_cnt">
                <div class="modal_title">
                    <h2>Questionnaire Review</h2>
                    <span @click="questionnairePreview = false">
                        <x-icon size="1.5x" class="close"></x-icon>
                    </span>
                </div>
                <div class="modal_cnt preview_content new_questionnaire_review">
                    
                    
              
                    
                    <VuePerfectScrollbar ref="mainSidebarPs1" :settings="settings">
                        
                        <PetitionDetails :callfromSponsorPrefill="true" v-if="questionnairePreview" :loadedFromPreview="true" :fieldsArrayDetails="questionnaireDetails" :previewData="questionnairePreviewData" />
                    </VuePerfectScrollbar>
                
                </div>
                <div class="questionnaire_footer">
                    <div class="d-flex">
                        <vs-button @click="questionnairePreview = false" class="cancel questionnaire_btn" type="filled">Cancel
                        </vs-button>
                        <vs-button v-if="false" @click="saveCase(false,false);" class="save questionnaire_btn" type="filled">Submit </vs-button>
                        <vs-button  @click="tempSave =false;showMessage = false; tempSave =false;showMessage = false; toggleBenProfileCOnformPopUp(true)" class="save questionnaire_btn" type="filled">Submit </vs-button>
                        
                    </div>
                </div>
            </div>
        </div>
    
        <vs-popup class="holamundo success-popups cls-btn" title="Your registration is complete." v-if="SuccessQuestionnaire" :active.sync="SuccessQuestionnaire">
            <form  @submit.prevent="" @keydown.enter.prevent="">
                <div class="form-container" @click="formerrors.msg = ''">
                    <figure>
                        <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
                    </figure>
                    <h2 class="title">Questionnaire submitted successfully!</h2> 
                    <template v-if="checkProperty($route ,'name') !='fill-sponsor-questionnaire' && checkProperty($route ,'name') !='fill-questionnaire' && checkProperty($route ,'name') !='fill-perm-questionnaire' ">
                        <p v-if="getUserData && checkProperty(getUserData['tenantDetails']['typeDetails'],'id') == 2">
                            It will be reviewed by the Admin and appropriate actions will be
                            taken soon. 
                        </p>
                        <p v-if="getUserData && (checkProperty(getUserData['tenantDetails']['typeDetails'],'id') == 1)">
                            It will be reviewed by the petitioner and appropriate actions will be
                            taken soon. 
                        </p>
                        <p>
                        Continue to fill Beneficiary Questionnaire. 
                        </p>
                    </template>
                </div>
                <div class="popup-footer">

                    <vs-button color="dark" @click="reloadthePage(false)" class="cancel" type="filled">cancel</vs-button>
                    <vs-button color="success" @click="reloadthePage(true)" class="save" type="filled">continue</vs-button>
                </div>
            </form>
        </vs-popup>
        <vs-popup class="holamundo main-popup qcomment" title="Comment" :active.sync="commentPopUp">
            <form data-vv-scope="commentForm" @submit.prevent="" @keydown.enter.prevent="">
                <div class="form-container" @click="formerrors.msg = ''">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <div class="form_group">
                                <label class="form_label">Comments </label>
                                <!-- <vs-textarea data-vv-as="Comments" v-validate="'required'" v-model="comments" name="comments" class="w-full" /> -->
                                <ckeditor data-vv-as="Comments" v-validate="'required'" v-model="comments" name="comments" class="w-full"   :editor="editor" :config="editorConfig"></ckeditor>
                                <span class="text-danger text-sm" v-show="errors.has('commentForm.comments')">{{ errors.first("commentForm.comments") }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="text-danger text-sm formerrors" v-show="formerrors.msg">
                        <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
                    </div>
                </div>
                <div class="popup-footer relative">
                    <span class="loader" v-if="submiTing"><img src="@/assets/images/main/loader.gif" /></span>
    
                    <vs-button :disabled="comments == '' || comments.trim() == '' || submiTing" color="success" @click="formSubmitted(false)" class="save" type="filled">Submit</vs-button>
                </div>
            </form>
        </vs-popup>
    
        <div class="custom_modal_sec spouse_doc documents__modal" v-if="spouseModalForm" :class="{ modalopen: spouseModalForm }">
            <div class="custom_modal_overlay"></div>
            <div class="custom_modal_cnt">
                <div class="modal_title">
                    <h2>Spouse Information</h2>
                    <span class="close" v-if="!documentUploading" @click="toggleSpouseForm(false)">
                        <em class="material-icons">close</em>
                    </span>
                </div>
                <div class="modal_cnt">
                    <VuePerfectScrollbar ref="mainSidebarPs" :settings="settings">
                        <form data-vv-scope="dependentsInfoformmodal" @submit.prevent="" @keydown.enter.prevent="" >
                            <personalinfo :tplsection="'sponsorInfo.dependentsInfo.spouse'" :countriesWithoutUS="countriesWithoutUS" :eye_colorList="eye_colorList" :marital_statuses="marital_statuses"  :races_list="races_list"  :hair_colorsList="hair_colorsList" :feetList="feetList" :inchesList="inchesList"  :visastatuses="visastatuses" :countries="countries" formscope="dependentsInfoformmodal" :petition="petition" :fieldsArray="questionnaireDetails" v-model="spouse"></personalinfo>
                        </form>
                    </VuePerfectScrollbar>
                </div>
                <div class="popup-footer relative">
                    <vs-button color="dark" :disabled="documentUploading" @click="toggleSpouseForm(false)" class="cancel" type="filled">Cancel</vs-button> 
                    <vs-button color="success" :disabled="documentUploading" @click="submitSpouse()" class="save" type="filled">Save
                    </vs-button>
                </div>
                <div></div>
            </div>
        </div>
    
        <div class="custom_modal_sec child_doc documents__modal" v-if="childModalForm" :class="{ modalopen: childModalForm }">
            <div class="custom_modal_overlay"></div>
            <div class="custom_modal_cnt">
                <div class="modal_title">
                    <h2>Child Information</h2>
                    <span class="close" @click="toggleChildForm(false)">
                        <em class="material-icons">close</em>
                    </span>
                </div>
                <div class="modal_cnt">
                    <VuePerfectScrollbar ref="mainSidebarPschild" :settings="settings">
                        <form data-vv-scope="childInfoformmodal" @submit.prevent="" @keydown.enter.prevent="">
                            <childpersonalinfo :countriesWithoutUS="countriesWithoutUS"  :marital_statuses="marital_statuses" :tplsection="'sponsorInfo.dependentsInfo.children'" :countries="countries" formscope="childInfoformmodal" :petition="petition" :fieldsArray="questionnaireDetails" v-model="petition.sponsorInfo.dependentsInfo.childrens[selectedchild]"></childpersonalinfo>
                        </form>
                    </VuePerfectScrollbar>
                </div>
                <!-- :disabled="submiTing"  -->
                <div class="popup-footer relative">  
                    <vs-button color="dark" :disabled="documentUploading" @click="toggleChildForm(false)" class="cancel" type="filled">Cancel</vs-button>
                    <vs-button color="success" :disabled="documentUploading" @click="submitChild()" class="save" type="filled">Save
                    </vs-button>
                </div>
                <div></div>
            </div>
        </div>
    
        <vs-popup class="holamundo main-popup cls-btn" title="Case Details" :active.sync="showPrefillPopup">
            <div class="form-container"> 
                <div class="vx-row">
                    <div class="vx-col w-full" v-if="beneFiciaryDeytailsExists">
                        <p style="line-height: 20px">
                            Do you want to pre-fill the basic information from the Sponsor Profile?
                        </p>
                    </div>
                    <div class="vx-col w-full" v-else>
                        <p style="line-height: 20px">
                            Do you want to pre-fill the basic information from the previous
                            case details?
                        </p>
                    </div>
                </div>
            </div>
            <div class="popup-footer">
                <vs-button color="dark" class="cancel" type="filled" @click="setBasicData();removeFields();showPrefillPopup = false">Cancel</vs-button>
                <vs-button color="success" class="save" type="filled" @click="
                prefilltheDetails();prefillAction = true;
                showPrefillPopup = false;
              ">Yes</vs-button>
            </div>
        </vs-popup>
        <vs-popup class="holamundo main-popup cls-btn" title="Confirmation" :active.sync="showBenProfileSyncPopup">
            <div class="form-container">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <p style="line-height: 20px">
                            Do you want to update the Sponsor Profile with the new/change information entered in this case?
                        </p>
                    </div>
                </div>
            </div>
            <div class="popup-footer">
                <vs-button color="dark" class="cancel" type="filled" @click="conformBenProfile(false)">Cancel</vs-button>
                <vs-button @click="conformBenProfile(true);" class="save questionnaire_btn" type="filled">Yes </vs-button>
            </div>
        </vs-popup>

        <template v-if="!checkCurrentUrl">
            <generatePin v-if="openGeneratePinPopUp" 
              @updateVerificationStatus="updateVerificationStatus"
              @hideMe="openGeneratePinPopUp = false"  
              :callFromSponsor="true"
              :petitionDetails="petition" />
        
        </template>

        <modal
        name="showConsentContentPopup"
        classes="v-modal-sec"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="600px"
        height="auto"
        >
            <div class="v-modal profile_details_modal terms_n_conditions">
            <div class="popup-header fromDetailsPage">
                <h2 class="popup-title">{{getLabelContent}}</h2>
                <span  @click="$modal.hide('showConsentContentPopup')">
                <em class="material-icons">close</em>
                </span>
            </div>

            <div class="form-container"> 
                <div class="vx-row">
                    <div class="vx-col w-full" v-if="contentCategory == 'consent'">
                        <p class="ownership_details" v-html="consentData" ></p>
                    </div>
                    <div class="vx-col w-full" v-if="contentCategory == 'termsAndConditions'">
                        <p class="ownership_details" v-html="termsAndConditionsData" ></p>
                    </div>
                </div>
            </div>
            <!-- ;agreeTerms(contentCategory) -->
            <div class="popup-footer relative">
                <vs-button color="success"
                    @click="$modal.hide('showConsentContentPopup')"
                    class="save"
                    type="filled"
                    >Okay
                </vs-button>
            </div>

            </div>
        </modal>
    
    </div>
    </template>
    
    <script>
     import affidavitForm from "@/views/forms/fields/affidavitForm.vue";
    import generatePin from "@/views/actionpopups/generatePin.vue";
     import { InfoIcon } from "vue-feather-icons";
    import { EyeIcon } from "vue-feather-icons";
    import genderField from './fields/gender.vue'
    import immiInput from "@/views/forms/fields/simpleinput.vue";
    
    import {
        Trash2Icon
    } from "vue-feather-icons";
    import fileUploadNote from "@/views/common/fileUploadNote.vue";
    import consulateAddress from "@/views/forms/fields/consulateAddress.vue";
    import addressField from "@/views/forms/fields/address.vue";
    import datepickerField from "@/views/forms/fields/datepicker.vue";
    import selectField from "@/views/forms/fields/simpleselect.vue";
    import monthAndYear from "@/views/forms/fields/monthAndYear.vue";
    import immiPhone from "@/views/forms/fields/phonenumber.vue";
    import immiMask from "@/views/forms/fields/maskinput.vue";
    import immiyesorno from "@/views/forms/fields/yesorno.vue";
    import immiuploader from "@/views/forms/fields/fileupload.vue";
    import immipriorstay from "@/views/forms/fields/priorstay.vue";
    import immitextarea from "@/views/forms/fields/simpletextarea.vue";
    import immieducations from "@/views/forms/fields/educations.vue";
    import immiswitchyesno from "@/views/forms/fields/switchyesno.vue";
    import Datepicker from "vuejs-datepicker-inv";
    import casedocumentslist from "@/views/common/casedocuments.vue";
    import immiemployment from "@/views/forms/fields/employment.vue";
    import moment from "moment";
    import petitionsinformation from "@/views/forms/fields/petitionsinformation.vue";
    import petitionImmigranInfo from "@/views/forms/fields/petitionImmigranInfo.vue";
    import personalinfo from "@/views/forms/fields/i130SpouseForm.vue";
    // D:\work\Immibox-web\src\views\forms\fields\i130SpouseForm.vue
    //D:\work\Immibox-web\src\views\forms\fields\i130ChildForm.vue
    import childpersonalinfo from "@/views/forms/fields/i130ChildForm.vue";
    import { XIcon } from 'vue-feather-icons'
    import JQuery from 'jquery';
    import FileUpload from "vue-upload-component/src";
    import _ from "lodash";
    import PetitionDetails from "@/views/PetitionDetails.vue";
    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    
    import immitextfield from "@/views/forms/fields/simpleTextField.vue";
    
    //485 Components
    import Vue from 'vue';
    Vue.use( CKEditor );
    import CKEditor from '@ckeditor/ckeditor5-vue2';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import previousSpouseForm from "@/views/petition/gc/previousSpouseForm.vue";
    import immigrationForm from "@/views/petition/gc/immigrationForm.vue";
    import financialForm from "@/views/petition/gc/financialForm.vue";
    import assestsForm from "@/views/petition/gc/assestsForm.vue";
    import liabilitiesForm  from "@/views/petition/gc/liabilitiesForm.vue";
    import publicBenefitsForm  from "@/views/petition/gc/publicBenefitsForm.vue";
    import parentForm from "@/views/petition/gc/parentForm.vue";
   


    
    
    export default {
        props: {
    
        },
        provide() {
            return {
                parentValidator: this.$validator,
            };
        },
        data() {
            return {
                consentData:'',
                termsAndConditionsData:'',
                contentCategory:'',
                consentTermsAndCondition:false, 
                termsAndConditionsChecked:false, 
                consentChecked:false,
                // Consent End
                filledStatusList:['Approved','Pending','Denied'],
                fillingForList:[
                    'Spouse','Father','Mother','Sibling','Child'
                   
                ],
                // {'id':'SPOUSE','name':'Spouse'}, // approved/denied/withdrawn
                //     {'id':'FATHER','name':'Father'},
                //     {'id':'MOTHER','name':'Mother'},
                //     {'id':'SIBLING','name':'Sibiling'},
                //     {'id':'CHILD','name':'Child'}
                caseApprovedList:['Approved','Denied','Withdrawn'],
                sponsorDocsList:[
                    {
                        required: false,
                        fileUploading:false,
                        key: 'sponsorPassport',
                        fieldName: 'sponsorPassport',
                        label: 'Copy of all the pages of the passport of the Petitioner (including the blank pages).  Please make sure that the photo(s) and biographic information are clearly visible'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'sponsorGreenCard',
                        fieldName: 'sponsorGreenCard',
                        label: 'Copy of the Naturalization Certificate/Green Card (front and back) of the Petitioner'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'sponsorBirthCertificate',
                        fieldName: 'sponsorBirthCertificate',
                        label: 'Copy of the Birth Certificate of the Petitioner'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'sponsorPhotographs',
                        fieldName: 'sponsorPhotographs',
                        label: 'Two (2) photographs of the Petitioner'
                    },
                    
                    
                ],
                prevH1bCaseStatusList:[
                    {id:'approved','name':'Approved'},
                    {id:'denied','name':'Denied'},
                    {id:'not_used','name':'Not Used'}
                ],
                openGeneratePinPopUp:false,
                tokenVerified:false,
                newDocs:[],
                tempSave:false,
                showMessage:true,
                documentUploading:false,
                disablefield:false, 
                editor: ClassicEditor,
                editorConfig: {
                    toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
                },
                consularProcessingValidator:'',
                public_benefits:[],
                liability_list:[],
                assestsList:[],
                eye_colorList:[],
                feetList:[1,2,3,4,5,6,7,8,9,10,11,12],
                inchesList:[0,1,2,3,4,5,6,7,8,9,10,11],
                classificationList:[ "EB-1","EB-2","EB-3" ],
                hair_colorsList:[],
                races_list:[],
                uploading:false,
                value:[],
                payFrequencyList:[ "Hour","Week","Month","Year" ],
                settings: { 
                    swipeEasing: true,
                },
                commentPopUp:false,
                benProfileDetails:null,
                petition: {
                    tenantId: null,
                    petitionerId: null,
                    companyId: null,
                    branchId: null,
                    workflowId: null,
                    customId: '',
                    caseNo: '',
                    caseNoOld: '',
                    caseNoRef: '',
                    caseNoSNo: 0,
                    allowCustomCaseNo: false,
                    caseNumber: null,
                    type: null,
                    subType: null,
                    masterSocList:[], 
                    sponsorInfo: {
                        haveUSCitizenOrPermResident:'',
                        filingThisPetitionerFor:'',
                        name: '',
                        firstName: '',
                        middleName: '',
                        lastName: '',
                        hasOtherNames: null,
                        otherNames: [{
                            _id: 0,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                        }],
                        gender: '',
                        email: '',
                        nameDiffFromBirthCert:null,
                        birthCertHaveNamePobDob:false,
                        have2AffidavitsOfBirthFamily:null,
                        currentAddress:{
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        mailingAddressIsSameAsAddress:false,
                        address: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        cellPhoneNumber: null,
                        cellPhoneCountryCode: {
                            countryCode: '',
                            countryCallingCode: ''
                        },
                        SSN: '',
                        alienNumber: '',
                        dateOfBirth: null,
                        placeOfBirth:null,
                        countryOfCitizenship:null,
                        countryOfCitizenshipDetails:null,
                        placeOfBirthDetails:null,
                        provinceOfBirth: null,
                        provinceOfBirthDetails: null,
                        locationOfBirth: null,
                        dateOfMarriage:null,
                            dateOfMarriageEnd:null,
                              //Place of Marriage
                            countryOfMarriage: '',
                            countryOfMarriageDetails: null,
                            provinceOfMarriage: '',
                            provinceOfMarriageDetails: null,
                            locationOfMarriage: '',
                        maritalStatus:null,
                        maritalStatusDetails:null,
                        usCitizen:false,
                        citizenshipAcquiredThrough:null,
                        // citizenshipBirth:null,
                        // citizenshipNaturalization:null,
                        // citizenshipParents:null,
                        lawfulPerResident:false,
                        lprRequired:null,
                        certOfCitizenNumber:'',
                        dateReceivedLPR:null,
                        placeOfIssuance:null,
                        dateOfIssuance:null,
                        usCitizenOrLPR:null,
                        height: {
                            feet: '',
                            inches: ''
                        },
                        weight: null,
                        race: [],
                        eyeColor: null,
                        hairColor: null,
                        nationality:null,
                        dateFromUSCitizen:null,
                        filedOnAnyOtherPerOrPetitioner:false,
                        filedName: '',
                        filedPlace: '',
                        fileDateOfFiling: null, 
                        filedStatus: null,
                        //  newly added keys starts
                        fillThisPetiChildOrParentRelation: null,
                        fillThisBroOrSisRelatedByAdoption: null,
                        gainLawPermResidentThroughAdoption: null, 
                        lawFulPermanentResident:{
                            classOfAdmission:'',
                            dateOfAdmission:null
                        },
                        cityOfAdmission:'',
                        stateOfAdmission:null,
                        stateDetailsOfAdmission:null,
                        dateOfProceedings:  null,
                        cityOfProceedings: '',
                        stateOfProceedings: null,
                        stateDetailsOfProceedings: null,
                        //state:'',
                        anyOtherElseFiledPetitionForBnf:null,
                        benfEverInImmigrationProceedings:null,
                        typeOfProceedings:null,
                        hasSubmitSepPetiForOtherRelation:null,
                        submitSupPetiForOtherRelative: [{
                            relative: null,
                            familyName: '',
                            givenName: '',
                            middleName: '',
                            relationShip: '',
                        }],
                        haveYouPrevFiledAnyPetitionForBnf: null,
                        bnfPrevPetitionInfo: {
                            familyName: '',
                            givenName: '',
                            middleName: '',
                            dateOfFiling:  null,
                            cityOfFiling: null,
                            stateOfFiling: null,
                            stateDetailsOfFiling: null,
                            status: '', // approved/denied/withdrawn
                        },
                        //  newly added keys ends
                        addressOfLastNYears:[{
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                        }], 
                        addressOutsideUSMoreThanYear:[{
                        
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null,
                            startDate: null,
                            endDate: null,
                        }],
                        affidavitInfo: {
                            benfApplyAdjustStatus:null,
                            currentAnnualSalary: '',
                            nameOfEmployer: '',
                            currentPosition: '',
                            depositsInBankUSA: '',
                            reasonableValPersonalProperty: '',
                            haveMarketValInStocksAndBonds: null,
                            marketValInStocksAndBonds: '',
                            sumOfLifeInsurance: '',
                            cashSurrValOfLifeInsurance: '',
                            haveValOfRealEstate: null,
                            valOfRealEstate: '',
                            amountOfMortgageProperty: '',
                            addressPropertyIsLocate: '',
                            benfAdjustmentDocument:[]
                        },
                        anyOtherPersonEmployedInUS:null,
                        haveYouEverEmployed:null,
                        prevEmploymentInfo: [{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            currentEmployer: null,
                            salary:null,
                            payFrequency:null,
                        }],
                        prevEmploymentOutsideUS:[{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            currentEmployer: false  
                        }],
                        previouslyMarried:null,
                        previousSpouse:{
                            hasOtherNames:false,
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            maidenName:'',
                            marriageEndedDueTo:null,
                            marriageEndedOtherInfo:'',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            
                            dateOfMarriage:null,
                            dateOfMarriageEnd:null,
                              //Place of Marriage
                            countryOfMarriage: '',
                            countryOfMarriageDetails: null,
                            provinceOfMarriage: '',
                            provinceOfMarriageDetails: null,
                            locationOfMarriage: '',
    
                            //Place of Termination
                            countryOfMarriageTermination: '',
                            countryOfMarriageTerminationDetails: null,
                            provinceOfMarriageTermination: '',
                            provinceOfMarriageTerminationDetails: null,
                            locationOfMarriageTermination: '',
                            obtainPermResidenceThroughSpouse:false  
                          
                        },
                        fatherInfo: { 
                            name: '', 
                            firstName: '', 
                            middleName: '', 
                            lastName: '', 
                            hasOtherNames: false, 
                            otherNames: [{ 
                                _id: 0, 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                            }], 
                            dateOfBirth: null, 
                            countryOfBirth: '', 
                            countryOfBirthDetails: null, 
                            provinceOfBirth: '', 
                            provinceOfBirthDetails: null, 
                            locationOfBirth: '', 
                            currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                                isUSCitizen: false, 
                                dateFromUSCitizen: null, //["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                        },
                        motherInfo: { 
                            name: '',                    
                            firstName: '', 
                            middleName: '', 
                            lastName: '', 
                            hasOtherNames: false , 
                            otherNames: [{ 
                                _id: 0, 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                            }], 
                            dateOfBirth: null, 
                            countryOfBirth: '', 
                            countryOfBirthDetails: null, 
                            provinceOfBirth: '', 
                            provinceOfBirthDetails: null, 
                            locationOfBirth: '', 
                            currentAddress: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                            },
                            isUSCitizen: false, 
                            dateFromUSCitizen:null,// ["", ""],
                            nameAtBirth:{
                                firstName: '', 
                                middleName: '', 
                                lastName: '',
                            },
                            deceasedCity: '',
                            deceasedCityDetails:null,
                            deceasedDate: null,
                        },
                        dependentsInfo:{
                            spouse: {
                                gender:'',
                                relationship:'',
                                currentlyInUS:null,
                                hasSpouse:null,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                                dateOfBirth: null,
                                countryOfBirth: null,
                                countryOfBirthDetails: null,
                                provinceOfBirth: null,
                                provinceOfBirthDetails: null,
                                locationOfBirth: null,
                                alienNumber:'',
                                passportExpiryDate:null,
                                currentStatus: null,
                                currentStatusDetails: null,
                                currentAddress:{
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                            },
                            children:[{
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                                dateOfBirth: null,
                                countryOfBirth: null,
                                countryOfBirthDetails: null,
                                provinceOfBirth: null,
                                provinceOfBirthDetails: null,
                                locationOfBirth: null,
                                relationshipToYou:'',
                            }]
                        },
                        documents:{
                            sponsorPhotographs:[],
                            sponsorBirthCertificate:[],
                            sponsorGreenCard:[],
                            sponsorPassport:[]
                        }
                        // replaced Fields
                    },
                    //GC 485 fields starts
                    
                    lcaRequested: false,
                    questionnaireFilled: false,
                    questionnaireFilled_temp: false,
                    lcaId: null,
                    statusId: 1,
                    status: 1,
                    questionnaireSent: true,
                    questionnaireInstructions: '',
                    assignOrSubmitRoleComment: '',
                    curWorkflowActivity: 'CREATE_PETITION',
                    nextWorkflowActivity: ['SUBMIT_BY_BENEFICIARY'],
                    relationships:['Son','Daughter']
                },
                tempPetition: {
                    tenantId: null,
                    petitionerId: null,
                    companyId: null,
                    branchId: null,
                    workflowId: null,
                    customId: '',
                    caseNo: '',
                    caseNoOld: '',
                    caseNoRef: '',
                    caseNoSNo: 0,
                    allowCustomCaseNo: false,
                    caseNumber: null,
                    type: null,
                    subType: null,
                    masterSocList:[], 
                    sponsorInfo: {
                        haveUSCitizenOrPermResident:'',
                        filingThisPetitionerFor:'',
                        name: '',
                        firstName: '',
                        middleName: '',
                        lastName: '',
                        hasOtherNames: null,
                        otherNames: [{
                            _id: 0,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                        }],
                        gender: '',
                        email: '',
                        nameDiffFromBirthCert:null,
                        birthCertHaveNamePobDob:false,
                        have2AffidavitsOfBirthFamily:null,
                        currentAddress:{
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        mailingAddressIsSameAsAddress:false,
                        address: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        cellPhoneNumber: null,
                        cellPhoneCountryCode: {
                            countryCode: '',
                            countryCallingCode: ''
                        },
                        SSN: '',
                        alienNumber: '',
                        dateOfBirth: null,
                        placeOfBirth:null,
                        placeOfBirthDetails:null,
                        provinceOfBirth: null,
                        provinceOfBirthDetails: null,
                        locationOfBirth: null,
                        dateOfMarriage:null,
                        countryOfCitizenship:null,
                        countryOfCitizenshipDetails:null,
                            dateOfMarriageEnd:null,
                              //Place of Marriage
                            countryOfMarriage: '',
                            countryOfMarriageDetails: null,
                            provinceOfMarriage: '',
                            provinceOfMarriageDetails: null,
                            locationOfMarriage: '',
                        maritalStatus:null,
                        maritalStatusDetails:null,
                        usCitizen:false,
                        citizenshipAcquiredThrough:null,
                        // citizenshipBirth:null,
                        // citizenshipNaturalization:null,
                        // citizenshipParents:null,
                        lawfulPerResident:false,
                        lprRequired:null,
                        certOfCitizenNumber:'',
                        dateReceivedLPR:null,
                        placeOfIssuance:null,
                        dateOfIssuance:null,
                        usCitizenOrLPR:null,
                        height: {
                            feet: '',
                            inches: ''
                        },
                        weight: null,
                        race: [],
                        eyeColor: null,
                        hairColor: null,
                        nationality:null,
                        dateFromUSCitizen:null,
                        filedOnAnyOtherPerOrPetitioner:false,
                        filedName: '',
                        filedPlace: '',
                        fileDateOfFiling: null, 
                        filedStatus: null,
                        //  newly added keys starts
                        fillThisPetiChildOrParentRelation: null,
                        fillThisBroOrSisRelatedByAdoption: null,
                        gainLawPermResidentThroughAdoption: null, 
                        lawFulPermanentResident:{
                            classOfAdmission:'',
                            dateOfAdmission:null
                        },
                        cityOfAdmission:'',
                        stateOfAdmission:null,
                        stateDetailsOfAdmission:null, 
                        dateOfProceedings:  null,
                        cityOfProceedings: '',
                        stateOfProceedings: null,
                        stateDetailsOfProceedings: null,
                        anyOtherElseFiledPetitionForBnf:null,
                        benfEverInImmigrationProceedings:null,
                        typeOfProceedings:null,
                        hasSubmitSepPetiForOtherRelation:null,
                        submitSupPetiForOtherRelative: [{
                            relative: null,
                            familyName: '',
                            givenName: '',
                            middleName: '',
                            relationShip: '',
                        }],
                        haveYouPrevFiledAnyPetitionForBnf: null,
                        bnfPrevPetitionInfo: {
                            familyName: '',
                            givenName: '',
                            middleName: '',
                            dateOfFiling:  null,
                            cityOfFiling: null,
                            stateOfFiling: null,
                            stateDetailsOfFiling: null,
                            status: '', // approved/denied/withdrawn
                        },
                        //  newly added keys ends 
                        addressOfLastNYears:[{
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                        }], 
                        addressOutsideUSMoreThanYear:[{
                        
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null,
                            startDate: null,
                            endDate: null,
                        }],
                        affidavitInfo: {
                            benfApplyAdjustStatus:null,
                            currentAnnualSalary: '',
                            nameOfEmployer: '',
                            currentPosition: '',
                            depositsInBankUSA: '',
                            reasonableValPersonalProperty: '',
                            haveMarketValInStocksAndBonds: null,
                            marketValInStocksAndBonds: '',
                            sumOfLifeInsurance: '',
                            cashSurrValOfLifeInsurance: '',
                            haveValOfRealEstate: null,
                            valOfRealEstate: '',
                            amountOfMortgageProperty: '',
                            addressPropertyIsLocate: '',
                            benfAdjustmentDocument:[]
                        },
                        anyOtherPersonEmployedInUS:null,
                        haveYouEverEmployed:null,
                        prevEmploymentInfo: [{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            currentEmployer: null,
                            salary:null,
                            payFrequency:null,
                        }],
                        prevEmploymentOutsideUS:[{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            currentEmployer: false  
                        }],
                        previouslyMarried:null,
                        previousSpouse:{
                            hasOtherNames:false,
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            maidenName:'',
                            marriageEndedDueTo:null,
                            marriageEndedOtherInfo:'',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            
                            dateOfMarriage:null,
                            dateOfMarriageEnd:null,
                              //Place of Marriage
                            countryOfMarriage: '',
                            countryOfMarriageDetails: null,
                            provinceOfMarriage: '',
                            provinceOfMarriageDetails: null,
                            locationOfMarriage: '',
    
                            //Place of Termination
                            countryOfMarriageTermination: '',
                            countryOfMarriageTerminationDetails: null,
                            provinceOfMarriageTermination: '',
                            provinceOfMarriageTerminationDetails: null,
                            locationOfMarriageTermination: '',
                            obtainPermResidenceThroughSpouse:false  
                          
                        },
                        fatherInfo: { 
                            name: '', 
                            firstName: '', 
                            middleName: '', 
                            lastName: '', 
                            hasOtherNames: false, 
                            otherNames: [{ 
                                _id: 0, 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                            }], 
                            dateOfBirth: null, 
                            countryOfBirth: '', 
                            countryOfBirthDetails: null, 
                            provinceOfBirth: '', 
                            provinceOfBirthDetails: null, 
                            locationOfBirth: '', 
                            currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                                isUSCitizen: false, 
                                dateFromUSCitizen: null, //["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                        },
                        motherInfo: { 
                            name: '',                    
                            firstName: '', 
                            middleName: '', 
                            lastName: '', 
                            hasOtherNames: false , 
                            otherNames: [{ 
                                _id: 0, 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                            }], 
                            dateOfBirth: null, 
                            countryOfBirth: '', 
                            countryOfBirthDetails: null, 
                            provinceOfBirth: '', 
                            provinceOfBirthDetails: null, 
                            locationOfBirth: '', 
                            currentAddress: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                            },
                            isUSCitizen: false, 
                            dateFromUSCitizen:null,// ["", ""],
                            nameAtBirth:{
                                firstName: '', 
                                middleName: '', 
                                lastName: '',
                            },
                            deceasedCity: '',
                            deceasedCityDetails:null,
                            deceasedDate: null,
                        },
                        dependentsInfo:{
                            spouse: {
                                gender:'',
                                relationship:'',
                                currentlyInUS:null,
                                hasSpouse:null,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                                dateOfBirth: null,
                                countryOfBirth: null,
                                countryOfBirthDetails: null,
                                provinceOfBirth: null,
                                provinceOfBirthDetails: null,
                                locationOfBirth: null,
                                alienNumber:'',
                                passportExpiryDate:null,
                                currentStatus: null,
                                currentStatusDetails: null,
                                currentAddress:{
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                            },
                            children:[{
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                                dateOfBirth: null,
                                countryOfBirth: null,
                                countryOfBirthDetails: null,
                                provinceOfBirth: null,
                                provinceOfBirthDetails: null,
                                locationOfBirth: null,
                                relationshipToYou:'',
                            }]
                        },
                        documents:{
                            photographs:[],
                            birthCertificate:[],
                            greenCard:[],
                            passport:[]
                        }
                        // replaced Fields
                    },
                    //GC 485 fields starts
                    
                    lcaRequested: false,
                    questionnaireFilled: false,
                    questionnaireFilled_temp: false,
                    lcaId: null,
                    statusId: 1,
                    status: 1,
                    questionnaireSent: true,
                    questionnaireInstructions: '',
                    assignOrSubmitRoleComment: '',
                    curWorkflowActivity: 'CREATE_PETITION',
                    nextWorkflowActivity: ['SUBMIT_BY_BENEFICIARY'],
                    relationships:['Son','Daughter']
                },
                currentTab: 'casedetails',
                countries: [],
                countriesWithoutUS:[],
                bfeprovinceStates: [],
                statesOfMarriage:[],
                usastates: [],
                visastatuses: [],
                marital_statuses: [],
                education_types: [],
                questionnaireDetails: null,
                beneFiciaryDeytailsExists:false,
                showPrefillPopup: false,
                showBenProfileSyncPopup:false,
                latestPetition: null,
                featureDates: null,
                tabslist: [{
                        key: "casedetails",
                        name: "Personal Info"
                    }
    
                ],
                questionnairePreview: false,
                questionnairePreviewData:null,
                SuccessQuestionnaire: false,
                h4RequiredForChild: null,
                spouseModalForm: false,
                childModalForm: false,
                submiTing: false,
                comments: "",
                formerrors: {  msg: ""  },
                executionCompleted:true,
                startEligibleDate: new Date().setFullYear(new Date().getFullYear() - 18),
                selectedchild: 0,
                //ignoreItems:['maritalStatusDetails'],
                ignoreItems:['addressOutsideUSMoreThanYear', 'addressOfLastNYears', 'bnfPrevPetitionInfo','stateDetailsOfProceedings','stateOfProceedings','stateOfAdmission','stateDetailsOfAdmission','submitSupPetiForOtherRelative', 'lawFulPermanentResident','secOrSubSequentExtnWithPtnr', 'stateOfLastEntryInUS','stateDetailsOfLastEntryInUS','height','firstExtnWithPtnr',"hasOtherNames",
                'otherNames','maritalStatusDetails','prevEmploymentInfo','educations','countryOfBirth','countryOfBirthDetails','immPetitionInfo','fatherInfo','motherInfo',
                'provinceOfBirth','provinceOfBirthDetails','countryOfCitizenship','countryOfCitizenshipDetails','homePhoneCountryCode','homePhoneNumber'
                ,'passportIssuedCountryDetails','passportIssuedCountry','education','dependentsInfo','affidavitInfo', 'documents'
                ,'cellPhoneNumber','cellPhoneCountryCode','curNonImmigrantVisaStatus','curNonImmigrantVisaStatusDetails','beneficiaryCnfmNumber','capType','serviceCenterName'
                ,'countryOfMarriage','countryOfMarriageDetails','provinceOfMarriage','provinceOfMarriageDetails','previousSpouse','prevEmploymentOutsideUS','associations'],
                detailsItemsList:[
                    {
                        key:'stateOfAdmission',
                        detailsKey:'stateDetailsOfAdmission',
                        section:'sponsorInfo',
                        type:'details'
                    },
                    {
                        key:'stateOfFiling',
                        detailsKey:'stateDetailsOfFiling',
                        section:'sponsorInfo.bnfPrevPetitionInfo',
                        type:'details'
                    },
                    {
                        key:'stateOfProceedings',
                        detailsKey:'stateDetailsOfProceedings',
                        section:'sponsorInfo',
                        type:'details'
                    },
                    {
                        key:'countryOfMarriage',
                        detailsKey:'countryOfMarriageDetails',
                        section:'sponsorInfo.previousSpouse',
                        type:'details'
                    },
                    {
                        key:'provinceOfMarriage',
                        detailsKey:'provinceOfMarriageDetails',
                        section:'sponsorInfo.previousSpouse',
                        type:'details'
                    },
                    {
                        key:'countryOfMarriageTermination',
                        detailsKey:'countryOfMarriageTerminationDetails',
                        section:'sponsorInfo.previousSpouse',
                        type:'details'
                    },
                    {
                        key:'provinceOfMarriageTermination',
                        detailsKey:'provinceOfMarriageTerminationDetails',
                        section:'sponsorInfo.previousSpouse',
                        type:'details'
                    },
                    {
                        key:'countryOfBirth',
                        detailsKey:'countryOfBirthDetails',
                        section:'sponsorInfo.fatherInfo',
                        type:'details'
                    },
                    {
                        key:'provinceOfBirth',
                        detailsKey:'provinceOfBirthDetails',
                        section:'sponsorInfo.fatherInfo',
                        type:'details'
                    },
                    {
                        key:'deceasedCity',
                        detailsKey:'deceasedCityDetails',
                        section:'sponsorInfo.fatherInfo',
                        type:'details'
                    },
                    {
                        key:'countryOfBirth',
                        detailsKey:'countryOfBirthDetails',
                        section:'sponsorInfo.motherInfo',
                        type:'details'
                    },
                    {
                        key:'provinceOfBirth',
                        detailsKey:'provinceOfBirthDetails',
                        section:'sponsorInfo.motherInfo',
                        type:'details'
                    },
                    {
                        key:'deceasedCity',
                        detailsKey:'deceasedCityDetails',
                        section:'sponsorInfo.motherInfo',
                        type:'details'
                    },
                    ////////// 
                    {
                        key:'maritalStatus',
                        detailsKey:'maritalStatusDetails',
                        section:'sponsorInfo',
                        type:'details'
                    },
                    {
                        key:'countryOfMarriage',
                        detailsKey:'countryOfMarriageDetails',
                        section:'sponsorInfo',
                        type:'details'   
                    },
                    {
                        key:'provinceOfMarriage',
                        detailsKey:'provinceOfMarriageDetails',
                        section:'sponsorInfo',
                        type:'details'
                    },
                    {
                        key:'curNonImmigrantVisaStatus',
                        detailsKey:'curNonImmigrantVisaStatusDetails',
                        section:'sponsorInfo',
                        type:'details'
                    },
                    {
                        key:'countryOfBirth',
                        detailsKey:'countryOfBirthDetails',
                        section:'sponsorInfo',
                        type:'details'
                    },
                    {
                        key:'provinceOfBirth',
                        detailsKey:'provinceOfBirthDetails',
                        section:'sponsorInfo',
                        type:'details'
                    },
                    {
                        key:'countryOfCitizenship',
                        detailsKey:'countryOfCitizenshipDetails',
                        section:'sponsorInfo',
                        type:'details'
                    },
                    {
                        key:'cellPhoneNumber',
                        detailsKey:'cellPhoneCountryCode',
                        section:'sponsorInfo',
                        type:'phone'
                    },
                    
                    {
                        key:'passportIssuedCountry',
                        detailsKey:'passportIssuedCountryDetails', 
                        section:'sponsorInfo',
                        type:'details'
                    },
                    
                    {
                        key:'countryOfBirth',
                        detailsKey:'countryOfBirthDetails',
                        section:'sponsorInfo.dependentsInfo.spouse',
                        type:'details'
                    },
                    {
                        key:'provinceOfBirth',
                        detailsKey:'provinceOfBirthDetails',
                        section:'sponsorInfo.dependentsInfo.spouse',
                        type:'details'
                    },
                ],
                prefillAction:false,
                spouse: {
                    gender:'',
                    relationship:'',
                    currentlyInUS:null,
                    hasSpouse:null,
                    name: '',
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    dateOfBirth: null,
                    countryOfBirth: null,
                    countryOfBirthDetails: null,
                    provinceOfBirth: null,
                    provinceOfBirthDetails: null,
                    locationOfBirth: null,
                    alienNumber:'',
                    passportExpiryDate:null,
                    currentStatus: null,
                    currentStatusDetails: null,
                    currentAddress:{
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: null,
                        zipcode: null
                    },
                },
                spouseIgnoreItems:['ssnFather','ssnMother','otherNames', 'maritalStatus','maritalStatusDetails','countryOfMarriage','countryOfMarriageDetails','provinceOfMarriage','provinceOfMarriageDetails',
                'height','fatherInfo','motherInfo','previousSpouse','prevEmploymentOutsideUS', 'stateOfLastEntryInUS','stateDetailsOfLastEntryInUS','countryOfBirth','prevEmploymentInfo','countryOfBirthDetails','passportIssuedCountryDetails','passportIssuedCountry','documents',
                'provinceOfBirth','provinceOfBirthDetails','countryOfCitizenship','countryOfCitizenshipDetails','phoneNumber','phoneCountryCode','associations'],
                previousSpouseIgnoreItems:['countryOfMarriage','countryOfMarriageDetails','provinceOfMarriage','provinceOfMarriageDetails','countryOfMarriageTermination',
                'countryOfMarriageTerminationDetails','provinceOfMarriageTermination','provinceOfMarriageTerminationDetails'],
                ignorePrefillItems:[
                    {
                        key:'nameDiffFromBirthCert',
                        section:'sponsorInfo',
                    },
                    {
                        key:'birthCertHaveNamePobDob',
                        section:'sponsorInfo',
                    },
                    {
                        key:'have2AffidavitsOfBirthFamily',
                        section:'sponsorInfo',
                    },
                    {
                        key:'hasOtherNames',
                        section:'sponsorInfo', 
                    },
                    {
                        key:'filedOnAnyOtherPerOrPetitioner',
                        section:'sponsorInfo',
                    },
                    {
                        key:'haveUSCitizenOrPermResident',
                        section:'sponsorInfo',
                    },
                    {
                        key:'citizenshipAcquiredThrough',
                        section:'sponsorInfo',
                    },
                    {
                        key:'lawfulPerResident',
                        section:'sponsorInfo',
                    },
                    {
                        key:'usCitizenOrLPR',
                        section:'sponsorInfo',
                    },
                    {
                        key:'previouslyMarried',
                        section:'sponsorInfo',
                    },
                    {
                        key:'haveMarketValInStocksAndBonds',
                        section:'sponsorInfo.affidavitInfo',
                    },
                    {
                        key:'haveValOfRealEstate',
                        section:'sponsorInfo.affidavitInfo',
                    },
                    {
                        key:'isUSCitizen',
                        section:'sponsorInfo.fatherInfo',
                    },
                    {
                        key:'isUSCitizen',
                        section:'sponsorInfo.motherInfo',
                    }, 
                    {
                        key:'hasOtherNames',
                        section:'sponsorInfo.fatherInfo',
                    },
                    {
                        key:'hasOtherNames',
                        section:'sponsorInfo.motherInfo',
                    }, 
                ],
                parentsIgnoreItems:['countryOfBirthDetails','countryOfBirth','provinceOfBirth','provinceOfBirthDetails','nameAtBirth','deceasedCityDetails','deceasedCity'],
                educationErrorMsg:"Seems you have not submitted bachelor's information. Please fill to continue",
                configDetails:null,
                prefillCountryInQuestionnaire:true,
                sponsorQuestionnaireKeys:[
                    'name', 'firstName', 'middleName', 'lastName', 'hasOtherNames', 
                    'otherNames', 'gender', 'email', 'nameDiffFromBirthCert', 'birthCertHaveNamePobDob', 'have2AffidavitsOfBirthFamily',
                    'currentAddress', 'mailingAddressIsSameAsAddress', 'address', 'cellPhoneNumber', 'cellPhoneCountryCode', 'SSN', 
                    'alienNumber', 'dateOfBirth', 'placeOfBirth', 'placeOfBirthDetails', 'provinceOfBirth', 'provinceOfBirthDetails', 
                    'locationOfBirth', 'maritalStatus', 'maritalStatusDetails', 'usCitizen', 'citizenshipBirth', 'citizenshipNaturalization',
                    'citizenshipParents', 'lawfulPerResident', 'lprRequired', 'certOfCitizenNumber', 'dateReceivedLPR', 'placeOfIssuance', 
                    'dateOfIssuance', 'usCitizenOrLPR', 'height', 'weight', 'race', 'eyeColor', 'hairColor', 'nationality', 'dateFromUSCitizen',
                    'filedOnAnyOtherPerOrPetitioner', 'filedName', 'filedPlace', 'fileDateOfFiling', 'filedStatus', 'affidavitInfo', 'prevEmploymentInfo',
                    'prevEmploymentOutsideUS', 'previousSpouse', 'fatherInfo', 'motherInfo', 'spouse', 'children', 'addressOutsideUSMoreThanYear', 'addressOfLastNYears'
                ],
                sponsorPrefillIgnoreKeys:['bnfPrevPetitionInfo','stateDetailsOfProceedings','stateOfProceedings','stateOfAdmission','stateDetailsOfAdmission', 'submitSupPetiForOtherRelative', 'lawFulPermanentResident', 'prevEmploymentInfo', 'prevEmploymentOutsideUS','dependentsInfo', 'fatherInfo', 'motherInfo', ,'countryOfBirth'
                    ,'countryOfBirthDetails', 'provinceOfBirth','provinceOfBirthDetails','countryOfCitizenship','countryOfCitizenshipDetails',
                    'curNonImmigrantVisaStatusDetails','curNonImmigrantVisaStatus','previousSpouse','affidavitInfo','countryOfMarriage',
                    'countryOfMarriageDetails',  'provinceOfMarriage', 'provinceOfMarriageDetails',
                ],
            };
        },
        computed: {
            getConsentVal(){
                let returnVal = '';
                if(this.consentChecked){
                    returnVal = 'consentChecked';
                }
                return returnVal;
            },
            getTermsVal(){
                let returnVal = '';
                if(this.termsAndConditionsChecked){
                    returnVal = 'termsAndConditionsChecked';
                }
                return returnVal;
            },
            getLabelContent(){
                let returnVal = '';
                if(this.contentCategory == 'consent'){
                    returnVal = 'Consent to Process Personal Data';
                }
                if(this.contentCategory == 'termsAndConditions'){
                    returnVal = 'Terms and Conditions';
                }
                return returnVal
            },
            concateName(){
                    let returnVal = ''

                        if(this.checkProperty(this.petition['beneficiaryInfo'],'firstName')){
                            returnVal = this.checkProperty(this.petition['beneficiaryInfo'],'firstName')
                        }
                        if(this.checkProperty(this.petition['beneficiaryInfo'],'middleName')){
                             returnVal = returnVal +' '+ this.checkProperty(this.petition['beneficiaryInfo'],'middleName')
                        }
                        if(this.checkProperty(this.petition['beneficiaryInfo'],'lastName')){
                            returnVal =  returnVal +' '+this.checkProperty(this.petition['beneficiaryInfo'],'lastName')
                        }
                        return returnVal
                },
            getTplSectionPrevious(){
                if(this.tplsection=='dependentsInfo.spouse'){
                return "dependentsInfo.spouse.previousSpouse"
                }else{
                    return this.tplsection;
                }
            },
            checkActiveTab(){
              return  _.findIndex(this.tabslist ,{"key":this.currentTab});
            },  
            getCaseName(){
                //petition.typeDetails.name
                let s =this.checkProperty(this.petition ,'typeDetails','name');
               if(s){
                s='Questionnaire for '+s;
                if( this.checkProperty(this.petition ,'subTypeDetails','name') ){
                    s=s+" <small>"+this.petition.subTypeDetails.name+"</small"
                }
                return s.replace(/(\d)/g, '<span class="number">$1</span>');
            }else{
                return '';
            }
    
            },
            gettotalDays() {
                var totaldays = 0;
                if(this.petition.beneficiaryInfo.priorPeriodOfStayInUS && this.checkProperty(this.petition['beneficiaryInfo'],'priorPeriodOfStayInUS','length')>0){
                    this.petition.beneficiaryInfo.priorPeriodOfStayInUS.forEach(function (item, index) {
                        if (item.noOfDays > 0) {
                            totaldays = totaldays + item.noOfDays;
        
                        }
                    })
                }
                return totaldays;
            },
            getIndexOfActivetab() {
                var $self = this;
                return _.findIndex(this.tabslist, (e) => {
                    return e.key == $self.currentTab;
                }) + 1;
            },
            actiontype() {
                if (this.getIndexOfActivetab == this.tabslist.length) {
                    if (this.petition.questionnaireFilled) {
                        return "Update";
                    }
                    if (!this.petition.questionnaireFilled) {
                        return "Review & Submit";
                    }
                    return "Submit";
                }
                return "Next";
            }
    
        },
        methods: {
            agreeTerms(categ){
                if(categ == 'consent'){
                    this.consentChecked=true;
                }
                if(categ == 'termsAndConditions'){
                    this.termsAndConditionsChecked=true
                }
                this.$modal.hide('showConsentContentPopup');
            },
            getConsentDetails(){
                let path = '/global/get-consent-content';
                let payLoad = {
                    tenantId:this.checkProperty( this.getUserData, 'tenantId')
                };
                this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((res)=>{
                    if(res){
                        if(res['consent']){
                            this.consentData = res['consent'];
                        }
                        if(res['termsAndConditions']){
                            this.termsAndConditionsData = res['termsAndConditions'];
                        }
                    }
                }).catch((err)=>{

                })
            },
            openConsentContent(category){
                this.getConsentDetails();
                let self = this;
                setTimeout(()=>{
                    self.contentCategory = category;
                    self.$modal.show('showConsentContentPopup')
                }, 1000)
            },
            clearDependenFields(val){
                if(['Mother','Father','Child'].indexOf(this.checkProperty(this.petition.sponsorInfo ,'filingThisPetitionerFor'))>-1){
                    this.petition.sponsorInfo.fillThisBroOrSisRelatedByAdoption = null;
                }
                if(['Sibling'].indexOf(this.checkProperty(this.petition.sponsorInfo ,'filingThisPetitionerFor'))>-1){
                    this.petition.sponsorInfo.fillThisPetiChildOrParentRelation = null;
                }
                if(['Spouse'].indexOf(this.checkProperty(this.petition.sponsorInfo ,'filingThisPetitionerFor'))>-1){
                    this.petition.sponsorInfo.fillThisPetiChildOrParentRelation = null;
                    this.petition.sponsorInfo.fillThisBroOrSisRelatedByAdoption = null;
                }
            },
            clearSepPetiForOtherRelation(){
                if(this.checkProperty(this.petition, 'sponsorInfo', 'hasSubmitSepPetiForOtherRelation') == false || !this.checkProperty(this.petition, 'sponsorInfo', 'hasSubmitSepPetiForOtherRelation') ){
                    this.petition['sponsorInfo'].submitSupPetiForOtherRelative = [{
                        relative: null,
                        familyName: '',
                        givenName: '',
                        middleName: '',
                        relationShip: '',
                    }]
                }
            },
            clearhaveYouPrevFiledAnyPetitionForBnf(){
                if(this.checkProperty(this.petition, 'sponsorInfo', 'haveYouPrevFiledAnyPetitionForBnf') == false || !this.checkProperty(this.petition, 'sponsorInfo', 'haveYouPrevFiledAnyPetitionForBnf') ){
                    this.petition['sponsorInfo'].bnfPrevPetitionInfo = {
                        familyName: '',
                        givenName: '',
                        middleName: '',
                        dateOfFiling:  null,
                        cityOfFiling: null,
                        stateOfFiling: null,
                        stateDetailsOfFiling: null,
                        status: ''
                    }
                }
            },
            clearUsandPrFields(val){
                if(val == 'permanent_resident'){
                    this.petition.sponsorInfo.usCitizen = null;
                    this.clearUsCitizenFields(false);
                }
                if(val == 'us_citizen'){
                    this.petition.sponsorInfo.lawfulPerResident = null;
                    this.clearPrResidentFields(false);
                }
            },
            clearUsCitizenFields(val){
                if(val == false){
                    this.petition.sponsorInfo.citizenshipAcquiredThrough = null;
                    this.petition.sponsorInfo.certOfCitizenNumber = null;
                    this.petition.sponsorInfo.placeOfIssuance = null;
                    this.petition.sponsorInfo.dateOfIssuance = null;
                }
            },
            clearPrResidentFields(val){
                if(val == false){
                    this.petition.sponsorInfo.lprRequired = null;
                    this.petition.sponsorInfo.dateReceivedLPR = null;
                    this.petition.sponsorInfo.usCitizenOrLPR = null;
                    this.petition.sponsorInfo.gainLawPermResidentThroughAdoption = null;
                    this.petition.sponsorInfo.lawFulPermanentResident.classOfAdmission = null;
                    this.petition.sponsorInfo.lawFulPermanentResident.dateOfAdmission = null;
                    this.petition.sponsorInfo.stateDetailsOfAdmission = null;
                    this.petition.sponsorInfo.cityOfAdmission = '';
                }
            },
            updateEmployementUs(category){
                let cat = category // 
                if(cat == 'Spouse'){
                    let vl = this.spouse.anyOtherPersonEmployedInUS;
                    if(vl){
                        setTimeout(()=>{
                            this.$refs['spouseEmploymentRef'].updateUsaCountry(vl);
                        },100)
                    }
                }
                if(cat == 'Child'){
                    let vl = this.petition.dependentsInfo.childrens[this.selectedchild].anyOtherPersonEmployedInUS;
                    if(vl){
                        setTimeout(()=>{
                            this.$refs['childEducationForm'].updateUsaCountry(vl);
                        },100);
                    }
                }
            },
            updateVerificationStatus(status=false){
                this.openGeneratePinPopUp =false;
                this.tokenVerified = status;
                this.init();

            },
           submitCase(callFromConform=false) {
                 let self =this;
                this.$validator.validateAll(this.currentTab + "form").then((result) => {
    
                    if (result) {
                        if(this.checkEducationTab()){
                            if (this.getIndexOfActivetab < this.tabslist.length) {
                                this.setActiveTab(this.tabslist[this.getIndexOfActivetab].key);
        
                                setTimeout(function () {
                                    document.getElementById("scrollableques").scrollTo({
                                        top: 0,
                                        left: 0,
                                        behavior: 'smooth'
                                    })
                                }, 500)
        
                            } 
                            else {
                                if((this.consentChecked && this.termsAndConditionsChecked && [50,51].indexOf(this.getUserRoleId)>-1&&this.checkProperty(this.configDetails, 'acceptConsentAndTAndC')) ||
                                 ([50,51].indexOf(this.getUserRoleId)<=-1||( 
                  [50, 51].indexOf(this.getUserRoleId) > -1 && 
                  !this.checkProperty(this.configDetails, 'acceptConsentAndTAndC')
                  ))){
                                    if (this.petition.questionnaireFilled) {
                                    
                                    // this.$vs.loading();   
                                    // this.saveCase(true, false);
                                     self.tempSave =true;
                                     self.showMessage = false
                                     this.benProfileDetails = _.cloneDeep(this.petition);
                                     this.toggleBenProfileCOnformPopUp(true);
                                    }
                                    else{          
                                        this.petition['sponsorInfo']['name'] = this.concateName
                                        this.setSameaddress(false);
                                        this.benProfileDetails = _.cloneDeep(this.petition);
                                        this.checkPreviousSpouse();
                                        this.callQuestionairePrefill();
                                        let temp_save =false;
                                        this.questionnairePreviewData = {
                                        submittedWithLink:false,
                                        petitionId: this.$route.params.itemId,
                                        userName: this.$store.state.user.name,
                                        typeName: this.petition.typeDetails.name,
                                        subTypeName: this.petition.subTypeDetails.name,
                                        subTypeDetails:this.petition.subTypeDetails,
                                        typeDetails: this.petition.typeDetails,
                                        action: temp_save ? "SPONSOR_INFO_UPDATE" : "SUBMIT_BY_SPONSOR",
                                        currentDate: moment().format("YYYY-MM-DD"),
                                        sponsorInfo:this.petition.sponsorInfo,
                                        // beneficiaryInfo: this.petition.beneficiaryInfo,
                                        // dependentsInfo: this.petition.dependentsInfo,
                                        // documents: this.petition.documents,
                                        // fatherInfo: this.petition.fatherInfo,
                                        // motherInfo: this.petition.motherInfo,
                                        temp_save: temp_save,
                                        questionnaireFilled: temp_save ? false : true
                                        };
                                        // if( this.checkProperty(this.petition['beneficiaryInfo'], 'prevH1bCaseStatus') && this.checkProperty(this.petition['beneficiaryInfo'], 'prevH1bCaseStatus', 'id')){
                                        //     this.questionnairePreviewData['beneficiaryInfo']['prevH1bCaseStatus'] = this.checkProperty(this.petition['beneficiaryInfo'], 'prevH1bCaseStatus', 'id');
                                        // }
                                        //this.questionnairePreviewData['noOfDaysStayInUS'] = this.gettotalDays;
                                        // if(!this.checkProperty(this.petition ,'permId') && this.checkProperty(this.petition ,'subTypeDetails' ,'id') ==16 && this.checkProperty(this.petition ,'jobDetails') ){
                                        //     this.questionnairePreviewData = Object.assign( this.questionnairePreviewData , { 'jobDetails': this.petition['jobDetails']} );
    
                                        // }
                                        // if(!this.checkCurrentUrl){
                                        //     this.questionnairePreviewData['submittedWithLink'] =true;
                                        // }
                                        this.questionnairePreview = true;
                                        
                                    
                                    }
                                }else{
                                    this.$validator.validateAll("consentTermsForm")
                                }
                                

                                
        
                            }
                        }
                        else{
                            this.showToster({
                                    message:  this.educationErrorMsg,
                                    isError: true,
                                });
                        }
                    } else {
                        this.validateandScroll();
                    }
                })
            },
            conformBenProfile(conform=false){
                this.toggleBenProfileCOnformPopUp(false);
                this.$vs.loading();
                if(conform){
                    this.updateBeneficiaryProfile();
                }
               
                this.saveCase(this.tempSave,this.showMessage);
            },
            toggleBenProfileCOnformPopUp(action=false){
                this.showBenProfileSyncPopup = action;

            },
            updateBeneficiaryProfile(){
                var postpetition = {
                    userId: this.checkProperty(this.petition,'userId'),
                    currentDate: moment().format("YYYY-MM-DD"),
                };
                if(_.has(this.benProfileDetails,'sponsorInfo')){
                    postpetition['sponsorInfo'] = this.benProfileDetails.sponsorInfo;
                }
                // if(_.has(this.benProfileDetails,'beneficiaryInfo')){
                //     postpetition['beneficiaryInfo'] = this.benProfileDetails.beneficiaryInfo;
                // }
                // if(_.has(this.benProfileDetails,'dependentsInfo')){
                //     postpetition['dependentsInfo'] = this.benProfileDetails.dependentsInfo;
                // }
                // if(_.has(this.benProfileDetails,'fatherInfo')){
                //     postpetition['fatherInfo'] = this.benProfileDetails.fatherInfo;
                // }
                // if(_.has(this.benProfileDetails,'motherInfo')){
                //     postpetition['motherInfo'] = this.benProfileDetails.motherInfo;
                // }
                // if(_.has(this.benProfileDetails,'documents')){
                //     postpetition['documents'] = this.benProfileDetails.documents;
                // }
                let path = '/beneficiary-profile/update-beneficiary-profile'
                this.$store.dispatch("commonAction", {data:postpetition,path:path}).then((res)=>{
                    this.showBenProfileSyncPopup = false;
                }).catch((err)=>{
                    
                })
            },
           
            emitUploadingAction(data){
                if(_.has(data,'docMainCategory')){
                    _.map(this[data['docMainCategory']],(item)=>{
                        if(item['fieldName'] == data['fieldName']){
                            item = Object.assign( item ,{ "fileUploading": false})
                            item['fileUploading'] = data['action'] 
                        }
                    })
                }
                if(_.has(data,'allFilesAreUploaded')){
                    if(data['allFilesAreUploaded'] && this.checkProperty(data,'uploadFIlesErrors', 'length') >0){
                        let joinedError = '';
                                if(data['uploadFIlesErrors'].length>0){
                                    joinedError = data['uploadFIlesErrors'].join(", ")
                                }
                        this.showToster({
                                        message:joinedError,
                                        isError: true,
                                    });

                    }

                }
                this.checkSubmitBtn(data)
            },
            checkSubmitBtn(data){
                this.documentUploading = false;
                if(_.has(data,'docMainCategory')){
                    _.forEach(this[data['docMainCategory']],(item)=>{
                        if(_.has(item,'fileUploading') && item['fileUploading']){
                            this.documentUploading = true;
                            return false;
                        }
                    })
                }
            },
            chnageMailingAddress(){
                if(this.checkProperty(this.petition,'beneficiaryInfo','currentlyInUS') && this.canRenderField('mailingAddressIsSameAsAddress',this.questionnaireDetails, false, 'beneficiaryInfo' ) 
                && this.canRenderField('currentAddress',this.questionnaireDetails, false, 'beneficiaryInfo' ) && this.canRenderField('address',this.questionnaireDetails, false, 'beneficiaryInfo' )
                && this.petition.beneficiaryInfo.mailingAddressIsSameAsAddress){
                    this.setSameaddress()
                }
            },
            addNyears(){
                let obj ={
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: {
                            _id: "61408c9ed01ea1248cdcf6b7",
                            id: 231,
                            name: "United States",
                            phoneCode: 1,
                            order: 1,
                            currencySymbol: "$",
                            currencyCode: "USD",
                            zipcodeLength: 5,
                            sortName: "united states",
                        },
                        zipcode: null,
                        startDate: null,
                        endDate: null,
                }
                this.petition.sponsorInfo['addressOfLastNYears'].push(obj);
                this.petition.sponsorInfo['addressOfLastNYears'] = _.cloneDeep( this.petition.sponsorInfo['addressOfLastNYears']);
            },
            removeNyears: function (index) {
                Vue.delete(this.petition.sponsorInfo.addressOfLastNYears, index);
            },
            removesubmitPetit(index){
                Vue.delete(this.petition.sponsorInfo.submitSupPetiForOtherRelative, index);
            },
            addSubmitPetit(){
                let obj ={
                    relative: null,
                    familyName: '',
                    givenName: '',
                    middleName: '',
                    relationShip: '',
                }
                this.petition.sponsorInfo['submitSupPetiForOtherRelative'].push(obj);
                this.petition.sponsorInfo['submitSupPetiForOtherRelative'] = _.cloneDeep( this.petition.sponsorInfo['submitSupPetiForOtherRelative']); 
            },
            addLastYearItem(){
                let obj ={
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: {
                            _id: "61408c9ed01ea1248cdcf6b7",
                            id: 231,
                            name: "United States",
                            phoneCode: 1,
                            order: 1,
                            currencySymbol: "$",
                            currencyCode: "USD",
                            zipcodeLength: 5,
                            sortName: "united states",
                        },
                        zipcode: null,
                        startDate: null,
                        endDate: null,
                }
                    this.petition.sponsorInfo['addressOutsideUSMoreThanYear'].push(obj);
                   this.petition.sponsorInfo['addressOutsideUSMoreThanYear'] = _.cloneDeep( this.petition.sponsorInfo['addressOutsideUSMoreThanYear']); 
            },
            removeLastYearItem: function (ind) {
                Vue.delete(this.petition.beneficiaryInfo.addressOutsideUSMoreThanYear, ind);
            },
            clearStartandEnddate(val,key,inder,position){
                if( this.petition.sponsorInfo[key] && this.checkProperty(this.petition.sponsorInfo[key],'length')>0){
                    let startDate = moment(this.petition.sponsorInfo[key][inder]['startDate']);
                    let endDate = moment(this.petition.sponsorInfo[key][inder]['endDate']);
                    if(!val && position == 'start'){
                        this.petition.sponsorInfo[key][inder]['endDate'] = null
                    }
                    if(val && position == 'start' && ( startDate.isAfter(endDate , 'day'))){
                        this.petition.sponsorInfo[key][inder]['endDate'] = null
                    }
                    if(position == 'end' && ( endDate.isBefore(startDate, 'day'))){
                        this.petition.sponsorInfo[key][inder]['startDate'] = null
                    }
                }
            },
            clearDependentField(obj){   
               if(obj['startDate']==null){
                   obj.endDate = null;
               }
               if(obj.startDate > obj.endDate){
                   obj.endDate = null;
               }
            },
            clearEndDate(obj){
               if(obj['startDate']==null){
                   obj.endDate = null;
               }
               if(obj.startDate > obj.endDate){
                   obj.endDate = null;
               }
            },
            disableCountryUsa(){
                if(this.checkProperty(this.petition,'highestDegreeList') && this.checkProperty(this.petition,'highestDegreeList','length')>0 && this.checkProperty(this.petition,'beneficiaryInfo','educations') && this.checkProperty(this.petition['beneficiaryInfo'],'educations','length')>0
                && this.petition.beneficiaryInfo.hasMasterDegreeInUS ){
                    _.forEach(this.petition.beneficiaryInfo.educations,(item)=>{
                        if(_.has(item,'highestDegree') && this.checkProperty(item,'highestDegree') == 6 && 
                        _.has(item,'address') && _.has(item['address'],'countryId')){
                            item['address']['countryId'] = 231
                            item['address']['countryDetails'] = { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" }
                        }
                    })
                }
            },
            removeCOuntryUSA(){
                if(!this.petition.beneficiaryInfo.hasMasterDegreeInUS && this.canRenderField('hasMasterDegreeInUS', this.questionnaireDetails ,false,'beneficiaryInfo')){
                    this.$refs['beneficairy_education'].removeCountryUs();     
                }
            },
            checkPreviousSpouse(){
                if((this.petition.sponsorInfo.previouslyMarried == null || this.petition.sponsorInfo.previouslyMarried == false)  && this.checkProperty(this.petition ,'sponsorInfo','maritalStatus') ==1){
                    this.petition.sponsorInfo.previousSpouse = {
                        hasOtherNames:false,
                        otherNames: [{
                            _id: 0,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                        }],
                        maidenName:'',
                        marriageEndedDueTo:null,
                        marriageEndedOtherInfo:'',
                        firstName: '',
                        middleName: '',
                        lastName: '',
                        dateOfBirth: null,
                        dateOfMarriage:null,
                        dateOfMarriageEnd:null,
                        countryOfMarriage: '',
                        countryOfMarriageDetails: null,
                        provinceOfMarriage: '',
                        provinceOfMarriageDetails: null,
                        locationOfMarriage: '',
                        countryOfMarriageTermination: '',
                        countryOfMarriageTerminationDetails: null,
                        provinceOfMarriageTermination: '',
                        provinceOfMarriageTerminationDetails: null,
                        locationOfMarriageTermination: '',
                        obtainPermResidenceThroughSpouse:false     
                    }
                }
            },
            getGlobalConfigDetails(){
                let postData ={}
                let path = 'global-config/details'
                this.$store.dispatch("commonAction", {data:postData,path:path})
                .then((response) =>{   
                this.defaultCountryCode = this.countrycode;            
                    if(this.checkProperty(response ,"config" )){
                        this.configDetails = this.checkProperty(response ,"config" );
                        if(_.has(this.configDetails ,"prefillCountryInQuestionnaire" )){
                            this.prefillCountryInQuestionnaire =this.configDetails['prefillCountryInQuestionnaire']
                        }
                    
                    }
                })
            },
            removeFields(){
                
                _.forEach(this.ignorePrefillItems,(item)=>{
                    let section = item['section'];
                    let key  = item['key'];
                    _.update(this.petition,section+'.'+key, () => null);
                })
                if(this.checkProperty(this.petition,'sponsorInfo','prevEmploymentInfo') && this.checkProperty(this.petition['sponsorInfo'],'prevEmploymentInfo','length')>0){
                    _.forEach(this.petition['sponsorInfo']['prevEmploymentInfo'],(item)=>{
                        if(_.has(item,'currentEmployer')){
                            item['currentEmployer'] = null;
                        }
                    })
                }
                if(this.prefillCountryInQuestionnaire == false){
                    if(this.checkProperty(this.petition, 'sponsorInfo', 'address') && this.checkProperty(this.petition['sponsorInfo'], 'address', 'countryId')){
                        this.petition.sponsorInfo.address['countryId'] = null;
                    }
                    if(this.checkProperty(this.petition, 'sponsorInfo', 'currentAddress') && this.checkProperty(this.petition['sponsorInfo'], 'currentAddress', 'countryId')){
                        this.petition.sponsorInfo.currentAddress['countryId'] = null;  
                    }
                    if(this.petition.sponsorInfo && this.checkProperty(this.petition.sponsorInfo,'prevEmploymentInfo') && this.checkProperty(this.petition.sponsorInfo,'prevEmploymentInfo','length')>0){
                        this.petition.sponsorInfo.prevEmploymentInfo[0].address['countryId'] = null;
                    }
                    if(this.checkProperty(this.petition['sponsorInfo'], 'dependentsInfo') && this.checkProperty(this.petition['sponsorInfo'], 'dependentsInfo', 'spouse') && 
                    this.checkProperty(this.petition['sponsorInfo']['dependentsInfo'], 'spouse', 'currentAddress') && this.checkProperty(this.petition['sponsorInfo']['dependentsInfo']['spouse'], 'currentAddress', 'countryId')){
                        this.petition.sponsorInfo.dependentsInfo.spouse['currentAddress']['countryId'] = null;
                    }
                }
                setTimeout(()=>{
                    this.$validator.reset();
                })
                
            },
            checkCurrentlyInUsa(){
                if(this.canRenderField('currentlyInUS',this.questionnaireDetails, false, 'beneficiaryInfo' ) && !this.checkProperty(this.petition,'beneficiaryInfo','currentlyInUS')){
                    this.petition.beneficiaryInfo.curNonImmigrantVisaStatusDetails = null
                    this.petition.beneficiaryInfo.curNonImmigrantVisaStatus  = null
                    this.petition.beneficiaryInfo.isDSExpiryDate = null
                    this.petition.beneficiaryInfo.curVisaExpiryDate = null
                    this.petition.beneficiaryInfo.I94 = null
                    this.petition.beneficiaryInfo.isI94DSExpiryDate = null
                    this.petition.beneficiaryInfo.I94ExpiryDate = null
                    this.petition.beneficiaryInfo.sevisNumber = null
                    this.petition.beneficiaryInfo.eadNumber = null
                    this.petition.beneficiaryInfo.address ={
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: null,
                        zipcode: null
                    }
                }
            },
            checkDependentsInfo(){
                if(this.petition.beneficiaryInfo && _.has(this.petition['beneficiaryInfo'],'hasAnyDependetsinUStoFileH4') && !this.checkProperty(this.petition,'beneficiaryInfo','hasAnyDependetsinUStoFileH4') && this.canRenderField('hasAnyDependetsinUStoFileH4',this.questionnaireDetails,false ,'beneficiaryInfo')){
                    this.petition['dependentsInfo'] = {
                        spouse: {
                            sevisNumber: null,
                            eadNumber: null,
                            haveYouEverTravelledToUS:null,
                            isDSExpiryDate:false,
                            isI94DSExpiryDate:false,
                            relationship: '',
                            saved: false,
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            passportIssuedNumber: null,
                            alienNumber: '',
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                payFrequency:null,
                                salary: null,
                                currentEmployer: null
                            }],
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                departedNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                visaStatus: null
                            }],
                            dateFromWhichResideInUs:null,
                            caseIssuedDate: null,
                            caseExpiryDate: null,
                            placeOfCaseIssued: '',
                            mailingAddressIsSameAsAddress:false,
                            stateOfLastEntryInUS: '',
                            stateDetailsOfLastEntryInUS: null,
                            placeOfLastEntryInUS: '',
                            firstArrivalDate: null,
                            lastArrivalDate: null,
                            allIssuedpassportData: [{
                                countryId: '',
                                countryDetails: null,
                                number: '',
                                issuedDate: null,
                                expiryDate: null 
                            }],
                            currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            height: {
                            feet: '',
                            inches: ''
                            },
                            weight: null,
                            race: [],
                            eyeColor:null,
                            hairColor: null,
                            educations: [{
                            _id: 0,
                            name: null,
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            highestDegree: null,
                            highestDegreeDetails: null,
                            majorFieldOfStudy: null,
                            attendedFrom: null,
                            attendedTo: null,
                            graduatedYear: null,
                            degreereceived: null,
                            isAccredited: null,
                            isForProfit: null
                            }],
                            prevEmploymentInfo: [{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            currentEmployer: false
                            }],
                            prevEmploymentOutsideUS:[{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                currentEmployer: false  
                            }],
                            previousSpouse:{
                            hasOtherNames:false,
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            maidenName:'',
                            marriageEndedDueTo:null,
                            marriageEndedOtherInfo:'',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            dateOfBirth: null,
                            dateOfMarriage:null,
                            dateOfMarriageEnd:null,
    
                              //Place of Marriage
                            countryOfMarriage: '',
                            countryOfMarriageDetails: null,
                            provinceOfMarriage: '',
                            provinceOfMarriageDetails: null,
                            locationOfMarriage: '',
    
                            //Place of Termination
                            countryOfMarriageTermination: '',
                            countryOfMarriageTerminationDetails: null,
                            provinceOfMarriageTermination: '',
                            provinceOfMarriageTerminationDetails: null,
                            locationOfMarriageTermination: '',
                            obtainPermResidenceThroughSpouse:false  
                          
                            },
                            addressOfLastNYears:[{
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                            }], 
                            addressOutsideUSMoreThanYear:[{
                            
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                            }],
                            dateOfLastEntryInUS:null,
                            dateOfMarriage: null, 
                            dateOfMarriageEnd: null, 
                            countryOfMarriage: '', 
                            countryOfMarriageDetails: null, 
                            provinceOfMarriage: '', 
                            provinceOfMarriageDetails: null, 
                            locationOfMarriage: '',
                            currentSpouseName: '',
                            maritalStatus : '', 
                            maritalStatusDetails: null,
                            curNonImmigrantVisaStatus: '', 
                            associations:[ {
                                name:'', 
                                address:{
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                },
                                startDate: null,
                                endDate:null,
                                natureofAssociations:'',
                            }],

                            isVisaDenieedTOUS:false,
                            visaDeniedReason:'',
                            haveYoueverPresntUnlawfully:false,
                            presntUnlawfullyReason:'',
                            haveYouEverReceivedPublicAssistendeInUS:false,
                            haveYouEverlikelyReceivePublicAssistendeInUS:false,
                            everAppliedAOSInUS: false, 
                            appliedAOSInUSDocs:[],
                            haveYouArrestedBefore:false,
                            haveYouArrestedBeforeDocs:[], 
                            doesBirthRegistered:false, 
                            curNonImmigrantVisaNumber:'',
                            enterInUSUnderCaseWaiverProgram: false,
                            inspectedByAnyImmOfficer: false, 
                            issuedAnyEADFromUSCIS: false, 
                            hasPermResidencyInOtherCountry: false, 
                            permResidencyCountryId: '', 
                            passportIssuedDate: null,
                            permResidencyCountryDetails: null,
                            

                            h4Required: null,
                            h4EADRequired: null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            email: '',
                            phoneNumber: '',
                            phoneCountryCode: {
                                countryCode: '',
                                countryCallingCode: ''
                            },
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            currentStatusDetails: null,
                            statusExpiryNumber: null,
                            SSN: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            applyingWithYou:false,
                            classification:'',
                            nameDiffFromBirthCert:false,
                            i140PriorityDate:null,
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            fatherInfo: { 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: false, 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                                isUSCitizen: false, 
                                dateFromUSCitizen: null, //["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            },
                            motherInfo: { 
                                name: '',                    
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: false , 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                                },
                                isUSCitizen: false, 
                                dateFromUSCitizen:null,// ["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            }, 
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                formI797: [],
                                formI20: [],
                                payStubs: [],
                                marriageCertificate: [],
                                noticeOfApprovalOfH1Status: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
                            //i140
                            adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
    
                        },
                        childrens: [{
                            sevisNumber: null,
                            eadNumber: null,
                            isDSExpiryDate:false,
                            isI94DSExpiryDate:false,
                            email: '',
                            phoneNumber: '',
                            phoneCountryCode: {
                            countryCode: '',
                            countryCallingCode: ''
                            },
                            saved: false,
                            relationship: '',
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            alienNumber: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: {
                                    id: null,
                                    name: null,
                                    stateId: null,
                                    countryId: null
                                },
                                stateId: null,
                                stateDetails: {
                                    id: null,
                                    name: null,
                                    countryId: null
                                },
                                countryId: null,
                                countryDetails: {
                                    id: null,
                                    name: null,
                                    shortName: null,
                                    phoneCode: null,
                                    countryId: null,
                                    currencySymbol: null,
                                    currencyCode: null,
                                    zipcodeLength: null
                                },
                                zipcode: null
                            },
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: {
                                    id: null,
                                    name: null,
                                    stateId: null,
                                    countryId: null
                                },
                                stateId: null,
                                stateDetails: {
                                    id: null,
                                    name: null,
                                    countryId: null
                                },
                                countryId: null,
                                countryDetails: {
                                    id: null,
                                    name: null,
                                    shortName: null,
                                    phoneCode: null,
                                    countryId: null,
                                    currencySymbol: null,
                                    currencyCode: null,
                                    zipcodeLength: null
                                },
                                zipcode: null
                            },
                            passportIssuedNumber: null,
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                departedNumber: null,
                                visaStatus: null
                            }],
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                payFrequency:null,
                                currentEmployer: null
                            }],
                            anyOtherPersonEmployedInUS:null,
                            haveYouEverEmployed:null,
                            lastArrivalDate:null,
                            stateOfLastEntryInUS: '',
                            stateDetailsOfLastEntryInUS: null,
                            placeOfLastEntryInUS: '',
                            h4Required: null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            statusExpiryNumber: null,
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                birthCertificate: [],
                                approvalNotice: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
    
                             //i140
                             adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
                        }]
                    };
                    this.spouse = {
                            sevisNumber: null,
                            eadNumber: null,
                            isI94DSExpiryDate:false,
                            isDSExpiryDate:false,
                            anyOtherPersonEmployedInUS:null,
                            haveYouEverEmployed:null,
                            relationship: '',
                            saved: false,
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            passportIssuedNumber: null,
                            alienNumber: '',
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            stateDetailsOfLastEntryInUS:null,
                            stateOfLastEntryInUS:null,
                            lastArrivalDate:null,
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                payFrequency:null,
                                currentEmployer: null
                            }],
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                departedNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                visaStatus: null
                            }],
    
                            h4Required: null,
                            h4EADRequired: null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            email: '',
                            cellPhoneNumber:'',
                    cellPhoneCountryCode: {
                        countryCode: '',
                        countryCallingCode: ''
                    },
                            phoneNumber: '',
                            phoneCountryCode: {
                                countryCode: '',
                                countryCallingCode: ''
                            },
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            currentStatusDetails: null,
                            statusExpiryNumber: null,
                            SSN: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                formI797: [],
                                formI20: [],
                                payStubs: [],
                                marriageCertificate: [],
                                noticeOfApprovalOfH1Status: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
                            //i140
                            adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
    
                    }
                }
            },
            removeDependentsInfo(){
                if((this.petition.beneficiaryInfo && _.has(this.petition['beneficiaryInfo'],'hasAnyDependetsinUStoFileH4') && !this.checkProperty(this.petition,'beneficiaryInfo','hasAnyDependetsinUStoFileH4') && this.canRenderField('hasAnyDependetsinUStoFileH4',this.questionnaireDetails,false ,'beneficiaryInfo'))||
                (!this.canRenderField('h4Required',this.questionnaireDetails ,false,'dependentsInfo.childrens') && !this.canRenderField('h4Required',this.questionnaireDetails ,false,'dependentsInfo.spouse'))||
                (this.petition.beneficiaryInfo && this.petition.beneficiaryInfo.maritalStatusDetails && this.petition.beneficiaryInfo.maritalStatusDetails.id == 1) ||
                (this.petition.beneficiaryInfo && !this.petition.beneficiaryInfo.maritalStatusDetails)){
                    delete this.benProfileDetails['dependentsInfo']
                    this.spouse = {
                            sevisNumber: null,
                            eadNumber: null,
                            isI94DSExpiryDate:false,
                            isDSExpiryDate:false,
                            anyOtherPersonEmployedInUS:null,
                            haveYouEverEmployed:null,
                            relationship: '',
                            saved: false,
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            passportIssuedNumber: null,
                            alienNumber: '',
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            stateDetailsOfLastEntryInUS:null,
                            stateOfLastEntryInUS:null,
                            lastArrivalDate:null,
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                payFrequency:null,
                                currentEmployer: null
                            }],
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                departedNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                visaStatus: null
                            }],
    
                            h4Required: null,
                            h4EADRequired: null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            email: '',
                            cellPhoneNumber:'',
                    cellPhoneCountryCode: {
                        countryCode: '',
                        countryCallingCode: ''
                    },
                            phoneNumber: '',
                            phoneCountryCode: {
                                countryCode: '',
                                countryCallingCode: ''
                            },
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            currentStatusDetails: null,
                            statusExpiryNumber: null,
                            SSN: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                formI797: [],
                                formI20: [],
                                payStubs: [],
                                marriageCertificate: [],
                                noticeOfApprovalOfH1Status: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
                            //i140
                            adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
    
                    }
                }else if(!this.canRenderField('h4Required',this.questionnaireDetails ,false,'dependentsInfo.childrens') || this.checkProperty(this.petition,'h4RequiredForChild') == false ||
                this.checkProperty(this.petition,'h4RequiredForChild') == null || this.checkProperty(this.petition,'h4RequiredForChild') == ''){
                    delete this.benProfileDetails['dependentsInfo']['childrens']
                }else if(!this.canRenderField('h4Required',this.questionnaireDetails ,false,'dependentsInfo.spouse') || this.checkProperty(this.petition['dependentsInfo'],'spouse','h4Required') == false ||
                    this.checkProperty(this.petition['dependentsInfo'],'spouse','h4Required') == null || this.checkProperty(this.petition['dependentsInfo'],'spouse','h4Required') == ''){
                    delete this.benProfileDetails['dependentsInfo']['spouse'];
                    this.spouse = {
                            sevisNumber: null,
                            eadNumber: null,
                            isI94DSExpiryDate:false,
                            isDSExpiryDate:false,
                            anyOtherPersonEmployedInUS:null,
                            haveYouEverEmployed:null,
                            relationship: '',
                            saved: false,
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            passportIssuedNumber: null,
                            alienNumber: '',
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            stateDetailsOfLastEntryInUS:null,
                            stateOfLastEntryInUS:null,
                            lastArrivalDate:null,
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                payFrequency:null,
                                currentEmployer: null
                            }],
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                departedNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                visaStatus: null
                            }],
    
                            h4Required: null,
                            h4EADRequired: null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            email: '',
                            cellPhoneNumber:'',
                    cellPhoneCountryCode: {
                        countryCode: '',
                        countryCallingCode: ''
                    },
                            phoneNumber: '',
                            phoneCountryCode: {
                                countryCode: '',
                                countryCallingCode: ''
                            },
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            currentStatusDetails: null,
                            statusExpiryNumber: null,
                            SSN: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                formI797: [],
                                formI20: [],
                                payStubs: [],
                                marriageCertificate: [],
                                noticeOfApprovalOfH1Status: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
                            //i140
                            adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
    
                    }
                }
            },
            checkDSExpireFields(){
                if(this.checkProperty(this.petition,'beneficiaryInfo','curNonImmigrantVisaStatusDetails') && !this.checkProperty(this.petition['beneficiaryInfo'],'curNonImmigrantVisaStatusDetails','id') ){
                    this.petition.beneficiaryInfo.isDSExpiryDate = false;
                }
            },
            checkPrevEmployment(){
                if(this.canRenderField('anyOtherPersonEmployedInUS',this.questionnaireDetails,false ,'sponsorInfo') && _.has(this.petition['sponsorInfo'],'anyOtherPersonEmployedInUS') && !this.checkProperty(this.petition['sponsorInfo'],'anyOtherPersonEmployedInUS')  ){
                    this.petition['beneficiaryInfo']['prevEmploymentInfo'] = [{
                        _id: 0,
                        employerName: '',
                        address: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        businessType: null,
                        jobTitle: null,
                        jobDuties: null,
                        startDate: null,
                        endDate: null,
                        currentEmployer: false,
                        salary:null,
                        payFrequency:null,
                    }]
                }
            },
            mamageVisaStatusDocuments(){
               let tempDocs  =_.cloneDeep( this.bendocslist );
               this.bendocslist =[];
            let tpDocs = [
                {
                    required: false,
                    key: "formI797H4ApprovalNotice",
                    fieldName: 'formI797H4ApprovalNotice',
                    label: "Form I-797 H4 approval notice if applicable"
                },
                {
                    required: false,
                    key: "h4Ead",
                    fieldName: 'h4Ead',
                    label: "H4 EAD if applicable"
                },
                {
                    required: false,
                    key: "marriageCertificate",
                    fieldName: 'marriageCertificate',
                    label: "Marriage Certificate (if spouse is on H-1B, L-1, or F-1 status) "
                },
                {
                    required: false,
                    key: "formI797H1BApprovalNoticePrinNonCtzn",
                    fieldName: 'formI797H1BApprovalNoticePrinNonCtzn',
                    label: "Form I-797 H-1B approval notice of Principal Non-citizen"
                },
                {
                    required: false,
                    key: "passportOfPrinNonCtzn",
                    fieldName: 'passportOfPrinNonCtzn',
                    label: "Passport of Principal Non-citizen- First page with photo, Visa page and last page with address"
                },
                {
                    required: false,
                    key: "last3MonthsPayslipsOfPrinNonCtzn",
                    fieldName: 'last3MonthsPayslipsOfPrinNonCtzn',
                    label: "Last 3 months pay statements of Principal Non-citizen"
                },
            ];
         //5 ---H1b , H4---7
                if( this.checkProperty( this.petition,'beneficiaryInfo','curNonImmigrantVisaStatus') ==7){
                    _.forEach(tpDocs , (doc)=>{
                        let isExist = _.find(tempDocs ,{"key":doc['key']});
                        if(!isExist){
                            tempDocs.push(doc);
                        }

                    });
                }else{

                    // let isExist = _.find(tempDocs ,{"key":'marriageCertificate'});
                    // if(!isExist){

                    //     tempDocs.push( { required: false,  key: "marriageCertificate", fieldName: 'marriageCertificate', label: "Marriage Certificate (if spouse is on H-1B, L-1, or F-1 status) " });

                    // }
                   
                let its =['formI797H4ApprovalNotice','h4Ead','formI797H1BApprovalNoticePrinNonCtzn','passportOfPrinNonCtzn','last3MonthsPayslipsOfPrinNonCtzn'];
                    tempDocs = _.filter(tempDocs ,(item)=>its.indexOf(item['key'])<=-1);

                    //documents
                    _.forEach(this.petition.documents ,(documents ,category)=>{
                        if(its.indexOf(category)>-1){
                            this.petition.documents[category] = [];

                        }

                    });
                    

                } 

                this.bendocslist =[];
                this.bendocslist =tempDocs;
            },
            questionnairePrefil(tplsection='sponsorInfo'){
                this.executionCompleted = false; 
                let questionnaireSection = tplsection;
                if(questionnaireSection == 'sponsorInfo' ){
                    _.forEach(this.petition[questionnaireSection], (item,key)=>{
                        if(!this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection) && this.ignoreItems.indexOf(key)<=-1){
                            this.petition[questionnaireSection][key] = _.cloneDeep(this.tempPetition[questionnaireSection][key]);
                            delete this.benProfileDetails[questionnaireSection][key]
                        }
                    })
                }
                if(questionnaireSection == 'lawFulPermanentResident' ){
                    _.forEach(this.petition['sponsorInfo'][questionnaireSection], (item,key)=>{
                        if(!this.canRenderField( key, this.questionnaireDetails ,false, 'sponsorInfo.lawFulPermanentResident')){
                            this.petition['sponsorInfo'][questionnaireSection][key] = _.cloneDeep(this.tempPetition['sponsorInfo'][questionnaireSection][key]);
                            delete this.benProfileDetails['sponsorInfo'][questionnaireSection][key]
                        }
                    })
                }
                if(questionnaireSection == 'submitSupPetiForOtherRelative' ){
                    // _.forEach(this.petition['sponsorInfo'][questionnaireSection], (item,key)=>{
                    //     if(!this.canRenderField( key, this.questionnaireDetails ,false, 'sponsorInfo.submitSupPetiForOtherRelative')){
                    //         this.petition['sponsorInfo'][questionnaireSection][key] = _.cloneDeep(this.tempPetition['sponsorInfo'][questionnaireSection][key]);
                    //         delete this.benProfileDetails['sponsorInfo'][questionnaireSection][key]
                    //     }
                    // })
                    if(this.checkProperty(this.petition['sponsorInfo'], questionnaireSection) && this.checkProperty(this.petition['sponsorInfo'], questionnaireSection,'length')>0){
                        _.forEach(this.petition['sponsorInfo']['submitSupPetiForOtherRelative'], (item,inder)=>{
                            _.forEach(item, (obj,key)=>{
                                if(!this.canRenderField( key, this.questionnaireDetails ,false, 'sponsorInfo.submitSupPetiForOtherRelative')){  
                                    item[key] = _.cloneDeep(this.tempPetition['sponsorInfo']['submitSupPetiForOtherRelative'][0][key]);
                                    delete this.benProfileDetails['sponsorInfo']['submitSupPetiForOtherRelative'][inder][key]
                                    
                                }
                            })
                        })     
                    }
                }
                if(questionnaireSection == 'bnfPrevPetitionInfo' ){
                    if(this.checkProperty(this.petition['sponsorInfo'], questionnaireSection)){
                        _.forEach(this.petition['sponsorInfo'][questionnaireSection], (item,key)=>{
                            if(!this.canRenderField( key, this.questionnaireDetails ,false, 'sponsorInfo.bnfPrevPetitionInfo') && ['stateOfFiling','stateDetailsOfFiling'].indexOf(key)<=-1){
                                this.petition['sponsorInfo'][questionnaireSection][key] = _.cloneDeep(this.tempPetition['sponsorInfo'][questionnaireSection][key]);
                                delete this.benProfileDetails['sponsorInfo'][questionnaireSection][key]
                            }
                        })
                    }
                }
                if(questionnaireSection == 'affidavitInfo' ){
                    let tempSection = 'sponsorInfo.affidavitInfo'
                    _.forEach(this.petition['sponsorInfo'][questionnaireSection], (item,key)=>{
                        if(!this.canRenderField( key, this.questionnaireDetails ,false, tempSection)){
                            this.petition['sponsorInfo']['affidavitInfo'][key] = _.cloneDeep(this.tempPetition['sponsorInfo']['affidavitInfo'][key]);
                            delete this.benProfileDetails['sponsorInfo']['affidavitInfo'][key]
                        }
                    })
                } //lawFulPermanentResident submitSupPetiForOtherRelative 'addressOutsideUSMoreThanYear', 'addressOfLastNYears'
                if(questionnaireSection == 'otherNames' ){
                    if(this.checkProperty(this.petition,'sponsorInfo') && this.checkProperty(this.petition,'sponsorInfo','otherNames')){
                        if(this.checkProperty(this.petition,'sponsorInfo') && this.checkProperty(this.petition,'sponsorInfo','otherNames') && this.checkProperty(this.petition['sponsorInfo'],'otherNames','length')>0 ){
                            if(!this.canRenderField( 'otherNames', this.questionnaireDetails ,false, 'sponsorInfo')){
                                this.petition['sponsorInfo']['otherNames'] = _.cloneDeep(this.tempPetition['sponsorInfo']['otherNames']);
                                delete this.benProfileDetails['sponsorInfo']['otherNames']
                            }
                        }else{
                            delete this.benProfileDetails['sponsorInfo']['otherNames']
                            this.petition['sponsorInfo']['otherNames'] = _.cloneDeep(this.tempPetition['sponsorInfo']['otherNames']);
                        }
                    }
                    if(this.checkProperty(this.petition['sponsorInfo'],'dependentsInfo') && this.checkProperty(this.petition['sponsorInfo']['dependentsInfo'],'spouse') && this.checkProperty(this.petition['sponsorInfo']['dependentsInfo']['spouse'],'otherNames')){
                        if( this.checkProperty(this.petition['sponsorInfo'],'dependentsInfo') && this.checkProperty(this.petition['sponsorInfo']['dependentsInfo'],'spouse') && this.checkProperty(this.petition['sponsorInfo']['dependentsInfo']['spouse'],'otherNames') && this.checkProperty(this.petition['sponsorInfo']['dependentsInfo']['spouse'],'otherNames','length')>0 ){
                            if(!this.canRenderField( 'otherNames', this.questionnaireDetails ,false, 'sponsorInfo.dependentsInfo.spouse')){
                                this.petition['sponsorInfo']['dependentsInfo']['spouse']['otherNames'] = _.cloneDeep(this.tempPetition['sponsorInfo']['dependentsInfo']['spouse']['otherNames']);
                                delete this.benProfileDetails['sponsorInfo']['dependentsInfo']['spouse']['otherNames']
                            }
                        }else{
                            delete this.benProfileDetails['sponsorInfo']['dependentsInfo']['spouse']['otherNames']
                            this.petition['sponsorInfo']['dependentsInfo']['spouse']['otherNames'] = _.cloneDeep(this.tempPetition['sponsorInfo']['dependentsInfo']['spouse']['otherNames']);
                        }
                    }
                   
                }
                if(questionnaireSection == 'detailsItemsList' ){
                    _.forEach(this.detailsItemsList, (item)=>{
                        let tempSection = item['section']
                        let tempKey = item['key']
                        let tempdetailsKey = item['detailsKey']
                        let tempType = item['type']
                        if(tempType == 'phone'){
                            if(tempSection == 'sponsorInfo'){
                                if(!this.canRenderField( tempKey, this.questionnaireDetails ,false, tempSection)){
                                    this.petition[tempSection][tempKey] = null;
                                    this.petition[tempSection][tempdetailsKey] = {
                                        countryCode: '',
                                        countryCallingCode: ''
                                    };
                                    delete this.benProfileDetails[tempSection][tempKey]
                                    delete this.benProfileDetails[tempSection][tempdetailsKey]
                                }
                            }
                            if(tempSection == 'sponsorInfo.dependentsInfo.spouse'){
                                if(!this.canRenderField( tempKey, this.questionnaireDetails ,false, tempSection)){
                                    this.petition['sponsorInfo']['dependentsInfo']['spouse'][tempKey] = null;
                                    this.petition['sponsorInfo']['dependentsInfo']['spouse'][tempdetailsKey] = {
                                        countryCode: '',
                                        countryCallingCode: ''
                                    };
                                    delete this.benProfileDetails['sponsorInfo']['dependentsInfo']['spouse'][tempKey]
                                    delete this.benProfileDetails['sponsorInfo']['dependentsInfo']['spouse'][tempdetailsKey]
                                }
                            }
                        }else{
                            if(tempSection == 'sponsorInfo'){
                                if(!this.canRenderField( tempKey, this.questionnaireDetails ,false, tempSection)){
                                    this.petition[tempSection][tempKey] = null;
                                    this.petition[tempSection][tempdetailsKey] = null;
                                    delete this.benProfileDetails[tempSection][tempKey]
                                    delete this.benProfileDetails[tempSection][tempdetailsKey]
                                }
                            }
                            if(tempSection == 'sponsorInfo.dependentsInfo.spouse'){
                                if(!this.canRenderField( tempKey, this.questionnaireDetails ,false, tempSection)){
                                    this.petition['sponsorInfo']['dependentsInfo']['spouse'][tempKey] = null;
                                    this.petition['sponsorInfo']['dependentsInfo']['spouse'][tempdetailsKey] = null;
                                    // delete this.benProfileDetails['sponsorInfo']['dependentsInfo']['spouse'][tempKey]
                                    // delete this.benProfileDetails['sponsorInfo']['dependentsInfo']['spouse'][tempdetailsKey]
                                }
                            }
                        }
                    })
                }
                if(questionnaireSection == 'height' ){
                    _.forEach(this.petition['sponsorInfo']['height'], (item,key)=>{
                        if(!this.canRenderField( key, this.questionnaireDetails ,false, 'sponsorInfo.height')){
                            delete this.benProfileDetails['sponsorInfo']['height'][key]
                            this.petition['sponsorInfo']['height'][key] = _.cloneDeep(this.tempPetition['sponsorInfo']['height'][key]);
                        }
                    })
                }
                if(questionnaireSection == 'addressOutsideUSMoreThanYear' || questionnaireSection =='addressOfLastNYears'){
                    let tempSection = 'sponsorInfo.addressOutsideUSMoreThanYear';
                    if(questionnaireSection == 'addressOfLastNYears'){
                        tempSection = 'sponsorInfo.addressOfLastNYears';
                    }
                    if(!this.canRenderField( questionnaireSection, this.questionnaireDetails ,false, tempSection)){
                        this.petition['sponsorInfo'][questionnaireSection] = _.cloneDeep(this.tempPetition['sponsorInfo'][questionnaireSection])
                        delete this.benProfileDetails['sponsorInfo'][questionnaireSection] 
                    } 
                }
                if(questionnaireSection == 'prevEmploymentInfo' || questionnaireSection =='prevEmploymentOutsideUS'){
                    let tempSection = 'sponsorInfo.prevEmploymentInfo';
                    if(questionnaireSection == 'prevEmploymentOutsideUS'){
                        tempSection = 'sponsorInfo.prevEmploymentOutsideUS';
                    }
                    if(this.canRenderField( questionnaireSection, this.questionnaireDetails ,false, tempSection)){
                        if(this.checkProperty(this.petition['sponsorInfo'], questionnaireSection) && this.checkProperty(this.petition['sponsorInfo'], questionnaireSection, 'length')>0 ){
                            _.forEach(this.petition['sponsorInfo'][questionnaireSection], (item,inder)=>{
                                _.forEach(item, (obj,key)=>{
                                    if(!this.canRenderField( key, this.questionnaireDetails ,false, tempSection) && ['graduatedDate','highestDegreeDetails'].indexOf(key)<=-1){
                                        item[key] = _.cloneDeep(this.tempPetition['sponsorInfo'][questionnaireSection][0][key]);
                                        delete this.benProfileDetails['sponsorInfo'][questionnaireSection][inder][key]
                                    }
                                })
                            }) 
                        } 
                    }else{
                       this.petition['sponsorInfo'][questionnaireSection] = _.cloneDeep(this.tempPetition['sponsorInfo'][questionnaireSection])
                       delete this.benProfileDetails['sponsorInfo'][questionnaireSection] 
                    }  
                }
                if(questionnaireSection == 'sponsorInfo.documents'){
                    if(questionnaireSection == 'sponsorInfo.documents' && this.checkProperty(this.petition['sponsorInfo'], 'documents')){
                        _.forEach(this.petition['sponsorInfo']['documents'], (item,key)=>{
                            if(!this.canRenderField( key, this.questionnaireDetails ,false, 'sponsorInfo.documents')){
                                this.petition['sponsorInfo']['documents'][key] = [];
                                delete this.benProfileDetails['sponsorInfo']['documents'][key]
                                
                            }
                        })
                    }
                }
                if(questionnaireSection == 'dependentsInfo.spouse'){
                    let tempSection = 'sponsorInfo.dependentsInfo.spouse'
                    if(this.checkProperty(this.petition['sponsorInfo'], 'dependentsInfo', 'spouse')){
                        _.forEach(this.petition['sponsorInfo']['dependentsInfo']['spouse'], (item,key)=>{
                            if(!this.canRenderField( key, this.questionnaireDetails ,false, tempSection) && this.spouseIgnoreItems.indexOf(key)<=-1 ){
                                //delete this.benProfileDetails['sponsorInfo']['dependentsInfo']['spouse'][key]
                                this.petition['sponsorInfo']['dependentsInfo']['spouse'][key] = _.cloneDeep(this.tempPetition['sponsorInfo']['dependentsInfo']['spouse'][key]);
                            }
                        })
                    }
                   
                } 
                if(questionnaireSection == 'fatherInfo' || questionnaireSection == 'motherInfo'){
                    if(questionnaireSection == 'fatherInfo' || questionnaireSection == 'motherInfo'){
                        let tempSection = 'sponsorInfo.fatherInfo';
                        if(questionnaireSection == 'motherInfo'){
                            tempSection = 'sponsorInfo.motherInfo';
                        }
                        if(this.canRenderField( questionnaireSection, this.questionnaireDetails ,false, tempSection)){
                            _.forEach(this.petition['sponsorInfo'][questionnaireSection], (item,key)=>{
                                if(!this.canRenderField( key, this.questionnaireDetails ,false, tempSection) && this.parentsIgnoreItems.indexOf(key)<=-1 ){
                                    this.petition['sponsorInfo'][questionnaireSection][key] = _.cloneDeep(this.tempPetition['sponsorInfo'][questionnaireSection][key]);
                                    delete this.benProfileDetails['sponsorInfo'][questionnaireSection][key]
                                }
                            })
                        }else{
                            delete this.benProfileDetails['sponsorInfo'][questionnaireSection]
                            this.petition['sponsorInfo'][questionnaireSection] = _.cloneDeep(this.tempPetition['sponsorInfo'][questionnaireSection]);
                        }
                    }
                } 
                if(questionnaireSection == 'sponsorInfo.previousSpouse'){
                    if(questionnaireSection == 'sponsorInfo.previousSpouse'){
                        _.forEach(this.petition['sponsorInfo']['previousSpouse'], (item,key)=>{
                            if(!this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection) && this.previousSpouseIgnoreItems.indexOf(key)<=-1 ){
                                delete this.benProfileDetails['sponsorInfo']['previousSpouse'][key]
                                this.petition['sponsorInfo']['previousSpouse'][key] = _.cloneDeep(this.tempPetition['sponsorInfo']['previousSpouse'][key]);
                            }
                        })
                    }
                } 
                this.executionCompleted = true;
            },
            callQuestionairePrefill(){
                //this.checkCurrentlyInUsa();
                this.checkPrevEmployment();
                this.clearDependenFields();
                this.clearSepPetiForOtherRelation();
                this.clearhaveYouPrevFiledAnyPetitionForBnf();
                //this.checkDependentsInfo();

                this.questionnairePrefil('sponsorInfo');
                this.questionnairePrefil('addressOutsideUSMoreThanYear');
                this.questionnairePrefil('addressOfLastNYears');
                this.questionnairePrefil('otherNames');
                this.questionnairePrefil('detailsItemsList');
                this.questionnairePrefil('height'); 
                this.questionnairePrefil('affidavitInfo');
                this.questionnairePrefil('prevEmploymentInfo'); 
                this.questionnairePrefil('prevEmploymentOutsideUS');
                this.questionnairePrefil('sponsorInfo.documents');
                this.questionnairePrefil('dependentsInfo.spouse');
                this.questionnairePrefil('fatherInfo');
                this.questionnairePrefil('motherInfo');
                this.questionnairePrefil('lawFulPermanentResident');
                this.questionnairePrefil('submitSupPetiForOtherRelative');
                this.questionnairePrefil('sponsorInfo.previousSpouse');
                this.questionnairePrefil('bnfPrevPetitionInfo');

                //this.removeDependentsInfo();   
                
            },
            formatFullname(item){
                let returnVal = ''
                if(this.checkProperty(item,'name')){
                    return returnVal = this.checkProperty(item,'name')
                }
                else{
                    if(this.checkProperty(item,'firstName')){
                        returnVal = this.checkProperty(item,'firstName')
                    }
                    if(this.checkProperty(item,'middleName')){
                         returnVal = returnVal +' '+ this.checkProperty(item,'middleName')
                    }
                    if(this.checkProperty(item,'lastName')){
                        returnVal =  returnVal +' '+this.checkProperty(item,'lastName')
                    }
                    return returnVal
                }
            },
            upload(fils,) {
           
           let  model =_.cloneDeep(fils);
           this.value =[];
           var _current = this;
           // this.$vs.loading();
     
           let efiles = [];
           efiles = _.filter(model, (e) => {
             return e.url != null && e.url != "";
           });
           let nfiles = _.filter(model, (e) => {
             return e.url == null || e.url == undefined;
           });
     
           let mapper = nfiles.map(
             (item) =>
               (item = {
                 name: item.name,
                 file: item.file ? item.file : null,
                 url: item.url ? item.url : "",
                 path: item.path ? item.path : "",
                 status: true,
                 mimetype: item.type ? item.type : item.mimetype,
               })  
           );
           let tempFiles = [];
           if (mapper.length > 0) {
             this.uploading = true;
             let count = 0;
             mapper.forEach((doc, index) => {
               let formData = new FormData();
               formData.append("files", doc.file);
               formData.append("secureType", "private");
               formData.append("getDetails", true);
               count++;
     
               this.$store.dispatch("uploadS3File", formData).then((response) => {
                 response.data.result.forEach((urlGenerated) => {
                   //alert(JSON.stringify(urlGenerated))
                   //  this.CommentPayload.documents.push(urlGenerated)
                  // if (  _.has(urlGenerated, "name") &&  tempFiles.indexOf(urlGenerated["name"]) <= -1 ) {
                    let tempUrl = urlGenerated
                    tempUrl = Object.assign(tempUrl, { uploadedBy: this.checkProperty(this.getUserData, 'userId'), uploadedByName: this.checkProperty(this.getUserData, 'name'), uploadedByRoleId: this.getUserRoleId, uploadedByRoleName: this.checkProperty(this.getUserData, 'loginRoleName') });
                     tempFiles.push(urlGenerated["name"]);
                     this.petition['beneficiaryInfo']['marriageCertDocs'].push(tempUrl);
                //   }
                   doc.url = urlGenerated;
                   doc.path = urlGenerated;
                   doc["mimetype"] = urlGenerated["mimetype"];
                   doc["type"] = urlGenerated["mimetype"];
                   delete doc.file;
                   mapper[index] = doc;
                 });
                 if (index >= mapper.length - 1) {
                   this.uploading = false;
                   // _current.$vs.loading.close();
                 }
               });
             });
             if (efiles.length > 0) efiles.push(...mapper);
             //this.CommentPayload["documents"] = efiles
           }
            },
            remove(item, data, filindex) {
                data.splice(filindex, 1);
            },
            getMasterSocList(){
    
                let query = {};
                query["page"] = 1;
                query["perpage"] = 10000;
                query["matcher"] = { 
                    // "getInactiveListAlso": true
                    };
                query["category"] = "soc_codes";
    
    
                this.$store
                .dispatch("getMasterData", query)
                .then((response) => {
                    this.masterSocList = response.list;
                
    
    
                //alert(this.perpage);
                })
                .catch(() => {
                this.masterSocList = [];
    
                });
    
            },
            setSameaddress(callFromChecckBox =true){
                
                    if(this.canRenderField('mailingAddressIsSameAsAddress',this.questionnaireDetails, false, 'sponsorInfo' ) 
                && this.petition.sponsorInfo.mailingAddressIsSameAsAddress){
                        this.petition.sponsorInfo['currentAddress'] = _.cloneDeep(this.petition.sponsorInfo['address']);
                    }else{
    

                        if(callFromChecckBox){
                        this.petition.sponsorInfo['currentAddress'] =  {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                        }
                        this.$refs['mailingAddresscomponent'].clearStatesList();
                    }
    
                    }
    
               
                
    
            },
            updatecellPhoneCountryCode(data){
                this.petition.sponsorInfo.cellPhoneCountryCode =data;
               
            },
            toggleSpouseForm() {
                if (this.spouse.saved) {
                } else {
                    this.spouse.hasSpouse = false
                    this.petition.sponsorInfo.dependentsInfo.spouse.hasSpouse = false;
                }
                this.spouseModalForm = false;
            },
            toggleChildForm() {
                var savedone = false;
                this.petition.dependentsInfo.childrens.forEach((element, index) => {
    
                    if (element.saved) {
                        savedone = true;
                    }
    
                });
                if (!savedone) {
                    this.petition.h4RequiredForChild = false;
                    this.petition.hasRequiredForChildren = false;
                    this.petition.dependentsInfo.childrens[0] = {
                        hasChildren: null
                    }
                }
    
                this.childModalForm = false;
            },
            editChildren(item, index) {
                this.childModalForm = true;
                this.selectedchild = index;
    
                         if(item){
                        var childocs = item.documents;
                        if(childocs && childocs.passport == null)  item.documents.passport =[];
                        if(childocs && childocs.visa == null)  item.documents.visa =[];
                        if(childocs && childocs.formI94 == null)  item.documents.formI94 =[];
                        if(childocs && childocs.birthCertificate == null)  item.documents.birthCertificate =[];
                        if(childocs && childocs.approvalNotice == null)  item.documents.approvalNotice =[];
                        if(childocs && childocs.approvalNoticeOfPrevH4 == null)  item.documents.approvalNoticeOfPrevH4 =[];
                        if(childocs && childocs.other == null)  item.documents.other =[];
                  }      
    
               
                this.$validator.reset();
            },
            submitChild() {
                this.$validator.validateAll("childInfoformmodal").then((result) => {
                    if (result) {
                        this.petition.sponsorInfo.dependentsInfo.childrens[this.selectedchild].saved = true;
                        var childres = []
                        this.petition.sponsorInfo.dependentsInfo.childrens.forEach((element, index) => {
                            if (element.saved && element.firstName != '' && element.firstName != null) {
                                childres.push(element)
                            }
                        });
                        this.petition.sponsorInfo.dependentsInfo.childrens = childres;
                        this.saveCase(true, true)
                    }
                    else{
                        const $ = JQuery;
                        if($('.text-danger:visible')){
                             $('.modal_cnt').scrollTop($('.text-danger:visible').first().parent().offset().top-30);
                        }
                    }
                })
    
            },
            addchildren() {
                this.petition.h4RequiredForChild = true;
                this.childH4(true)
            },
            childH4(addmore = false) {
                var _child = this.getChildObject();
                if (addmore) {
                    var savedone = false;
                    if(this.checkProperty(this.petition,'sponsorInfo', 'dependentsInfo') && this.checkProperty(this.petition['sponsorInfo'], 'dependentsInfo', 'children') && this.checkProperty(this.petition['sponsorInfo']['dependentsInfo'], 'children', 'length')>0){
                        this.petition.sponsorInfo.dependentsInfo.childrens.forEach((element, index) => {
                            if (element.saved) {
                                savedone = true;
                            }
                        });
                    }
                    if (savedone) {
                        /* If already saved children exists then push new object*/
                        var _childrens = this.petition.sponsorInfo.dependentsInfo.childrens;
                        _childrens.push(_child);
                        this.petition.sponsorInfo.dependentsInfo.childrens = _childrens;
                        this.petition.sponsorInfo.dependentsInfo.childrens[this.petition.sponsorInfo.dependentsInfo.childrens.length - 1].hasChildren = false;
                        this.selectedchild = this.petition.sponsorInfo.dependentsInfo.childrens.length - 1;
                        this.childModalForm = true;
                    } else {
                        var _childrens = [];
                        _childrens.push(_child)
                        this.petition.sponsorInfo.dependentsInfo.childrens = _childrens;
                        this.childModalForm = true;
                    }
                } else {
                    if (this.petition.hasRequiredForChildren) {
                        this.addchildren()
                    } else {
                        this.childModalForm = false;
                        var _childrens = [];
                        _childrens.push(_child)
                        this.petition.sponsorInfo.dependentsInfo.childrens = _childrens;
                        this.petition.sponsorInfo.dependentsInfo.childrens[0].hasChildren = false;
                    }
                }
    
                if (!this.petition.hasRequiredForChildren) {
                    this.petition.sponsorInfo.dependentsInfo.childrens = []
                    this.petition.sponsorInfo.dependentsInfo.childrens.push(_child)
                }
            },
            getSpouseObj(){
                let _spouse= {
                    gender:null,
                    relationship:'',
                    currentlyInUS:null,
                    hasSpouse:null,
                    name: '',
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    dateOfBirth: null,
                    countryOfBirth: null,
                    countryOfBirthDetails: null,
                    provinceOfBirth: null,
                    provinceOfBirthDetails: null,
                    locationOfBirth: null,
                    alienNumber:'',
                    passportExpiryDate:null,
                    currentStatus: null,
                    currentStatusDetails: null,
                    currentAddress:{
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: null,
                        zipcode: null
                    },
                }
                return _spouse
            },
            spouseH4() {
                let _spouse= this.getSpouseObj();

                if (this.checkProperty(this.petition, 'sponsorInfo') && this.checkProperty(this.petition, 'sponsorInfo', 'dependentsInfo') && this.checkProperty(this.petition['sponsorInfo'], 'dependentsInfo', 'spouse') && this.petition.sponsorInfo.dependentsInfo.spouse.hasSpouse) { 
                    if(this.latestPetition && _.has(this.latestPetition,'dependentsInfo') && this.checkProperty(this.latestPetition,'dependentsInfo') && this.checkProperty(this.latestPetition,'dependentsInfo','spouse')
                        && this.checkProperty(this.latestPetition['dependentsInfo'],'spouse','firstName') && this.prefillAction){
                        this.spouse = _.cloneDeep(this.latestPetition.dependentsInfo.spouse);  
                    }
                    else if(this.petition && _.has(this.petition,'sponsorInfo') && this.checkProperty(this.petition,'sponsorInfo') && this.checkProperty(this.petition['sponsorInfo'],'dependentsInfo','spouse')
                        && this.checkProperty(this.petition['sponsorInfo']['dependentsInfo'],'spouse','firstName') && this.prefillAction == false ){
                        this.spouse = _.cloneDeep(this.petition.sponsorInfo.dependentsInfo.spouse);
                        if(!_.has(this.spouse, 'gender')){
                           this.spouse['gender'] = '';
                           console.log('sairam')
                        }
                    }
                    else{
                        
                        this.spouse = _spouse;
                        console.log(JSON.stringify(this.spouse))
                    }
                    this.spouseModalForm = true;
                }else {
                    this.spouseModalForm = false;
                    this.spouse = _spouse;
                    this.petition.dependentsInfo.spouse  = _spouse;
                    this.petition.sponsorInfo.dependentsInfo.spouse.hasSpouse = false;
                }
            },
            editSpouse(item) {
                //   if(item){
                //         var childocs = item.documents;
                //         if(childocs && childocs.passport == null)  item.documents.passport =[];
                //         if(childocs && childocs.visa == null)  item.documents.visa =[];
                //         if(childocs && childocs.formI94 == null)  item.documents.formI94 =[];
                //         if(childocs && childocs.formI797 == null)  item.documents.formI797 =[];
                //         if(childocs && childocs.formI20 == null)  item.documents.formI20 =[];
                //         if(childocs && childocs.marriageCertificate == null)  item.documents.marriageCertificate =[];
                //         if(childocs && childocs.noticeOfApprovalOfH1Status == null)  item.documents.noticeOfApprovalOfH1Status =[];
                //         if(childocs && childocs.approvalNoticeOfPrevH4 == null)  item.documents.approvalNoticeOfPrevH4 =[];
                //         if(childocs && childocs.other == null)  item.documents.other =[];
    
                // }      
    
                this.spouseModalForm = true;
                this.$validator.reset();
            },
            submitSpouse() {
                this.$validator.validateAll("dependentsInfoformmodal").then((result) => {
                    if (result) {
                        this.petition.sponsorInfo.dependentsInfo.spouse = _.cloneDeep(this.spouse)
                        this.petition.sponsorInfo.dependentsInfo.spouse.hasSpouse = true;
                        this.spouse.saved = true;
                        this.saveCase(true, true)
                    } 
                    else{
                        const $ = JQuery;
                        if($('.text-danger:visible')){
                            $('.modal_cnt').scrollTop($('.text-danger:visible').first().parent().offset().top-30);
                        }
                    }
                })
            },
            checkEducationTab(){
                let returnVal = true
                if(this.currentTab == 'education' && this.canRenderField('hasMasterDegreeInUS', this.questionnaireDetails ,false,'beneficiaryInfo')  && this.checkProperty(this.petition,'beneficiaryInfo','educations') &&
                this.checkProperty(this.petition['beneficiaryInfo'],'educations','length')>0){
                   let mastDExists = _.find(this.petition['beneficiaryInfo']['educations'], { 'highestDegree': 6 });
                   let bDexists = _.find(this.petition['beneficiaryInfo']['educations'], { 'highestDegree': 4 });
                   if(mastDExists ){
                    if(!bDexists){
                        this.educationErrorMsg="Seems you have not submitted Bachelor's information. Please fill to continue"
                        returnVal = false
                    }
                   }else{
                    if(this.checkProperty(this.petition,'beneficiaryInfo','hasMasterDegreeInUS')){
                        returnVal = false
                        this.educationErrorMsg="Seems you have not submitted Master's information. Please fill to continue"
                    }
                   } 
                }
                return returnVal
            },
            findNewDocs(){
                this.newDocs =[];
                if(this.checkProperty(this.petition, 'sponsorInfo', 'documents')){
                    _.forEach(this.petition.sponsorInfo.documents,(docs,category )=>{
                        if(docs && docs.length>0){
                            _.forEach(docs ,(document)=>{
                                if(_.has(document ,'isNew' ) && document['isNew'] ==true && _.get(document ,'path') && _.has(document ,'status' ) && document['status'] ==true ){
                                    this.newDocs.push(document)
                                }

                            })

                        }

                    });
                }

            },
            saveCase(temp_save, show_message = true) {
                this.benProfileDetails = _.cloneDeep(this.petition);
                this.newDocs =[];
                this.findNewDocs();
                this.setSameaddress(false);
                this.callQuestionairePrefill();
                this.checkPreviousSpouse();
                //this.updateBeneficiaryProfile();
                this.$vs.loading();
                this.petition.noOfDaysStayInUS = this.gettotalDays;
              // console.log(JSON.stringify(this.benProfileDetails['sponsorInfo']['dependentsInfo']['spouse']))
                var postpetition = {
                    submittedWithLink:false,
                    petitionId: this.$route.params.itemId,
                    userName: this.$store.state.user.name,
                    typeName: this.petition.typeDetails.name,
                    subTypeName: this.petition.subTypeDetails.name,
                    action: temp_save ? "SPONSOR_INFO_UPDATE" : "SUBMIT_BY_SPONSOR",
                    currentDate: moment().format("YYYY-MM-DD"),
                    sponsorInfo: this.petition.sponsorInfo,
                    // dependentsInfo: this.petition.dependentsInfo,
                    // documents: this.petition.documents,
                    temp_save: temp_save,
                    // fatherInfo: this.petition.fatherInfo,
                    // motherInfo: this.petition.motherInfo,
                    questionnaireFilled: temp_save ? false : true,
                    newDocs:[],
                    consentChecked: this.consentChecked,
                    termsAndConditionsChecked: this.termsAndConditionsChecked,
                };
                if(this.checkProperty(this.petition['beneficiaryInfo'], 'prevH1bCaseStatus') && this.checkProperty(this.petition['beneficiaryInfo'], 'prevH1bCaseStatus', 'id')){
                    postpetition['beneficiaryInfo']['prevH1bCaseStatus'] = this.checkProperty(this.petition['beneficiaryInfo'], 'prevH1bCaseStatus', 'id');
                }
                // this.petition.sponsorInfo.filingThisPetitionerFor
                if(this.checkProperty(this.petition['sponsorInfo'], 'filingThisPetitionerFor') && this.checkProperty(this.petition['sponsorInfo'], 'filingThisPetitionerFor', 'id')){
                    postpetition['sponsorInfo']['filingThisPetitionerFor'] = this.checkProperty(this.petition['sponsorInfo'], 'filingThisPetitionerFor', 'id');
                }
                //petition.beneficiaryInfo.haveYouEverAppliedH1bCase
                postpetition['newDocs'] = this.newDocs;

                // if(this.checkProperty(postpetition ,'beneficiaryInfo' ,'haveYouEverTravelledToUS' ) =='Yes'){
                //     postpetition['beneficiaryInfo']['haveYouEverTravelledToUS'] =true;
                // }
                // if(this.checkProperty(postpetition ,'beneficiaryInfo' ,'haveYouEverTravelledToUS' ) =='No'){
                //     postpetition['beneficiaryInfo']['haveYouEverTravelledToUS'] =false;
                // }
                if(!this.checkProperty(this.petition ,'permId') && this.checkProperty(this.petition ,'subTypeDetails' ,'id') ==16 && this.checkProperty(this.petition ,'jobDetails') ){
                    postpetition = Object.assign(postpetition , { 'jobDetails': this.petition['jobDetails']} );
    
                }
                if(!this.checkCurrentUrl){
                    postpetition['submittedWithLink'] =true;
                }
                // if(this.canRenderField('otherNames',this.questionnaireDetails, false, 'beneficiaryInfo' )){
                //     if(this.petition.beneficiaryInfo.hasOtherNames){
                       
                //         postpetition['beneficiaryInfo']['hasOtherNames'] =true;
                //     }

                // }

                this.$store.dispatch("petitioner/petitionupdate", postpetition)
                    .then((response) => {
                        this.showBenProfileSyncPopup = false;
                        if (this.checkProperty(response, "error")) {
    
                            if (show_message) {
    
                                this.showToster({
                                    message: response.error.message,
                                    isError: true,
                                });
                            } else {
    
                                this.$vs.loading.close();
                            }
    
                        } else {
    
                            this.spouseModalForm = false;
                            this.childModalForm = false;
                            if (show_message) {
                                
                              
                                if (!temp_save) {
                                    this.SuccessQuestionnaire = true;
                                } else {
    
                                    this.showToster({
                                        message: "Questionnaire saved successfully",
                                        isError: false,
                                    });
                                }
    
                            } else {


                                let currentRoute = this.$route;

                                if (  !this.checkCurrentUrl &&   _.get(currentRoute, "name", "") == "fill-sponsor-questionnaire" &&  _.has(currentRoute, "meta.getTokenFromUrl") &&
                                _.has(currentRoute, "query.token")
                                ) {
                                    let token = _.get(currentRoute, "query.token", "");
                                     let url = "/filled-case-details/" +this.$route.params.itemId + "?token=" + token;
                                //   window.location.href = window.location.origin+'/app'+url

                                    this.showToster({  message: "Questionnaire saved successfully",  isError: false,  });
                                
                                     this.$router.push(url) //petitionId

                                }else if (this.petition.questionnaireFilled) {
                                    this.showToster({ message: "Questionnaire updated successfully",   isError: false,  });

                                    if (this.checkProperty(this.petition, "rfeCase")) {
                                        this.$router.push("/rfe-petition-details/" + this.$route.params.itemId);
                                   } else {
                                      this.$router.push("/petition-details/" + this.$route.params.itemId);
                                    }
    
                                } else {
                                    
    
                                    if (!temp_save) {
                              
                                        this.questionnairePreview = false;
                                        this.$vs.loading.close();
                                        this.SuccessQuestionnaire = true;
                                        //document.addEventListener("click", this.reloadthePage);
    
                                    } else {
                                        
                                        this.questionnairePreview = false;
                                       this.showToster({ message: "Questionnaire updated successfully",   isError: false,  });
                                        this.$vs.loading.close();

                                        if (this.checkProperty(this.petition, "rfeCase")) {
                                            this.$router.push("/rfe-petition-details/" + this.$route.params.itemId);
                                        } else {
                                            this.$router.push("/petition-details/" + this.$route.params.itemId);
                                        }
                                    }
    
                                }
    
                            }
                        }
    
                        this.$vs.loading.close();
    
                })
      
            },
            reloadthePage(redirect = false) {
                let routeTest = this.$route.params.itemId;
    
                var _self = this;
                if (this.SuccessQuestionnaire) {
                    this.SuccessQuestionnaire = false;
                }
                if(redirect){
                    this.SuccessQuestionnaire = false;
                    setTimeout(()=>{
                        _self.SuccessQuestionnaire = false;
                        _self.$router.push({ name: "questionnaire", params: { itemId: routeTest, 'redirectBenQuestionnaire': true } });
                    },5)
                   
                    //_self.$router.push("/rfe-petition-details/" + routeTest);
                }else{
                    setTimeout(() => {
                        this.SuccessQuestionnaire = false;
                    let currentRoute = _self.$route;
    
                    if (
                        _.get(currentRoute, "name", "") == "fill-sponsor-questionnaire" &&
                        _.has(currentRoute, "meta.getTokenFromUrl") &&
                        _.has(currentRoute, "query.token")
                    ) {
                        let token = _.get(currentRoute, "query.token", "");
                        let url = "/filled-case-details/" + routeTest + "?token=" + token;
                        //   window.location.href = window.location.origin+'/app'+url
                        _self.$router.push(url);
                    } else {
                        if (_self.checkProperty(_self.petition, "rfeCase")) {
                            _self.$router.push("/rfe-petition-details/" + routeTest);
                        } else {
                            _self.$router.push("/petition-details/" + routeTest);
                        }
                    }
                }, 10);
                }
            },
            goBack() {
                this.setActiveTab(this.tabslist[this.getIndexOfActivetab - 2].key)
    
            },
            updateTablist() {
                // console.log(this.canRenderField('hasChildren',this.questionnaireDetails ,false,'sponsorInfo.dependentsInfo.children'))
                // console.log(this.canRenderField('hasSpouse',this.questionnaireDetails ,false,'sponsorInfo.dependentsInfo.spouse'))
                if (this.petition.sponsorInfo && this.petition.sponsorInfo.maritalStatusDetails && this.petition.sponsorInfo.maritalStatusDetails.id != 1 && 
                (this.canRenderField('hasChildren',this.questionnaireDetails ,false,'sponsorInfo.dependentsInfo.children') || this.canRenderField('hasSpouse',this.questionnaireDetails ,false,'sponsorInfo.dependentsInfo.spouse') )) {
                    var index = _.find(this.tabslist, function (item) {
                        return item.key == "dependentsinfo"
                    })
                    if (index) {
                    } else {
                        var docIndex = _.find(this.tabslist, function (item) {
                            return item.key == "documents"
                        })
                        if(docIndex){
                            this.tabslist.splice(this.tabslist.indexOf(docIndex),1)
                        }
                        var secondDocIndex = _.find(this.tabslist, function (item) {
                            return item.key == "documents"
                        })
                        if(!secondDocIndex){
                            this.tabslist.push({
                                key: "dependentsinfo",
                                name: "Dependents Info"
                            },
                            {
                                key: "documents",
                                name: "Documents"
                            })
                        }else{
                            this.tabslist.push({
                                key: "dependentsinfo",
                                name: "Dependents Info"
                            })
                        }
                       
                    }
                } else {
                    this.tabslist = _.filter(this.tabslist, function (item) {
                        return item.key != "dependentsinfo"
                    })
                }
            },
            formatName(item) {
    
                var _t = '';
                if (item.name != '' && item.name != null) return _t.name;
                if (item.first_name != null && item.first_name != '') _t = item.first_name;
                if (item.middle_name != null && item.middle_name != '') _t + " " + item.middle_name;
                if (item.last_name != null && item.last_name != '') _t + " " + item.last_name;
    
                return _t;
            },
            validateandScroll() {
                var $self = this;
                const $ = JQuery;
                var el = _.find(this.errors["items"], function (item) {
                    return item.scope == $self.currentTab + "form"
                })
                if (el) {
                    const ele = $("[name=" + el.field + "]").parents(".vx-col");
                    var _top = 0;
                    if (ele) {
                        _top = ele.position().top;
                    }
                }
                if(el && _top<=0){
                    const ele = $("[name=" + el.field + "]").parents(".vx-row");
                    if (ele) {
                        _top = ele.position().top;
                    }
                }
                document.getElementById("scrollableques").scrollTo({
                    top: _top,
                    left: 0,
                    behavior: 'smooth'
                })
    
            },
            setActiveTab(item, validate = false) {
                //this.currentTab = item;
                if (validate) {
                    this.$validator.validateAll(this.currentTab + "form").then((result) => {
                        if (result) {
                            //  if(item  == "documents"){
                            //     this.checkMarriageCerti();
                            // }
                            if( this.checkEducationTab()){
                                this.currentTab = item;
                                document.getElementById("scrollableques").scrollTo({
                                    top: 0,
                                    left: 0,
                                    behavior: 'smooth'
                                })
                            }
                            else{
                                this.showToster({
                                    message:  this.educationErrorMsg,
                                    isError: true,
                                });
                            }
                        } else {
    
                            this.validateandScroll()
    
                        }
    
                    })
                } else {
                    this.currentTab = item;
    
                    setTimeout(function () {
                        document.getElementById("scrollableques").scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        })
                    }, 500)
    
                }
               
    
            },
            changeBfProvince(value) {
                this.petition.sponsorInfo.countryOfBirth = this.petition.sponsorInfo.countryOfBirthDetails.id;
                this.petition.sponsorInfo.provinceOfBirth = null
                
                 this.petition.sponsorInfo.provinceOfBirthDetails = null;
                this.bfeprovinceStates = [];
    
                this.loadStatesByCountry('bfeprovinceStates', value.id)
            },
            changeCountryMarriage(value){
    
                this.petition.sponsorInfo.countryOfMarriage = this.petition.sponsorInfo.countryOfMarriageDetails.id;
                this.petition.sponsorInfo.provinceOfMarriage = null;
                this.petition.sponsorInfo.provinceOfMarriageDetails = null;
                this.statesOfMarriage = [];
    
                this.loadStatesByCountry('statesOfMarriage', value.id)
            },
            setOutsideAddress() {
    
                if (this.petition.beneficiaryInfo.currentlyInUS) {
                    this.petition.beneficiaryInfo.addressOutsideUS = {
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: null,
                        zipcode: null
                    };
                } 
            },
            addOtherNames() {
                let item = {
                    firstName: "",
                    middleName: "",
                    lastName: ""
                };
                this.petition.sponsorInfo["otherNames"].push(item);
            },
            removeOtherName(index) {
                this.petition.sponsorInfo["otherNames"].splice(index, 1);
            },
            resetOtherNames($event) {
                this.petition.sponsorInfo["otherNames"] = [];
                this.addOtherNames();
    
            },
            validateScope() {
                this.$validator.validateAll("casedetailsform").then((result) => {
    
                    this.validateandScroll();
                })
            },
            loadStatesByCountry(model, countryId) {
    
                this.$store.dispatch("getstates", countryId).then((response) => {
                    switch (model) {
                        case "bfeprovinceStates":
                            this.bfeprovinceStates = response;
                            break;
                        case "usastates":
                            this.usastates = response;
                        break;
                        case "statesOfMarriage":
                            this.statesOfMarriage = response;
                        break;    
                    }
                });
    
            },
            getAffidivitObj(){
                let affidivitObj={
                    currentAnnualSalary: '',
                    nameOfEmployer: '',
                    currentPosition: '',
                    depositsInBankUSA: '',
                    reasonableValPersonalProperty: '',
                    haveMarketValInStocksAndBonds: null,
                    marketValInStocksAndBonds: '',
                    sumOfLifeInsurance: '',
                    cashSurrValOfLifeInsurance: '',
                    haveValOfRealEstate: null,
                    valOfRealEstate: '',
                    amountOfMortgageProperty: '',
                    addressPropertyIsLocate: ''
                }
                return affidivitObj
            },
            setTheInitData() {
                var $self = this;
                if (this.petition.sponsorInfo.countryOfBirthDetails && this.petition.sponsorInfo.countryOfBirth != null) {
    
                    this.loadStatesByCountry('bfeprovinceStates', this.petition.sponsorInfo.countryOfBirth)
    
                }
                let affidivitObj = this.getAffidivitObj();
                let provinceOfBirth = this.checkProperty(this.petition ,'sponsorInfo' ,'provinceOfBirth');
                   if (provinceOfBirth != null) { 
                     let provinceOfBirthDetails = _.find(this.bfeprovinceStates, function (item) {  return item.id == provinceOfBirth  })
                         if(provinceOfBirthDetails){
                             this.petition.sponsorInfo.provinceOfBirthDetails = provinceOfBirthDetails;
                         }
                    }
    
                let curNonImmigrantVisaStatus = this.petition.sponsorInfo.curNonImmigrantVisaStatus;
                if (curNonImmigrantVisaStatus != null) {
                    this.petition.sponsorInfo.curNonImmigrantVisaStatusDetails = _.find(this.petition.visaStatusList, function (item) {
    
                        return item.id == curNonImmigrantVisaStatus
                    })
                }
                if (this.petition.sponsorInfo && this.petition.sponsorInfo.prevEmploymentInfo == null) {
                    this.petition.sponsorInfo.prevEmploymentInfo = [{
                        _id: 0,
                        employerName: '',
                        address: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        businessType: null,
                        jobTitle: null,
                        jobDuties: null,
                        startDate: null,
                        endDate: null,
                        salary:null,
                        currentEmployer: false
                    }]
                }
                if(this.checkProperty(this.petition, 'sponsorInfo') && !this.checkProperty(this.petition, 'sponsorInfo', 'affidavitInfo')){
                    this.petition['sponsorInfo']['affidavitInfo'] = affidivitObj;
                }
                if (this.canRenderField('prevEmploymentInfo', this.questionnaireDetails,false,'sponsorInfo.prevEmploymentInfo')) {
    
                    var index = _.find(this.tabslist, function (item) {
    
                        return item.key == "employment"
                    })
                    if (index) {
    
                    } else {
                        this.tabslist.push({
                            key: "employment",
                            name: "Employment Info"
                        })
                    }
    
                }
                if (this.canRenderField('fatherInfo', this.questionnaireDetails,false,'sponsorInfo.fatherInfo') || this.canRenderField('motherInfo', this.questionnaireDetails,false,'sponsorInfo.motherInfo')) {
    
                    var index = _.find(this.tabslist, function (item) {
                    
                        return item.key == "parent"
                    })
                
                    if (index) {

                    } else {
                        this.tabslist.push({
                            key: "parent",
                            name: "Parents Info"
                        })
                    }

                } 
                if(this.checkProperty(this.petition, 'sponsorInfo') && (!this.checkProperty(this.petition, 'sponsorInfo', 'submitSupPetiForOtherRelative') ||
                (this.checkProperty(this.petition, 'sponsorInfo', 'submitSupPetiForOtherRelative') && !this.checkProperty(this.petition, 'sponsorInfo', 'submitSupPetiForOtherRelative', 'length')>0))){
                    this.petition['sponsorInfo']['submitSupPetiForOtherRelative'] = [{
                        relative: null,
                        familyName: '',
                        givenName: '',
                        middleName: '',
                        relationShip: '',
                    }];
                }
    
                var index = _.find(this.tabslist, function (item) {
    
                    return item.key == "documents"
                })
                if (index) {
    
                } else {
                    this.tabslist.push({
                        key: "documents",
                        name: "Documents"
                    })
                }
                this.updateTablist()
                this.featureDates = new Date();
                if (this.petition.sponsorInfo.dependentsInfo.childrens && this.petition.sponsorInfo.dependentsInfo.childrens.length > 0 && this.petition.sponsorInfo.dependentsInfo.childrens[0].firstName != '' && this.petition.sponsorInfo.dependentsInfo.childrens[0].firstName != null) {
                    this.petition.h4RequiredForChild = true;
                    this.petition.hasRequiredForChildren = true;
                }
                if(this.checkProperty(this.petition.sponsorInfo, 'dependentsInfo') && this.checkProperty(this.petition.sponsorInfo, 'dependentsInfo', 'childrens') && this.petition.sponsorInfo.dependentsInfo.childrens && this.petition.sponsorInfo.dependentsInfo.childrens.length > 0 ){
                    this.petition.sponsorInfo.dependentsInfo.childrens.forEach((element, index) => {
                        if (element.firstName != '' && element.firstName != null) {
                            this.petition.sponsorInfo.dependentsInfo.childrens[index].saved = true;
                        }
                    });
                }
                if (this.checkProperty(this.petition.sponsorInfo, 'dependentsInfo') && this.petition.sponsorInfo.dependentsInfo.spouse.firstName != null && this.petition.sponsorInfo.dependentsInfo.spouse.firstName != '') {
                    this.petition.sponsorInfo.dependentsInfo.spouse.saved = true;
                    this.petition.sponsorInfo.dependentsInfo.spouse.hasSpouse = true;
                    this.spouse.saved = true;
                }
                setTimeout(()=>{
                    //$self.mamageVisaStatusDocuments()
                } ,500);
                this.$vs.loading.close();

            },
            getCountries(){
                this.$store.dispatch("getcountries").then((response) => {
                    this.countries = response;
    
                });
            },
            init(callFromMounted=false) {
                
                this.$store
                    .dispatch("getpetition", this.$route.params.itemId)
                    .then((response) => {
                        if(response && response.data && response.data.result){
                            if(this.checkProperty(response.data.result['beneficiaryInfo'], 'prevH1bCaseStatus')){
                                let dtval = this.checkProperty(response.data.result['beneficiaryInfo'], 'prevH1bCaseStatus')
                                let findObj = _.find(this.prevH1bCaseStatusList,{'id':dtval});
                                response.data.result['beneficiaryInfo']['prevH1bCaseStatus']  = findObj;
                            }
                           let tempDocs=[];
                          _.forEach(this.bendocslist ,(docs)=>{
                            tempDocs.push(docs);
                          })
                          let currentRoute = this.$route;
                          let token = '';
                            if(_.get(currentRoute, "name", "") == "fill-sponsor-questionnaire" &&  _.has(currentRoute, "meta.getTokenFromUrl") && _.has(currentRoute, "query.token") ) {
                                token = _.get(currentRoute, "query.token", "");
                                if(token){
                                    let payLoad = { apiToken:token };
                                    let path = '/auth/verify-token';
                                    this.$store.dispatch("commonAction", { "data": payLoad, "path": path }).then((res)=>{
                                    if(res){
                                        this.$store.commit('updateAnonymousUserData', res)
                                    }
                                    }).catch((err)=>{})
                                }
                            }
                            this.getConsentDetails();
                          if(this.checkProperty(response['data']['result'], 'questionnaireFilled') && this.checkProperty(this.$route ,'name') =='fill-sponsor-questionnaire'){
                            this.$router.push("/filled-case-details/" + this.$route.params.itemId+ "?token=" + token);
                          }
                          //gc 485 tabs
                          if(true){
                            let tempTabs = [];
                            _.forEach(this.tabslist ,(tabItem)=>{
                                if(tabItem['key']=='casedetails'){
                                tempTabs.push(tabItem);
                                    if(!_.find(this.tabslist ,{'key':"parent"})){
                                    tempTabs.push({  key: "parent", name: "Parents Info" });
                                }
                                        
                                
                            }else{
                            tempTabs.push(tabItem);
                            }



                            });
                          }

                                                  
                        
                          this.bendocslist =[];
                          this.bendocslist =tempDocs;
                        //   if(response.data.result && this.checkProperty(response.data.result, 'sponsorInfo')){
                        //   }
                        var data = _.merge(this.petition, response.data.result);
                        this.petition = data;
                        if(response.data.result && this.checkProperty(response.data.result, 'completedActivities')  && this.checkProperty(response.data.result, 'completedActivities', 'length')>0){
                           if(this.checkProperty(response.data.result, 'completedActivities').indexOf('SUBMIT_BY_SPONSOR')>-1){
                               this.petition.questionnaireFilled = true;
                           }                      
                        }
                        let _spouse = this.getSpouseObj();
                        let _child = this.getChildObject();
                        if(_.has(this.petition, 'sponsorInfo') && _.has(this.petition['sponsorInfo'], 'dependentsInfo') && this.checkProperty(this.petition['sponsorInfo'],'dependentsInfo', 'children')
                        && this.checkProperty(this.petition['sponsorInfo']['dependentsInfo'], 'children','length')>0 ){
                            _.forEach(this.petition['sponsorInfo']['dependentsInfo']['childrens'], (chIt)=>{
                                if(!_.has(chIt,'currentAddress')){
                                    chIt['currentAddress'] = {
                                        line1: null,
                                        line2: null,
                                        aptType: null,
                                        locationId: null,
                                        locationDetails: null,
                                        stateId: null,
                                        stateDetails: null,
                                        countryId: null,
                                        countryDetails: null,
                                        zipcode: null
                                    }
                                }
                                if(!_.has(chIt,'physicalAddress')){
                                    chIt['physicalAddress'] = {
                                        line1: null,
                                        line2: null,
                                        aptType: null,
                                        locationId: null,
                                        locationDetails: null,
                                        stateId: null,
                                        stateDetails: null,
                                        countryId: null,
                                        countryDetails: null,
                                        zipcode: null
                                    }
                                }
                            })
                        }
                        if(!_.has(this.petition['sponsorInfo'], 'dependentsInfo')){
                                this.petition['sponsorInfo']['dependentsInfo']={
                                    spouse:_.cloneDeep(_spouse),
                                    childrens:[]
                                };
                                this.petition['sponsorInfo']['dependentsInfo']['childrens'].push(_child)
                        }
                        else if(_.has(this.petition['sponsorInfo'], 'dependentsInfo') && ( !_.has(this.petition['sponsorInfo']['dependentsInfo'], 'spouse') || (_.has(this.petition['sponsorInfo']['dependentsInfo'], 'spouse') && (this.checkProperty(this.petition['sponsorInfo']['dependentsInfo'], 'spouse') == null || this.checkProperty(this.petition['sponsorInfo']['dependentsInfo'], 'spouse') == '') )) ){
                            this.petition['sponsorInfo']['dependentsInfo']['spouse'] = _.cloneDeep(_spouse);
                        }
                        
                        if(_.has(this.petition,'sponsorInfo') && this.checkProperty(this.petition,'sponsorInfo','dependentsInfo') && this.checkProperty(this.petition['sponsorInfo'], 'dependentsInfo','spouse')){
                            this.spouse = _.cloneDeep(this.petition.sponsorInfo.dependentsInfo.spouse);
                            if(this.checkProperty(this.petition, 'sponsorInfo', 'dependentsInfo') && this.checkProperty(this.petition['sponsorInfo'], 'dependentsInfo', 'spouse') &&  !_.has(this.petition.sponsorInfo.dependentsInfo.spouse, 'hasSpouse')){
                                this.petition.sponsorInfo.dependentsInfo.spouse['hasSpouse'] = false;
                                this.spouse['hasSpouse'] = false;

                            }
                        }  
                        if(!_.has(this.spouse, 'physicalAddress')){
                            this.spouse['physicalAddress'] = {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            }
                        }
                        if(!_.has(this.spouse, 'currentAddress')){
                            this.spouse['currentAddress'] = {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            }
                        }

                        //pin verification functionality  
                       
                         if(!this.checkCurrentUrl && callFromMounted &&  this.checkProperty( this.petition ,'requiredPinForQuesSubmit')   ){
                
                            if(!this.openGeneratePinPopUp &&  this.checkProperty( this.petition ,'qstPinSet')){
                                if(!this.tokenVerified){
                                    this.openGeneratePinPopUp =true;
                                    return false;
                                }
                                
                                
                            }else{
                          
                                this.openGeneratePinPopUp =true;
                                 return false

                            }
                         }
                         if(!_.has(this.petition['sponsorInfo'], 'lawFulPermanentResident')){
                            this.petition['sponsorInfo']['lawFulPermanentResident'] = {};
                            this.petition['sponsorInfo']['lawFulPermanentResident']['classOfAdmission'] = '';
                            this.petition['sponsorInfo']['lawFulPermanentResident']['dateOfAdmission'] = '';
                         }
                        //  if(!_.has(this.petition['sponsorInfo'], 'submitSupPetiForOtherRelative')){
                        //     this.petition['sponsorInfo']['submitSupPetiForOtherRelative'] = {};
                        //     this.petition['sponsorInfo']['submitSupPetiForOtherRelative']['relative'] = null;
                        //     this.petition['sponsorInfo']['submitSupPetiForOtherRelative']['familyName'] = '';
                        //     this.petition['sponsorInfo']['submitSupPetiForOtherRelative']['givenName'] = '';
                        //     this.petition['sponsorInfo']['submitSupPetiForOtherRelative']['middleName'] = '';
                        //     this.petition['sponsorInfo']['submitSupPetiForOtherRelative']['relationShip'] = '';
                        //  }
                        if(!_.has(this.petition['sponsorInfo'], 'submitSupPetiForOtherRelative') || (this.checkProperty(this.petition, 'sponsorInfo') && (!this.checkProperty(this.petition, 'sponsorInfo', 'submitSupPetiForOtherRelative') ||
                        (this.checkProperty(this.petition, 'sponsorInfo', 'submitSupPetiForOtherRelative') && !this.checkProperty(this.petition, 'sponsorInfo', 'submitSupPetiForOtherRelative', 'length')>0)))){
                            this.petition['sponsorInfo']['submitSupPetiForOtherRelative'] = [{
                                relative: null,
                                familyName: '',
                                givenName: '',
                                middleName: '',
                                relationShip: '',
                            }];
                        }
                         if(!_.has(this.petition['sponsorInfo'], 'bnfPrevPetitionInfo')){
                            this.petition['sponsorInfo']['bnfPrevPetitionInfo'] = {};
                            this.petition['sponsorInfo']['bnfPrevPetitionInfo']['familyName'] = '';
                            this.petition['sponsorInfo']['bnfPrevPetitionInfo']['givenName'] = '';
                            this.petition['sponsorInfo']['bnfPrevPetitionInfo']['middleName'] = '';
                            this.petition['sponsorInfo']['bnfPrevPetitionInfo']['dateOfFiling'] = null;
                            this.petition['sponsorInfo']['bnfPrevPetitionInfo']['cityOfFiling'] = '';
                            this.petition['sponsorInfo']['bnfPrevPetitionInfo']['stateOfFiling'] = null;
                            this.petition['sponsorInfo']['bnfPrevPetitionInfo']['stateDetailsOfFiling'] = null;
                            this.petition['sponsorInfo']['bnfPrevPetitionInfo']['status'] = '';
                         }
                        //this.mamageVisaStatusDocuments(); 
                        //this.questionnaireDetails = [];
                        this.$store
                            .dispatch("commonAction", {
                                data: {
                                    questionnaireId: this.petition.questionnaireTplId
                                },
                                path: "/questionnaire/details",
                            })
                            .then((res) => {
    
                                let postData = {
                                    userId: this.petition.userId,
                                    getDocuments: true,
                                };
                                let pth="petition/get-recent-by-beneficiary";
                                pth ="petition-common/get-recent-by-beneficiary";
                                //pth =  '/beneficiary-profile/get-profile-details'
                                this.$store
                                    .dispatch("commonAction", {
                                        data: postData,
                                        path: pth,
                                    })
                                    .then((response) => {
                                        if (response && response.profileDetails && response.profileDetails.beneficiaryInfo  && this.checkProperty(response['profileDetails'],'beneficiaryInfo','firstName')) {
                                            if (!this.petition.questionnaireFilled && (this.petition.sponsorInfo.email == null || this.petition.sponsorInfo.email == '')) {
                                                this.showPrefillPopup = true;
                                            } 
                                            this.beneFiciaryDeytailsExists  = true;
                                            let tempDetails = response['profileDetails'];
                                            this.latestPetition = tempDetails;
                                        }
                                        else if (response && response.caseDetails && _.has(response.caseDetails, 'sponsorInfo') && response.caseDetails.sponsorInfo && false) {
                                            if (!this.petition.questionnaireFilled && (this.petition.sponsorInfo.email == null || this.petition.sponsorInfo.email == '')) {
                                                this.showPrefillPopup = true;
                                            }
                                            this.beneFiciaryDeytailsExists  = false;   
                                            let tempDetails = response["caseDetails"];
                                            this.latestPetition = tempDetails;
                                            
                                        }else if (response && response.userDetails && response.userDetails && (!this.petition.questionnaireFilled && (this.petition.sponsorInfo.email == null || this.petition.sponsorInfo.email == ''))){
    
                                            if(this.checkProperty(response ,'userDetails' ,'email' ) && !this.checkProperty(this.petition ,'sponsorInfo' ,'email')){
    
                                            this.petition['sponsorInfo']['email'] = this.checkProperty(response ,'userDetails' ,'email' )
    
    
                                            }
                                            if(this.checkProperty(response ,'userDetails' ,'firstName' ) && !this.checkProperty(this.petition ,'sponsorInfo' ,'firstName')){
                                            this.petition['sponsorInfo']['firstName'] = this.checkProperty(response ,'userDetails' ,'firstName' );
                                            }
                                            if(this.checkProperty(response ,'userDetails' ,'middleName' )  && !this.checkProperty(this.petition ,'sponsorInfo' ,'middleName') ){
                                                this.petition['sponsorInfo']['firstName'] = this.checkProperty(response ,'userDetails' ,'middleName' );
                                            }
                                            if(this.checkProperty(response ,'userDetails' ,'lastName' ) && !this.checkProperty(this.petition ,'sponsorInfo' ,'lastName') ){
                                            this.petition['sponsorInfo']['lastName'] = this.checkProperty(response ,'userDetails' ,'lastName' );
                                            }
                                            this.removeFields()
                                        }
                                        this.questionnaireDetails = res.fields;
                                        this.setTheInitData()
                                    });
    
                            })
    
                        }else{
    
                              this.$vs.loading.close();
                        }
                      
                    })
            },

            getChildObject() {
                let child = {
                    hasChildren:null,
                    name: '',
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    dateOfBirth: null,
                    countryOfBirth: null,
                    countryOfBirthDetails: null,
                    provinceOfBirth: null,
                    provinceOfBirthDetails: null,
                    locationOfBirth: null,
                    relationshipToYou:'',
                }
                return child
            },
    
            setBasicData(){
                let _self =this;
                //this.latestPetition beneficiaryInfo
                //email  firstName middleName lastName
                if(this.checkProperty(this.latestPetition ,'sponsorInfo' ,'email' )){
    
                    this.petition['sponsorInfo']['email'] = this.checkProperty(this.latestPetition ,'beneficiaryInfo' ,'email' )
                    
    
                }
                if(this.checkProperty(this.latestPetition ,'sponsorInfo' ,'firstName' )){
                    this.petition['sponsorInfo']['firstName'] = this.checkProperty(this.latestPetition ,'beneficiaryInfo' ,'firstName' );
                }
                if(this.checkProperty(this.latestPetition ,'sponsorInfo' ,'middleName' )){
                    this.petition['sponsorInfo']['middleName'] = this.checkProperty(this.latestPetition ,'beneficiaryInfo' ,'middleName' );
                }
                if(this.checkProperty(this.latestPetition ,'sponsorInfo' ,'lastName' )){
                    this.petition['sponsorInfo']['lastName'] = this.checkProperty(this.latestPetition ,'beneficiaryInfo' ,'lastName' );
                }

                setTimeout(()=>{
                   // _self.mamageVisaStatusDocuments()
                } ,500);
    
    
            },
            prefilltheDetails(){
                this.prepopulateQuestionnaire('sponsorInfo');
                this.prepopulateQuestionnaire('prevEmploymentInfo');
                this.prepopulateQuestionnaire('prevEmploymentOutsideUS');
                this.prepopulateQuestionnaire('addressOutsideUSMoreThanYear');
                this.prepopulateQuestionnaire('addressOfLastNYears');
                this.prepopulateQuestionnaire('previousSpouse');
                this.prepopulateQuestionnaire('fatherInfo');
                this.prepopulateQuestionnaire('motherInfo');
                this.prepopulateQuestionnaire('detailsItemsList');
                this.prepopulateQuestionnaire('affidavitInfo');
                this.prepopulateQuestionnaire('submitSupPetiForOtherRelative');
                this.prepopulateQuestionnaire('bnfPrevPetitionInfo');
                this.prepopulateQuestionnaire('lawFulPermanentResident');
                //this.prepopulateQuestionnaire('spouse');     
                this.setTheInitData() 
            },
            prepopulateQuestionnaire(tplsection='sponsorInfo'){
                let questionnaireSection = tplsection;
                let latestPetitionSection = 'beneficiaryInfo'
                if(questionnaireSection == 'sponsorInfo' ){
                    _.forEach(this.petition[questionnaireSection], (item,key)=>{
                        if(this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection) && this.sponsorPrefillIgnoreKeys.indexOf(key)<=-1 && _.has(this.latestPetition, latestPetitionSection+'.'+key) ){
                            this.petition[questionnaireSection][key] = _.cloneDeep(this.latestPetition[latestPetitionSection][key]);
                        }
                    })
                } 
                if(questionnaireSection == 'submitSupPetiForOtherRelative' ){
                    // _.forEach(this.petition['sponsorInfo'][questionnaireSection], (item,key)=>{
                    //     if(this.canRenderField( key, this.questionnaireDetails ,false, 'sponsorInfo.submitSupPetiForOtherRelative')
                    //      && _.has(this.latestPetition[latestPetitionSection], 'submitSupPetiForOtherRelative')  && _.has(this.latestPetition[latestPetitionSection]['submitSupPetiForOtherRelative'], key) ){
                    //         this.petition['sponsorInfo'][questionnaireSection][key] = _.cloneDeep(this.latestPetition[latestPetitionSection]['submitSupPetiForOtherRelative'][key]);
                    //     }
                    // })
                    if(this.checkProperty(this.latestPetition[latestPetitionSection], questionnaireSection) && this.checkProperty(this.latestPetition[latestPetitionSection], questionnaireSection,'length')>0
                    && this.checkProperty(this.latestPetition[latestPetitionSection], 'hasSubmitSepPetiForOtherRelation') ){
                        this.petition['sponsorInfo'][questionnaireSection][key] = _.cloneDeep(this.latestPetition[latestPetitionSection]['submitSupPetiForOtherRelative']);  
                    }else{
                        this.petition['sponsorInfo']['submitSupPetiForOtherRelative'] = [{
                            relative: null,
                            familyName: '',
                            givenName: '',
                            middleName: '',
                            relationShip: '',
                        }];
                    }
                } 
                if(questionnaireSection == 'addressOutsideUSMoreThanYear' || questionnaireSection =='addressOfLastNYears'){
                    let tempSection = 'sponsorInfo.addressOutsideUSMoreThanYear';
                    if(questionnaireSection == 'addressOfLastNYears'){
                        tempSection = 'sponsorInfo.addressOfLastNYears';
                    }
                    if(this.canRenderField( questionnaireSection, this.questionnaireDetails ,false, tempSection)){
                        if(this.checkProperty(this.latestPetition['beneficiaryInfo'], questionnaireSection) && this.checkProperty(this.latestPetition['beneficiaryInfo'], questionnaireSection, 'length')>0 ){
                            this.petition['sponsorInfo'][questionnaireSection] = _.cloneDeep(this.latestPetition['beneficiaryInfo'][questionnaireSection])
                        }else{
                            this.petition['sponsorInfo'][questionnaireSection] = _.cloneDeep(this.tempPetition['sponsorInfo'][questionnaireSection])
                        }
                    }else{
                        this.petition['sponsorInfo'][questionnaireSection] = _.cloneDeep(this.tempPetition['sponsorInfo'][questionnaireSection])
                    }
                }
                if(questionnaireSection == 'bnfPrevPetitionInfo' ){
                    _.forEach(this.petition['sponsorInfo'][questionnaireSection], (item,key)=>{
                        if(this.canRenderField( key, this.questionnaireDetails ,false, 'sponsorInfo.bnfPrevPetitionInfo')
                         && _.has(this.latestPetition[latestPetitionSection], 'bnfPrevPetitionInfo')  && _.has(this.latestPetition[latestPetitionSection]['bnfPrevPetitionInfo'], key) ){
                            this.petition['sponsorInfo'][questionnaireSection][key] = _.cloneDeep(this.latestPetition[latestPetitionSection]['bnfPrevPetitionInfo'][key]);
                        }
                    })
                }
                if(questionnaireSection == 'lawFulPermanentResident' ){
                    _.forEach(this.petition['sponsorInfo'][questionnaireSection], (item,key)=>{
                        if(this.canRenderField( key, this.questionnaireDetails ,false, 'sponsorInfo.lawFulPermanentResident')
                         && _.has(this.latestPetition[latestPetitionSection], 'lawFulPermanentResident')  && _.has(this.latestPetition[latestPetitionSection]['lawFulPermanentResident'], key) ){
                            this.petition['sponsorInfo'][questionnaireSection][key] = _.cloneDeep(this.latestPetition[latestPetitionSection]['lawFulPermanentResident'][key]);
                        }
                    })
                }
                if(questionnaireSection == 'detailsItemsList' ){
                    _.forEach(this.detailsItemsList, (item)=>{
                        let tempSection = item['section']
                        let tempKey = item['key']
                        let tempdetailsKey = item['detailsKey']
                        if(tempSection == 'sponsorInfo'){
                            if(_.has(this.latestPetition['beneficiaryInfo'], tempKey) && this.checkProperty(this.latestPetition, 'beneficiaryInfo', tempKey) 
                            && _.has(this.petition['sponsorInfo'], tempKey )){
                                if(this.canRenderField( tempKey, this.questionnaireDetails ,false, tempSection) && _.has(this.latestPetition, 'beneficiaryInfo'+'.'+tempKey) && _.has(this.petition, tempSection+'.'+tempKey)){
                                    this.petition['sponsorInfo'][tempKey] = this.latestPetition['beneficiaryInfo'][tempKey];
                                    this.petition['sponsorInfo'][tempdetailsKey] = this.latestPetition['beneficiaryInfo'][tempdetailsKey];
                                }
                            }
                        }
                        if(tempSection == 'sponsorInfo.fatherInfo' || tempSection == 'sponsorInfo.motherInfo'){
                            let latestSection = 'fatherInfo';
                            if(tempSection == 'sponsorInfo.motherInfo'){
                                latestSection = 'motherInfo';
                            }
                            if(this.canRenderField( tempKey, this.questionnaireDetails ,false, tempSection) && _.has(this.latestPetition, latestSection+'.'+tempKey) && _.has(this.petition, latestSection+'.'+tempKey)){
                                this.petition['sponsorInfo'][latestSection][tempKey] = this.latestPetition[latestSection][tempKey];
                                this.petition['sponsorInfo'][latestSection][tempdetailsKey] = this.latestPetition[latestSection][tempdetailsKey];
                            }
                        }
                        if(tempSection == 'sponsorInfo.previousSpouse'){
                            if(this.checkProperty(this.latestPetition, 'beneficiaryInfo', 'previousSpouse')  && _.has(this.latestPetition['beneficiaryInfo']['previousSpouse'], tempKey)
                            && _.has(this.petition['sponsorInfo'],'previousSpouse' ) && _.has(this.petition['sponsorInfo']['previousSpouse'],tempKey)){
                                let tempBenSection = 'beneficiaryInfo.previousSpouse'
                                if(this.canRenderField( tempKey, this.questionnaireDetails ,false, tempSection) && _.has(this.latestPetition, tempBenSection+'.'+tempKey) && _.has(this.petition, tempSection+'.'+tempKey)){
                                    this.petition['sponsorInfo']['previousSpouse'][tempKey] = this.latestPetition['beneficiaryInfo']['previousSpouse'][tempKey];
                                    this.petition['sponsorInfo']['previousSpouse'][tempdetailsKey] = this.latestPetition['beneficiaryInfo']['previousSpouse'][tempdetailsKey];
                                }
                            }else{
                                this.petition['sponsorInfo']['previousSpouse'] = this.getPreviousSpouseObj();
                            }
                        }
                        // else{
                        //     if(this.canRenderField( tempKey, this.questionnaireDetails ,false, tempSection) && _.has(this.latestPetition, tempSection+'.'+tempKey) && _.has(this.petition, tempSection+'.'+tempKey)){
                        //         this.petition[tempSection][tempKey] = this.latestPetition[tempSection][tempKey];
                        //         this.petition[tempSection][tempdetailsKey] = this.latestPetition[tempSection][tempdetailsKey];
                        //     }
                        // }
                    })
                }
                if(questionnaireSection == 'prevEmploymentInfo' || questionnaireSection == 'prevEmploymentOutsideUS' ){
                    let tempSection = 'sponsorInfo.prevEmploymentInfo';
                    if(questionnaireSection == 'prevEmploymentOutsideUS'){
                        tempSection = 'sponsorInfo.prevEmploymentOutsideUS';
                    }
                    if(this.canRenderField( questionnaireSection, this.questionnaireDetails ,false, tempSection)){
                        if(this.checkProperty(this.latestPetition['beneficiaryInfo'], questionnaireSection) && this.checkProperty(this.latestPetition['beneficiaryInfo'], questionnaireSection, 'length')>0 ){
                            this.petition['sponsorInfo'][questionnaireSection] = _.cloneDeep(this.latestPetition['beneficiaryInfo'][questionnaireSection])

                        } 
                    }
                }
                if(questionnaireSection == 'previousSpouse'){
                    let tempSection = 'sponsorInfo.previousSpouse';
                    if(this.canRenderField( questionnaireSection, this.questionnaireDetails ,false, tempSection)){
                        if(this.checkProperty(this.latestPetition['beneficiaryInfo'], questionnaireSection) && this.checkProperty(this.latestPetition['beneficiaryInfo'], questionnaireSection) != null ){
                            this.petition['sponsorInfo'][questionnaireSection] = _.cloneDeep(this.latestPetition['beneficiaryInfo'][questionnaireSection])

                        } 
                    }
                }
                if(questionnaireSection == 'affidavitInfo'){
                    let tempSection = 'sponsorInfo.affidavitInfo';
                    if(this.canRenderField( questionnaireSection, this.questionnaireDetails ,false, tempSection)){
                        if(this.checkProperty(this.latestPetition['beneficiaryInfo'], questionnaireSection) && this.checkProperty(this.latestPetition['beneficiaryInfo'], questionnaireSection) != null ){
                            this.petition['sponsorInfo'][questionnaireSection] = _.cloneDeep(this.latestPetition['beneficiaryInfo'][questionnaireSection])

                        } 
                    }
                }
                if(questionnaireSection == 'fatherInfo' || questionnaireSection == 'motherInfo' ){
                    let tempSection = 'sponsorInfo.fatherInfo';
                    if(questionnaireSection == 'motherInfo'){
                        tempSection = 'sponsorInfo.motherInfo';
                    }
                    if(this.canRenderField( questionnaireSection, this.questionnaireDetails ,false, tempSection)){
                        if(this.checkProperty(this.latestPetition, questionnaireSection) && this.checkProperty(this.latestPetition, questionnaireSection) != null ){
                            this.petition['sponsorInfo'][questionnaireSection] = _.cloneDeep(this.latestPetition[questionnaireSection])

                        } 
                    }
                }
                if(questionnaireSection == 'spouse'){
                    let tempSection = 'sponsorInfo.dependentsInfo.spouse';
                    if(this.canRenderField( 'hasSpouse', this.questionnaireDetails ,false, tempSection)){
                        if(this.checkProperty(this.latestPetition['dependentsInfo'], questionnaireSection) && this.checkProperty(this.latestPetition['dependentsInfo'], questionnaireSection) != null ){
                            this.petition['sponsorInfo']['dependentsInfo'][questionnaireSection] = _.cloneDeep(this.latestPetition['dependentsInfo'][questionnaireSection])
                        } 
                    }else{
                        this.petition['sponsorInfo']['dependentsInfo'][questionnaireSection] = this.getSpouseObj();
                    }
                }
            },
            getPreviousSpouseObj(){
                let _preSpouse={
                    hasOtherNames:false,
                    otherNames: [{
                        _id: 0,
                        name: '',
                        firstName: '',
                        middleName: '',
                        lastName: '',
                    }],
                    maidenName:'',
                    marriageEndedDueTo:null,
                    marriageEndedOtherInfo:'',
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    dateOfBirth: null,
                    dateOfMarriage:null,
                    dateOfMarriageEnd:null,
                    countryOfMarriage: '',
                    countryOfMarriageDetails: null,
                    provinceOfMarriage: '',
                    provinceOfMarriageDetails: null,
                    locationOfMarriage: '',
                    countryOfMarriageTermination: '',
                    countryOfMarriageTerminationDetails: null,
                    provinceOfMarriageTermination: '',
                    provinceOfMarriageTerminationDetails: null,
                    locationOfMarriageTermination: '',
                    obtainPermResidenceThroughSpouse:false  
                }
                return _preSpouse
            },
    
        },
        beforeDestroy() {
            const $ = JQuery;
            //document.removeEventListener("click", this.reloadthePage);
    
            $('body').removeClass('questionnairetpl')
        },
        mounted() {
            this.getConsentDetails();
            this.formerrors = {  msg: ""  };
            this.getMasterSocList();
            const $ = JQuery;
            this.$vs.loading();
            $('body').addClass('questionnairetpl')
            this.$store.dispatch("getcountries").then((response) => {
                this.countries = response;
                if(this.checkProperty(this.countries, 'length')>0){
                    this.countriesWithoutUS = _.filter(this.countries,(item)=> {
                        return item.id != 231;
                    });
                }
            });
                this.$store.dispatch("getmasterdata", "visa_status").then((response) => {
                    this.visastatuses = response;
                });
                this.$store.dispatch("getmasterdata", "eye_colors").then((response) => {
                    this.eye_colorList = response;
                });
                this.$store.dispatch("getmasterdata", "hair_colors").then((response) => {
                    this.hair_colorsList = response;
                });
                this.$store.dispatch("getmasterdata", "races").then((response) => {
                    this.races_list = response;
                });
                this.$store.dispatch("getmasterdata", "asset_types").then((response) => {
                    this.assestsList = response;
                });
                this.$store.dispatch("getmasterdata", "liabilities_debts").then((response) => {
                    this.liability_list = response;
                });
                this.$store.dispatch("getmasterdata", "public_benefits").then((response) => {
                    let list = response;
                    _.forEach( list,(item) => {
                       item =Object.assign(item,{ 'isSelected':false});
                    });
                    this.public_benefits = _.cloneDeep(list)
                });
                this.$store
                    .dispatch("getmasterdata", "marital_status")
                    .then((response) => {
                        this.marital_statuses = response;
                    });
    
                this.$store
                    .dispatch("getmasterdata", "education_types")
                    .then((response) => {
                        this.education_types = response;
                        // this.upDatehighestDegree();
                    });

            let localData = localStorage.getItem("pinAccessData");
            let action=true;
            if(localData){
                localData = JSON.parse(atob(localData));
            }else{
                localData =[];
            }
            let userData = this.getUserData;
            if(_.find(localData ,{ "userId":userData["userId"],"petitionId": this.$route.params.itemId })){
                action =false;
                this.tokenVerified =true;
            }        
            this.init(action);
            this.getGlobalConfigDetails();
            //this.$validator.reset();
            this.loadStatesByCountry('usastates', 231)
            this.loadStatesByCountry('bfeprovinceStates', 231);
            if(this.checkProperty(this.$route ,'query' ,'filter')){
                try{
                    //this.currentTab = "employment";
                    let filter = this.checkProperty(this.$route ,'query' ,'filter');
                    var actual = JSON.parse(atob(filter));
                    let keys = Object.keys(actual);
                    if(this.checkProperty(keys ,'length') >0){
                        _.forEach(keys,(item)=>{
                            if(item == 'currentTab'){
                                this.currentTab = actual[item]
                            }
                        })
                    }
                }
                catch(e){

                }
            }
    
    
        },
        components: {
            affidavitForm,
            fileUploadNote,
            generatePin,
            monthAndYear,
            InfoIcon,
            EyeIcon,
            FileUpload,
            Datepicker,
            immitextfield,
            XIcon,
            genderField,
            immiInput,
            addressField,
            consulateAddress,
            Trash2Icon,
            datepickerField,
            selectField,
            immiPhone,
            immiMask,
            immiyesorno,
            immiuploader,
            immipriorstay,
            immitextarea,
            immieducations,
            immiswitchyesno,
            casedocumentslist,
            immiemployment,
            PetitionDetails,
            VuePerfectScrollbar,
            petitionsinformation,
            petitionImmigranInfo,
            personalinfo,
            childpersonalinfo,
    
         // 485 Components
         previousSpouseForm ,
         immigrationForm,
        
        
         financialForm,
         assestsForm,
         liabilitiesForm,
         publicBenefitsForm,
         parentForm,
    
    
        },
        watch: {
    
        }
    };
    </script>